<template>
  <div class="temp-container">
    <div class="temp-header flex flex-between">
      <div @click="back" class="btn">
        <span class="hmicon icon-fanhui"></span>
        返回
      </div>
      <div>自定义首页</div>
      <ul class="flex header-list">
        <!-- <li class="btn">
          <span class="hmicon icon-yulan"></span>预览
        </li>-->
        <li class="btn" @click="save">
          <span class="hmicon icon-baocun"></span>保存
        </li>
        <!-- <li class="btn">
          <span class="hmicon icon-fabu"></span>发布
        </li>-->
      </ul>
    </div>
    <div class="flex">
      <!-- 组件容器 -->
      <div class="component-list">
        <div class="title">基础组件</div>
        <draggable
          class="dragArea list-group flex flex-wrap"
          :list="hmComponents"
          :sort="false"
          :group="{ name: 'component', pull: 'clone', put: false }"
          @change="log"
          :clone="cloneEnd"
        >
          <!-- :group="{ name: 'component', pull: 'clone', put: false }" -->
          <template v-for="(v, i) in hmComponents">
            <div class="list-group-item" v-if="v.type === 'base' && v.component !== 'image-ad-selection-plus' " :key="i">
              <span class="hmicon" :class="v.icon"></span>
              <div class="label">{{ v.label }}</div>
            </div>
          </template>
        </draggable>
        <div class="title">营销组件</div>
        <draggable
          class="dragArea list-group flex flex-wrap"
          :list="hmComponents"
          :sort="false"
          :group="{ name: 'component', pull: 'clone', put: false }"
          @change="log"
          :clone="cloneEnd"
        >
          <template v-for="(v, i) in hmComponents">
            <div
              class="list-group-item"
              v-if="v.type === 'marketing'"
              :key="'i' + i"
            >
              <span class="hmicon" :class="v.icon"></span>
              <div class="label">{{ v.label }}</div>
            </div>
          </template>
        </draggable>
      </div>
      <!-- 预览容器 -->
      <div class="preview-container">
        <div
          class="preview-wrapper"
          :style="{
            backgroundColor: pageConfig.bg,
            backgroundImage: 'url(' + pageConfig.bg + ')',
          }"
        >
          <div
            class="preview-head"
            :style="{ backgroundImage: 'url(' + pageConfig.topBgImg + ')' }"
          >
            <div
              class="head-ipt-wrapper"
              v-if="scrollGt100 && pageConfig.isShowSearchBox"
            >
              <input type="text" placeholder="搜索商品" />
            </div>
            <div
              class="preview-title"
              :style="{ color: pageConfig.titleColor }"
              :class="{ bold: pageConfig.titleBold }"
              v-else
            >
              {{ title }}
            </div>
          </div>
          <el-scrollbar ref="scrollbar" style="width: 800px">
            <div class="preview-body">
              <draggable
                class="dragArea preview-list-group"
                :list="previewComponents"
                group="component"
                @change="log"
              >
                <div
                  class="preview-list-group-item"
                  @click="selectPreviewItem(i, v.prop)"
                  :class="{
                    active: activePreviewIndex === i,
                    'contact-us-item': v.component === 'contact-us',
                  }"
                  v-for="(v, i) in previewComponents"
                  :key="i"
                >
                  <component
                    :is="v.component"
                    @add="handleAddZone"
                    :random="Math.random()"
                    :key="'component' + i"
                    @remove="handleRemoveZone"
                    @change="handleChangeZone"
                    ref="singleComponent"
                    :isActive="activePreviewIndex === i"
                    :controls="v.component === 'video'"
                    v-bind="v.prop"
                  ></component>
                  <div class="widget flex">
                    <span class="widget-label">{{ v.label }}</span>
                    <span
                      @click="deleteCurrentComponent(i)"
                      class="widget-icon hmicon icon-shanchu"
                    ></span>
                    <span
                      @click="copyCurrentComponent(i)"
                      class="widget-icon hmicon icon-fuzhi"
                    ></span>
                  </div>
                </div>
              </draggable>
              <div class="preview-height-tag">
                <span class="preview-height-tag-text">iPhone 8手机高度</span>
              </div>
            </div>
          </el-scrollbar>
          <tab-bar :tabBarList="tabBarList"></tab-bar>
        </div>
      </div>
      <!-- 设置项容器 -->
      <div class="options-container">
        <!-- 全局设置 -->
        <div class="page-setting" v-if="showPageSetting">
          <div class="page-header">
            <div class="title">页面设置</div>
            <div class="tips">
              底部栏图标最多显示5个图标，不可少于3个图标，图标风格需保持统一，建议尺寸40x40像素
              <div class="warning">
                页面链接也可输入小程序关联的公众号文章地址
              </div>
            </div>
            <div class="mb20">
              <div class="sub-title bold">页面背景设置</div>
              <div>
                <div class="flex item-center">
                  <div class="label">填充背景</div>
                  <div>
                    <el-radio-group
                      @change="changePageBg"
                      v-model="pageConfig.fillBgType"
                    >
                      <el-radio label="custom">自定义颜色</el-radio>
                      <el-radio label="bgImage">上传背景图</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div style="margin-left: 64px; margin-top: 10px">
                  <el-color-picker
                    @change="changeBgColor"
                    v-if="pageConfig.fillBgType === 'custom'"
                    :predefine="predefine"
                    v-model="pageConfig.bg"
                    size="mini"
                  ></el-color-picker>
                  <div
                    class="icon-wrapper"
                    v-if="pageConfig.fillBgType === 'bgImage'"
                    :class="{ 'no-bg': !pageConfig.bg }"
                    @click="changePageBgImage('bgImage')"
                  >
                    <img
                      :src="pageConfig.bg"
                      class="img"
                      v-if="pageConfig.bg"
                      alt="填充背景"
                    />
                    <div class="change-icon">
                      {{ pageConfig.bg ? "更换背景" : "添加背景" }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="sub-title bold">顶部栏设置</div>
              <div>
                <div class="flex item-center mb20">
                  <span class="mr10">页面标题</span>
                  <el-input
                    class="flex-1"
                    size="small"
                    :maxlength="10"
                    v-model="title"
                    placeholder="页面标题"
                  ></el-input>
                </div>
                <div class="flex item-center flex-between mb20">
                  <span class="mr10">标题颜色</span>
                  <el-color-picker
                    v-model="pageConfig.titleColor"
                    size="mini"
                    :predefine="predefine"
                  ></el-color-picker>
                </div>
                <div class="flex other-setting">
                  <div>
                    <span class="mr20">标题</span>
                    <span class="sub-title temp">{{
                      pageConfig.titleBold ? "加粗体" : "常规体"
                    }}</span>
                  </div>
                  <div class="item-setting flex flex-end flex-1">
                    <el-radio-group v-model="pageConfig.titleBold">
                      <el-radio :label="false">
                        <div
                          class="shape blank flex item-center flex-center"
                          :class="{ active: !pageConfig.titleBold }"
                        >
                          <span class="hmicon icon-wenzi-xi"></span>
                        </div>
                      </el-radio>
                      <el-radio :label="true">
                        <div
                          class="shape line flex item-center flex-center"
                          :class="{ active: pageConfig.titleBold }"
                        >
                          <span class="hmicon icon-wenzi-cu"></span>
                        </div>
                      </el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <!-- <div class="flex item-center mt20 mb20">
                  <div class="label mr20">顶部栏背景</div>
                  <div>
                    <el-radio-group
                      v-model="pageConfig.fixedType"
                    >
                      <el-radio label="custom">显示</el-radio>
                      <el-radio label="noFixed">隐藏</el-radio>
                    </el-radio-group>
                  </div>
                </div> 
                <div class="mb20 mt10" v-if="pageConfig.fixedType==='custom'">
                -->
                <div class="mb20 mt10">
                  <div class="flex item-center">
                    <span class="mr10">顶部栏背景</span>
                    <div class="top-bg-wrapper join-bg pointer flex-1">
                      <img :src="pageConfig.topBgImg" alt="顶部栏背景" />
                      <div class="contorl-wrapper flex flex-around">
                        <el-button type="text" size="small" @click="setTopBgImg"
                          >更换</el-button
                        >
                        <el-button
                          type="text"
                          size="small"
                          @click="resetTopBgImg"
                          >重置</el-button
                        >
                      </div>
                    </div>
                  </div>
                  <div class="tips">
                    建议尺寸750*128（iphoneX及以上机型顶部较高显示会有部分不一致）
                  </div>
                </div>
                <div class="flex item-center flex-between mb20">
                  <span class="mr10">顶部栏搜索框</span>
                  <el-switch
                    :width="30"
                    v-model="pageConfig.isShowSearchBox"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
            </div>
          </div>
          <div class="page-footer">
            <div class="sub-title bold">底部栏设置</div>
            <div class="flex item-center ml20" v-if="pageModel === 'customize'">
              <div>
                <el-radio-group
                  v-model="pageConfig.tabBarSet"
                >
                  <el-radio label="home">与首页一致</el-radio>
                  <el-radio label="customize">自定义</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div v-if="pageConfig.tabBarSet === 'customize'">
            <ul class="tabbar-setting">
              <draggable :list="tabBarList">
                <li
                  class="tabbar-setting-item move"
                  v-for="(v, i) in tabBarList"
                  :key="i"
                >
                  <div
                    class="delete-tab"
                    v-if="v.custom && i >= 4"
                    @click="deleteCurrentTabbar(i)"
                  >
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div class="flex item-center mb10">
                    <div class="mr10">名称</div>
                    <el-input
                      :maxlength="10"
                      v-model="v.hrefName"
                      size="small"
                    ></el-input>
                    <div class="flex-1 flex flex-end">
                      <el-switch
                        :width="30"
                        v-model="v.open"
                        v-if="v.custom || v.hrefName === '购物车'"
                        active-color="#13ce66"
                        :active-value="true"
                        :inactive-value="false"
                      ></el-switch>
                    </div>
                  </div>
                  <div class="mb10">
                    <div class="flex item-center">
                      <div class="mr10">链接</div>
                      <el-select
                        size="small"
                        clearable
                        allow-create
                        placeholder="选择页面"
                        v-model="v.hrefAddress"
                        v-if="!v.groupGoods.groupId"
                        @change="selectTabBarGroup($event, i)"
                        :disabled="!v.custom && v.hrefName !== '购物车'"
                        style="width: 200px"
                        filterable
                      >
                        <el-option
                          v-for="(item, index) in microShopRouteList"
                          :key="index"
                          :label="item.hrefName"
                          :value="item.hrefAddress"
                        ></el-option>
                      </el-select>
                      <div class="flex item-center" v-if="v.groupGoods.groupId">
                        <span>分组：</span>
                        <el-tag
                          closable
                          @close="handleCloseTabBarGroup(i)"
                          type="success"
                          >{{ v.groupGoods.groupName }}</el-tag
                        >
                      </div>
                    </div>
                  </div>
                  <div class="navbar-icon flex">
                    <div class="un-selected flex item-center">
                      <span class="mr10">选中</span>
                      <div
                        class="icon-wrapper"
                        :class="{ 'no-bg': !v.selectedIconpath }"
                        @click="changeIcon(i, 'selectedIconpath')"
                      >
                        <img
                          :src="v.selectedIconpath"
                          v-if="v.selectedIconpath"
                          alt="导航图"
                        />
                        <div class="change-icon">
                          {{ v.selectedIconpath ? "更换图标" : "添加图标" }}
                        </div>
                      </div>
                    </div>
                    <div class="selected flex item-center">
                      <span class="mr10">未选中</span>
                      <div
                        class="icon-wrapper"
                        :class="{ 'no-bg': !v.iconPath }"
                        @click="changeIcon(i, 'iconPath')"
                      >
                        <img :src="v.iconPath" v-if="v.iconPath" alt="导航图" />
                        <div class="change-icon">
                          {{ v.iconPath ? "更换图标" : "添加图标" }}图标
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </draggable>
            </ul>
            <div class="have-bg-wrapper">
              <el-button
                type="primary"
                @click="addTabBarList"
                plain
                :disabled="tabBarList && tabBarList.length >= 5"
                size="small"
                class="w100"
                >添加导航</el-button
              >
            </div>
            </div>
          </div>
        </div>
        <!-- 单个组件设置 -->
        <div class="component-setting" v-if="!showPageSetting">
          <!-- 搜索框设置 -->
          <div
            class="search-setting"
            v-if="currentProp && currentProp.name === 'search'"
          >
            <div class="p20">
              <div class="title">商品搜索</div>
              <div class="tips">
                搜索框默认展示第一个热词，其它逐次热词滚动显示
              </div>
              <div class="flex item-center mt10">
                  搜索模式
              </div>
              <div class="flex item-center mt10">                
                <div>
                  <el-radio-group
                    v-model="currentProp.searchMode"
                  >
                    <el-radio label="keyWord">关键词搜索</el-radio>
                    <el-radio label="keyWordAndAttr">关键词+筛选搜索</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="mt20">
                <div>
                  <span class="mr10">选择模板</span>
                  <span class="sub-title temp"
                    >{{ currentProp.radius ? "圆形" : "方形" }}搜索框</span
                  >
                </div>
                <div class="item-setting">
                  <el-radio-group v-model="currentProp.radius">
                    <el-radio :label="false">
                      <div
                        class="shape square"
                        :class="{ active: !currentProp.radius }"
                      >
                        <div class="content"></div>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape radius"
                        :class="{ active: currentProp.radius }"
                      >
                        <div class="content"></div>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
                <div class="mt20">
                  <span class="mr10">选择热门搜索</span>
                  <span class="sub-title temp"
                    >{{
                      currentProp.version === "Horizontal" ? "横版" : "竖版"
                    }}搜索框</span
                  >
                </div>
                <div class="item-setting">
                  <el-radio-group
                    v-model="currentProp.version"
                    @change="changeVersion"
                  >
                    <el-radio label="Horizontal">
                      <div
                        class="version style1 shape"
                        :class="{ active: currentProp.version == 'Horizontal' }"
                      >
                        <div class="content"></div>
                      </div>
                    </el-radio>
                    <el-radio label="vertical">
                      <div
                        class="version style2 shape"
                        :class="{ active: currentProp.version == 'vertical' }"
                      >
                        <div class="content"></div>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div
              style="padding: 20px; background: #fafafa"
              v-if="currentProp.version === 'vertical'"
            >
              <div
                class="flex flex-between"
                style="padding: 10px; background: #ffffff"
              >
                <span class="mr20">热词背景图片</span>
                <!-- <el-color-picker
                :predefine="predefine"
                v-model="currentProp.backgroundVertical"
                size="mini"
              ></el-color-picker> -->
                <div
                  class="icon-wrapper"
                  :class="{ 'no-bg': !currentProp.versionSrc }"
                >
                  <img
                    :src="currentProp.versionSrc"
                    v-if="currentProp.versionSrc"
                    alt="图片"
                  />
                  <div class="change-icon" @click="changeVersionSrc()">
                    {{ currentProp.versionSrc ? "更换图片" : "添加图片" }}
                  </div>
                  <div class="card-item-delete-img" @click="deleteVersionSrc()">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="have-bg-wrapper">
              <draggable class="card-list" :list="currentProp.hotWordList">
                <div
                  class="card-list-item"
                  v-for="(v, i) in currentProp.hotWordList"
                  :key="i"
                >
                  <el-input
                    max="15"
                    class="w100"
                    @input="setPlaceholder"
                    v-model="v.word"
                    size="small"
                    placeholder="请输入热词"
                  ></el-input>
                  <div
                    class="flex flex-between mt20"
                    v-if="currentProp.version === 'Horizontal'"
                  >
                    <span class="mr20">背景颜色</span>
                    <el-color-picker
                      :predefine="predefine"
                      v-model="v.background"
                      size="mini"
                    ></el-color-picker>
                  </div>
                  <div class="flex flex-between mt20">
                    <span class="mr20">热词图标</span>
                    <div class="icon-wrapper" :class="{ 'no-bg': !v.src }">
                      <img :src="v.src" v-if="v.src" alt="图标" />
                      <div class="change-icon" @click="changeLogoUrlSearch(i)">
                        {{ v.src ? "更换图标" : "添加图标" }}
                      </div>
                      <div
                        class="card-item-delete-img"
                        @click="deleteCardListImg(v)"
                      >
                        <span class="hmicon icon-guanbi1"></span>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-between mt20">
                    <span class="mr20">文本颜色</span>
                    <el-color-picker
                      :predefine="predefine"
                      v-model="v.color"
                      size="mini"
                    ></el-color-picker>
                  </div>
                  <div
                    class="card-item-delete"
                    @click="deleteCardList(i, 'hotWordList')"
                  >
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                </div>
              </draggable>
              <el-button
                type="primary"
                @click="addHotWord()"
                plain
                :disabled="currentProp.hotWordList.length >= 20"
                size="small"
                class="w100"
                >添加热词</el-button
              >
            </div>
            <ul class="other-setting p20">
              <li class="flex item-center">
                <span class="mr20">框体高度</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="28"
                    :max="50"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.height"
                  ></el-slider>
                </div>
              </li>
              <li class="flex flex-between">
                <span class="mr20">背景颜色</span>
                <el-color-picker
                  v-model="currentProp.wrapperBackGround"
                  size="mini"
                  :predefine="predefine"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">框体颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.background"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">文本颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.color"
                  size="mini"
                ></el-color-picker>
              </li>
            </ul>
          </div>
          <!-- 客服设置 -->
          <div
            class="search-setting"
            v-if="currentProp && currentProp.name === 'contact-us'"
          >
            <div class="p20">
              <div class="title">在线咨询</div>
              <el-radio-group v-model="currentProp.type">
                <el-radio label="link">微信客服</el-radio>
                <el-radio label="mobile">电话</el-radio>
                <el-radio label="picture">图片</el-radio>
                <el-radio label="qyWeChat">企微客服</el-radio>
              </el-radio-group>
            </div>
            <div class="have-bg-wrapper">
              <span class="form-item-tip" v-if="currentProp.type === 'link'"
                >请到小程序后台进行客服号绑定</span
              >
              <span class="form-item-tip" v-if="currentProp.type === 'picture'"
                >上传图片建议600x600像素</span
              >
              <el-input
                v-if="currentProp.type === 'mobile'"
                class="w100"
                v-model="currentProp.url"
                size="small"
                min="11"
                max="11"
                placeholder="请输入手机号"
              ></el-input>
              <el-input
                v-if="currentProp.type === 'qyWeChat'"
                class="w100"
                v-model="currentProp.src"
                size="small"
                placeholder="请输入URL"
              ></el-input>
              <el-button
                v-if="currentProp.type === 'picture'"
                type="primary"
                plain
                class="w100"
                size="small"
                @click="setConcatImg"
                >上传图片</el-button
              >
              <div class="mt20">
                <img
                  :src="currentProp.url"
                  alt
                  v-if="currentProp.type === 'picture'"
                />
              </div>
            </div>
          </div>
          <!-- 商品分类 -->
          <div
            class="goods-setting"
            v-if="currentProp && currentProp.name === 'tabs'"
          >
            <div class="p20">
              <div class="title">商品分类</div>
              <div class="tips">添加商品分类，并往分类下添加分组商品</div>
              <div>
                <span class="mr20">选择模板</span>
                <span class="sub-title temp">{{ goodsType }}</span>
              </div>
              <div class="item-setting template-setting flex">
                <el-radio-group
                  class="flex flex-wrap"
                  v-model="currentProp.goodShowType"
                >
                  <el-radio label="big">
                    <div
                      style="height: 60px"
                      class="shape two-column flex"
                      :class="{ active: currentProp.goodShowType === 'big' }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/9d8ee587-635e-4dc4-8aa6-c678a07f25bf.png"
                        alt
                      />
                    </div>
                  </el-radio>
                  <el-radio label="twoColumn">
                    <div
                      style="height: 60px"
                      class="shape three-column flex"
                      :class="{
                        active: currentProp.goodShowType === 'twoColumn',
                      }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/481b7566-8606-4147-817f-d3e27c56c493.png"
                        alt
                      />
                    </div>
                  </el-radio>
                  <el-radio label="threeColumn">
                    <div
                      style="height: 60px"
                      class="shape three-column flex"
                      :class="{
                        active: currentProp.goodShowType === 'threeColumn',
                      }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/69a14a701832cdb47f321eb847d04ef.png"
                        alt="一行3列"
                      />
                    </div>
                  </el-radio>
                  <el-radio label="scroll">
                    <div
                      style="height: 60px"
                      class="shape four-column flex"
                      :class="{ active: currentProp.goodShowType === 'scroll' }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/415fc147-4b32-4c39-b022-ac4e61ba41e4.png"
                        alt
                      />
                    </div>
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
            <draggable class="tabbar-setting" :list="currentProp.tabList">
              <div
                class="tabbar-setting-item"
                v-for="(v, i) in currentProp.tabList"
                :key="i"
              >
                <div class="delete-tab" @click="deleteCurrentTabs(i)">
                  <span class="hmicon icon-guanbi1"></span>
                </div>
                <div>
                  <div class="flex flex-between mb20">
                    <el-input
                      class="flex-1 mr20"
                      size="small"
                      v-model="v.tabTitle"
                      placeholder="请输入分类名称"
                    ></el-input>
                    <el-button
                      size="small"
                      type="primary"
                      @click="addTabsGroupGoods(i)"
                      >添加分组商品</el-button
                    >
                  </div>
                  <div class="flex item-center" v-if="v.groupGoods.groupId">
                    <span>分组：</span>
                    <el-tag
                      closable
                      @close="handleCloseTabsGroup(i)"
                      type="success"
                      >{{ v.groupGoods.groupName }}</el-tag
                    >
                  </div>
                </div>
              </div>
            </draggable>
            <div class="have-bg-wrapper">
              <el-button
                type="primary"
                @click="addTabNav"
                plain
                size="small"
                class="w100"
                >添加分类标题</el-button
              >
            </div>
            <ul class="other-setting p20 border-bottom">
              <li class="tips">注：标题布局仅在标题未超出屏幕时生效</li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">标题布局</span>
                </div>
                <div class="flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.layout">
                    <el-radio label="flex-start">居左</el-radio>
                    <el-radio label="flex-center">居中</el-radio>
                    <el-radio label="flex-between">分散</el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">选中分类</span>
                </div>
                <div class="flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.type">
                    <el-radio label="text">高亮</el-radio>
                    <el-radio label="line">标线</el-radio>
                    <el-radio label="button">按钮</el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">背景颜色</span>
                </div>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.backgroundColor"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">文字颜色</span>
                </div>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.color"
                  size="mini"
                ></el-color-picker>
              </li>
            </ul>
            <!-- <ul class="other-setting p20 border-bottom">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">
                    {{ currentProp.borderRadius ? "直角" : "圆角" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">
                    {{ currentProp.titleBold ? "加粗体" : "常规体" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">页面边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </li>
              <li
                class="flex flex-between item-center"
                v-if="!currentProp.isSwiper"
              >
                <span class="mr20">图片边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.marginBottom"
                  ></el-slider>
                </div>
              </li>
            </ul>
            <ul class="other-setting p20">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品描述</span>
                  <span class="sub-title temp">
                    {{ currentProp.showSubTitle ? "显示" : "隐藏" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showSubTitle"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品价格</span>
                  <span class="sub-title temp">
                    {{ currentProp.showPrice ? "显示" : "隐藏" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showPrice"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品角标</span>
                  <span class="sub-title temp">
                    {{ currentProp.showLogo ? "显示" : "隐藏" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showLogo"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
            </ul>
            <div class="p20">
              <el-radio-group
                v-model="currentProp.logoType"
                v-if="currentProp.showLogo"
              >
                <el-radio label="HOT"></el-radio>
                <el-radio label="NEW"></el-radio>
                <el-radio label="秒杀"></el-radio>
                <el-radio label="自定义"></el-radio>
              </el-radio-group>
              <div v-if="currentProp.logoType === '自定义'"><span class="tips">上传图片建议尺寸120x120像素</span></div>
              <div
                class="icon-wrapper"
                v-if="currentProp.logoType === '自定义'"
                :class="{ 'no-bg': !currentProp.logoUrl }"
                @click="changeLogoUrl()"
              >
                <img
                  :src="currentProp.logoUrl"
                  v-if="currentProp.logoUrl"
                  alt="图片广告"
                />
                <div class="change-icon">
                  {{ currentProp.logoUrl ? "更换图片" : "添加图片" }}
                </div>
              </div>
            </div>-->
          </div>
          <!-- 热销活动 -->
          <div
            class="goods-setting"
            v-if="currentProp && currentProp.name === 'hot'"
          >
            <div class="p20">
              <div class="title">热销活动</div>
              <div class="tips">添加热销活动分类，并往分类下添加分组商品</div>
            </div>

            <!-- <div
                class="icon-wrapper"
                :class="{ 'no-bg': !currentProp.hotImg }"
                style="margin: 0 20px"
                @click="changeHotImageAd()"
            >
              <img :src="currentProp.hotImg" class="img" v-if="currentProp.hotImg" alt="图片广告" />
              <div class="change-icon">
                {{ currentProp.hotImg ? "更换图片" : "添加图片" }}
              </div>
            </div> -->

            <draggable class="tabbar-setting" :list="currentProp.imgList">
              <div
                class="tabbar-setting-item flex"
                v-for="(v, i) in currentProp.imgList"
                :key="i"
              >
                <div class="delete-tab" @click="deleteCurrentImageAd2(i)">
                  <span class="hmicon icon-guanbi1"></span>
                </div>
                <div
                  class="icon-wrapper"
                  :class="{ 'no-bg': !v.src }"
                  @click="changeImageAd(i)"
                >
                  <img :src="v.src" class="img" v-if="v.src" alt="图片广告" />
                  <div class="change-icon">
                    {{ v.src ? "更换图片" : "添加图片" }}
                  </div>
                </div>
                <div class="flex-1">
                  <div class="flex item-center mb10">
                    <span class="mr10">标题</span>
                    <el-input
                      class="flex-1"
                      v-model="v.text"
                      size="small"
                      maxlength="10"
                      placeholder="建议10个字以内，可不填"
                    ></el-input>
                  </div>
                  <div class="flex item-center" style="padding: 10px 0">
                    <span class="mr10">类型</span>
                    <el-radio-group
                      v-model="v.pageType"
                      class="flex-1"
                      @change="openGoodsSelect(v, i, 'imgList')"
                    >
                      <el-radio label="page">页面</el-radio>
                      <el-radio label="goods">商品</el-radio>
                      <el-radio label="brand">品牌</el-radio>
                      <el-radio label="mp">小程序</el-radio>
                      <el-radio label="channels">视频号</el-radio>
                      <el-radio label="live">直播间</el-radio>
                      <el-radio label="activityCenter">营销活动</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="flex item-center" v-if="v.pageType === 'page'">
                    <span class="mr10">链接</span>
                    <el-select
                      class="flex-1"
                      size="small"
                      clearable
                      placeholder="选择页面"
                      v-if="!v.groupGoods.groupId"
                      v-model="v.hrefAddress"
                      @change="selectGroup($event, i, 'imgList')"
                      allow-create
                      filterable
                    >
                      <el-option
                        v-for="(item, index) in microShopRouteList"
                        :key="index"
                        :label="item.hrefName"
                        :value="item.hrefAddress"
                      ></el-option>
                    </el-select>
                    <div class="flex item-center" v-if="v.groupGoods.groupId">
                      <span>分组：</span>
                      <el-tag
                        closable
                        @close="handleCloseGroup('imgList', i)"
                        type="success"
                        >{{ v.groupGoods.groupName }}</el-tag
                      >
                    </div>
                  </div>
                  <div
                    class="flex item-center"
                    v-if="v.pageType === 'goods' && v.goodsInfo.wxshopSpuName"
                  >
                    <span class="mr10">商品</span>
                    <el-tag
                      closable
                      @close="handleClose(v, i)"
                      type="success"
                      >{{ v.goodsInfo.wxshopSpuName }}</el-tag
                    >
                  </div>
                  <div
                    class="flex item-center"
                    v-if="
                      v.pageType === 'brand' &&
                      v.brandInfo &&
                      v.brandInfo.brandName
                    "
                  >
                    <span class="mr10">品牌</span>
                    <el-tag
                      closable
                      @close="handleClose(v, i)"
                      type="success"
                      >{{ v.brandInfo.brandName }}</el-tag
                    >
                  </div>
                  <template v-if="v.pageType === 'mp'">
                    <div class="flex item-center mb20">
                      <span class="mr10">appid</span>
                      <el-input
                        class="flex-1"
                        size="small"
                        v-model="v.appid"
                        type="text"
                        placeholder="请输入appid"
                      ></el-input>
                    </div>
                    <div class="flex item-center">
                      <span style="width: 34px" class="mr10">链接</span>
                      <el-input
                        class="flex-1"
                        v-model="v.hrefAddress"
                        size="small"
                        type="text"
                        placeholder="请输入链接"
                      ></el-input>
                    </div>
                  </template>
                  <template v-if="v.pageType === 'channels'">
                    <div class="flex item-center mb10">
                      <span class="mr10">视频号主页ID</span>
                    </div>
                    <div class="flex item-center mb20">
                      <el-input
                        class="flex-1"
                        size="small"
                        v-model="v.profile"
                        type="text"
                        placeholder="请输入主页ID"
                      ></el-input>
                    </div>
                    <div class="flex item-center mb10">
                      <span class="mr10">视频号视频ID</span>
                    </div>
                    <div class="flex item-center mb20">
                      <el-input
                        class="flex-1"
                        v-model="v.activity"
                        size="small"
                        type="text"
                        placeholder="请输入视频ID"
                      ></el-input>
                    </div>
                  </template>
                  <template v-if="v.pageType === 'live'">
                    <!-- <div class="flex item-center mb10">
                      <span class="mr10">直播间ID</span>
                    </div>
                    <div class="flex item-center mb20">
                      <el-input
                        class="flex-1"
                        size="small"
                        v-model="v.roomId"
                        type="text"
                        placeholder="请输入直播间ID"
                      ></el-input>
                    </div> -->
                    <div class="flex item-center mb10" 
                      v-if="v.liveList.length>0">
                      <span class="mr10">直播间</span>
                    </div>
                    <el-tag
                      closable
                      @close="handleClose(v, i)"
                      type="success"
                      v-if="v.liveList.length>0"
                      >{{ v.liveList[0].roomName }}</el-tag
                    >
                  </template>
                  <template v-if="v.pageType === 'activityCenter'">
                    <div class="flex item-center mb10" 
                      v-if="v.activityInfo.gameId">
                      <span class="mr10">营销活动</span>
                    </div>
                    <el-tag
                      closable
                      @close="handleClose(v, i)"
                      type="success"
                      v-if="v.activityInfo.gameId"
                      >{{ v.activityInfo.gameName }}</el-tag
                    >
                  </template>
                </div>
              </div>
            </draggable>
            <div class="have-bg-wrapper">
              <el-button
                :disabled="
                  currentProp.imgList && currentProp.imgList.length >= 10
                "
                type="primary"
                plain
                size="small"
                class="w100"
                @click="addImageAd2"
                >添加背景图</el-button
              >
            </div>

            <draggable class="tabbar-setting" :list="currentProp.hotList">
              <div
                class="tabbar-setting-item"
                v-for="(v, i) in currentProp.hotList"
                :key="i"
              >
                <div class="delete-tab" @click="deleteCurrentHot(i)">
                  <span class="hmicon icon-guanbi1"></span>
                </div>
                <div>
                  <div class="flex flex-between mb20">
                    <el-input
                      class="flex-1 mr20"
                      size="small"
                      v-model="v.hotTitle"
                      placeholder="请输入分类名称"
                    ></el-input>
                    <el-button
                      size="small"
                      type="primary"
                      @click="addHotGroupGoods(i)"
                      >添加分组商品</el-button
                    >
                  </div>
                  <div class="flex item-center mb20">
                    <span>副标题：</span>
                    <el-input
                      class="flex-1 mr20"
                      size="small"
                      v-model="v.hotAssistantTitle"
                      placeholder="请输入副分类名称"
                    ></el-input>
                  </div>
                  <div class="flex item-center mb20">
                    <span>分组水印：</span>
                    <div
                      class="icon-wrapper"
                      :class="{ 'no-bg': !v.watermark }"
                    >
                      <img
                        :src="v.watermark"
                        v-if="v.watermark"
                        alt="图片"
                      />
                      <div class="change-icon" @click="changeWatermark(i)">
                        <span class='red' v-if="v.watermark">更换水印</span>
                        <span class='white' v-else>添加水印</span>
                      </div>
                      <div class="card-item-delete-img" @click="deleteWatermark(v)">
                        <span class="hmicon icon-guanbi1"></span>
                      </div>
                    </div>
                    <span>水印尺寸建议750*750,<br>请上传png格式</span>
                  </div>
                  <div
                    class="flex item-center flex-wrap"
                    v-if="v.groupGoods.length > 0"
                  >
                    <span>分组：</span>
                    <el-tag
                      style="margin-bottom: 5px"
                      closable
                      @close="handleCloseHotGroup(i, goodsIndex)"
                      type="success"
                      v-for="(goodsItem, goodsIndex) in v.groupGoods"
                      :key="goodsIndex"
                    >
                      <span v-if="goodsItem.gameName">{{
                        goodsItem.gameName
                      }}</span>
                    </el-tag>
                  </div>
                  <div class="flex item-center" v-if="v.groupGoods.groupId">
                    <span>分组：</span>
                    <el-tag
                      closable
                      @close="handleCloseTabsGroup2(i)"
                      type="success"
                      >{{ v.groupGoods.groupName }}</el-tag
                    >
                  </div>
                </div>
              </div>
            </draggable>
            <div class="have-bg-wrapper">
              <el-button
                type="primary"
                @click="addHotNav"
                plain
                size="small"
                class="w100"
                >添加分类标题</el-button
              >
            </div>
            <ul class="other-setting p20 border-bottom">
              <li class="tips">注：标题布局仅在标题未超出屏幕时生效</li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">标题布局</span>
                </div>
                <div class="flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.layout">
                    <el-radio label="flex-start">居左</el-radio>
                    <el-radio label="flex-around">居中</el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">选中分类</span>
                </div>
                <div class="flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.type">
                    <el-radio label="text">高亮</el-radio>
                    <el-radio label="underline">标线</el-radio>
                    <el-radio label="button">按钮</el-radio>
                  </el-radio-group>
                </div>
              </li>
            </ul>
          </div>
          <!-- 视频设置 -->
          <div
            class="video-setting"
            v-if="currentProp && currentProp.name === 'video'"
          >
            <div class="p20">
              <div class="title">视频</div>
              <span class="tips"
                >系统视频仅支持mp4格式的视频,添加成功后会自动播放；腾讯视频需要添加腾讯视频视频id</span
              >
            </div>
            <div class="p20">
              <el-radio-group
                v-model="currentProp.type"
                @change="changeVideoType"
              >
                <el-radio label="origin">系统视频</el-radio>
                <el-radio label="txv">腾讯视频</el-radio>
                <el-radio label="local" v-if="showUploadLocalVideo"
                  >本地视频</el-radio
                >
              </el-radio-group>
            </div>
            <div class="link-wrapper" v-if="currentProp.type === 'txv'">
              <a
                style="color: #2d8cf0"
                href="https://www.yuque.com/docs/share/ebc783de-b8fb-46f6-8f32-0c0ad19705d8?#"
                target="_blank"
                >如何获取腾讯视频id?</a
              >
            </div>
            <div class="have-bg-wrapper">
              <div
                class="flex flex-center mb20"
                v-if="currentProp.type === 'local'"
              >
                <el-button
                  class="flex-1 mb20"
                  type="primary"
                  size="small"
                  @click="upLoadVideo"
                  >上传视频</el-button
                >
              </div>
              <el-input
                v-model="currentProp.src"
                class="w100"
                :placeholder="
                  currentProp.type === 'txv'
                    ? '粘贴腾讯视频视频id'
                    : '粘贴mp4视频地址'
                "
                size="small"
              ></el-input>
            </div>
          </div>
          <!-- 辅助分割 -->
          <div
            class="deiding-line-setting"
            v-if="currentProp && currentProp.name === 'dividing-line'"
          >
            <div class="page-header">
              <div class="title">辅助分割</div>
              <span class="tips"
                >可以选择辅助空白或者辅助线，辅助空白颜色不可调整，辅助线高度不可调整</span
              >
            </div>
            <ul class="other-setting p20">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">分割类型</span>
                  <span class="sub-title temp">{{
                    currentProp.line ? "辅助线" : "辅助空白"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.line">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.line }"
                      >
                        <span class="hmicon icon-fengexian-mian"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.line }"
                      >
                        <span class="hmicon icon-fengexian-xian"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex item-center" v-if="!currentProp.line">
                <span class="mr20">空白高度</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="10"
                    :max="100"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.blankHeight"
                  ></el-slider>
                </div>
              </li>
              <li class="flex flex-between" v-else>
                <span class="mr20">辅助线颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.borderColor"
                  size="mini"
                ></el-color-picker>
              </li>
            </ul>
          </div>
          <!-- 公告 -->
          <div
            class="notice-setting"
            v-if="currentProp && currentProp.name === 'notice'"
          >
            <div class="page-header">
              <div class="mb20">
                <div class="title">公告</div>
                <span class="tips"
                  >请填写内容，如果内容过长，将会在手机上滚动显示</span
                >
              </div>
              <div class="flex">
                <span class="sub-title mr10">公告</span>
                <el-input
                  class="flex-1"
                  size="small"
                  type="textarea"
                  v-model="currentProp.text"
                ></el-input>
              </div>
            </div>
            <ul class="other-setting p20">
              <li class="flex flex-between">
                <span class="mr20">文字颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.color"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">背景颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.backgroundColor"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span>底部浮动</span>
                <el-switch
                  v-model="currentProp.fixedBottom"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </li>
              <li class="flex flex-between">
                <span>点击按钮</span>
                <el-switch
                  v-model="currentProp.isShowClickButton"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </li>
              <li class="flex flex-between item-center" v-if="currentProp.isShowClickButton">
                <span class="mr10">按钮文字</span>
                <el-input
                  class="flex-1"
                  type="text"
                  size="small"
                  placeholder="请输入标题,最多4个字"
                  v-model="currentProp.clickButtonTitle"
                  maxlength="4"
                ></el-input>
              </li>
              <li class="flex flex-between item-center" v-if="currentProp.isShowClickButton">
                <span class="mr10">链接</span>
                <el-select
                  class="flex-1"
                  size="small"
                  clearable                 
                  placeholder="选择页面"
                  v-model="currentProp.hrefAddress"
                  @change="selectGroup"
                  allow-create
                  filterable
                >
                  <el-option
                    v-for="(item, i) in microShopRouteList"
                    :key="i"
                    :label="item.hrefName"
                    :value="item.hrefAddress"
                  ></el-option>
                </el-select>
              </li>
              <li class="flex flex-between">
                <span>能否关闭</span>
                <el-switch
                  v-model="currentProp.isShowCloseButton"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </li>
              <li class="flex flex-between">
                <span>是否滚动</span>
                <el-switch
                  v-model="currentProp.scrollable"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </li>
              <li class="flex flex-between">
                <span>公告是否居中</span>
                <el-switch
                  v-model="currentProp.textCenter"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">内容字号</span>
                  <span class="sub-title temp">{{
                    currentProp.titleBold ? "加大" : "普通"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
            </ul>
          </div>
          <!-- 富文本编辑器 -->
          <div
            class="rich-text-setting"
            v-if="currentProp && currentProp.name === 'rich-text'"
          >
            <div class="p20">
              <div class="title">富文本</div>
              <div class="tips">
                点击下方编辑富文本，你可以对文字进行
                <b>加粗</b>、 <i>斜体</i>、 <u>下划线</u>、 <s>删除线</s>、文字
                <span style="color: #e2005d">颜色</span>、
                <span style="background: #e2005d; color: #fff">背景色</span
                >，以及 <span class="title">字号大小</span>进行简单排版
              </div>
            </div>
            <div class="have-bg-wrapper">
              <hm-rich-editor v-model="currentProp.content" />
            </div>
          </div>
          <!-- 标题文本设置 -->
          <div
            class="title-text-setting"
            v-if="currentProp && currentProp.name === 'title-text'"
          >
            <div class="page-header">
              <div class="title">标题文本</div>
              <div class="tips">
                <div class="warning">
                  页面链接也可输入小程序关联的公众号文章地址
                </div>
              </div>
              <div class="flex item-center mb20">
                <span class="mr10">标题内容</span>
                <el-input
                  class="flex-1"
                  type="text"
                  size="small"
                  placeholder="请输入标题"
                  v-model="currentProp.title"
                ></el-input>
              </div>
              <div class="flex item-center">
                <span class="mr10">描述内容</span>
                <el-input
                  class="flex-1"
                  type="textarea"
                  maxlength="100"
                  size="small"
                  placeholder="请输入描述,最多100字"
                  v-model="currentProp.subTitle"
                ></el-input>
              </div>
            </div>
            <ul class="other-setting">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">{{
                    currentProp.titleBold ? "加粗体" : "常规体"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">描述粗细</span>
                  <span class="sub-title temp">{{
                    currentProp.subTitleBold ? "加粗体" : "常规体"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.subTitleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.subTitleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.subTitleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between">
                <span class="mr20">标题颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.titleColor"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">描述颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.subTitleColor"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">背景颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.backgroundColor"
                  size="mini"
                ></el-color-picker>
              </li>
            </ul>
            <div class="p20">
              <div class="flex flex-between mb20">
                <div>
                  <span>复制</span>
                  <span class="tips">（复制标题到剪贴板）</span>
                </div>

                <el-switch
                  v-model="currentProp.isShowCopyBtn"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
              <div class="flex flex-between mb20">
                <span>查看更多</span>
                <el-switch
                  v-model="currentProp.isShowMore"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
              <div class="flex item-center" style="padding: 10px 0">
                <span class="mr10">链接类型</span>
                <el-radio-group
                  style="border: none"
                  class="flex-1"
                  v-model="currentProp.pageType"
                  @change="openGoodsSelectSingle"
                >
                  <el-radio label="page" style="marginright: 20px"
                    >页面</el-radio
                  >
                  <el-radio label="goods" style="marginright: 20px"
                    >商品</el-radio
                  >
                  <el-radio label="brand" style="marginright: 20px"
                    >品牌</el-radio
                  >
                  <el-radio label="mp">小程序</el-radio>
                  <el-radio label="channels">视频号</el-radio>
                  <el-radio label="live">直播间</el-radio>
                  <el-radio label="activityCenter">营销活动</el-radio>
                </el-radio-group>
              </div>
              <div
                class="flex item-center"
                v-if="currentProp.pageType === 'page'"
              >
                <span class="mr10">链接</span>
                <el-select
                  class="flex-1"
                  size="small"
                  clearable
                  v-if="!currentProp.groupGoods.groupId"
                  placeholder="选择页面"
                  v-model="currentProp.hrefAddress"
                  @change="selectGroup"
                  allow-create
                  filterable
                >
                  <el-option
                    v-for="(item, i) in microShopRouteList"
                    :key="i"
                    :label="item.hrefName"
                    :value="item.hrefAddress"
                  ></el-option>
                </el-select>
                <div
                  class="flex item-center"
                  v-if="currentProp.groupGoods.groupId"
                >
                  <span>分组：</span>
                  <el-tag closable @close="handleCloseGroup" type="success">{{
                    currentProp.groupGoods.groupName
                  }}</el-tag>
                </div>
              </div>
              <div
                class="flex item-center"
                v-if="
                  currentProp.pageType === 'goods' &&
                  currentProp.goodsInfo &&
                  currentProp.goodsInfo.wxshopSpuName
                "
              >
                <span class="mr10">商品</span>
                <el-tag closable @close="handleCloseSingle" type="success">{{
                  currentProp.goodsInfo.wxshopSpuName
                }}</el-tag>
              </div>
              <div
                class="flex item-center"
                v-if="
                  currentProp.pageType === 'brand' &&
                  currentProp.brandInfo &&
                  currentProp.brandInfo.brandName
                "
              >
                <span class="mr10">品牌</span>
                <el-tag closable @close="handleCloseSingle" type="success">{{
                  currentProp.brandInfo.brandName
                }}</el-tag>
              </div>
              <template v-if="currentProp.pageType === 'mp'">
                <div class="flex item-center mb20">
                  <span class="mr10">appid</span>
                  <el-input
                    class="flex-1"
                    size="small"
                    v-model="currentProp.appid"
                    type="text"
                    placeholder="请输入appid"
                  ></el-input>
                </div>
                <div class="flex item-center">
                  <span style="width: 34px" class="mr10">链接</span>
                  <el-input
                    class="flex-1"
                    v-model="currentProp.hrefAddress"
                    size="small"
                    type="text"
                    placeholder="请输入链接"
                  ></el-input>
                </div>
              </template>
              <template v-if="currentProp.pageType === 'channels'">
                <div class="flex item-center mb10">
                  <span class="mr10">视频号主页ID</span>
                </div>
                <div class="flex item-center mb20">
                  <el-input
                    class="flex-1"
                    size="small"
                    v-model="currentProp.profile"
                    type="text"
                    placeholder="请输入主页ID"
                  ></el-input>
                </div>
                <div class="flex item-center mb10">
                  <span class="mr10">视频号视频ID</span>
                </div>
                <div class="flex item-center mb20">
                  <el-input
                    class="flex-1"
                    v-model="currentProp.activity"
                    size="small"
                    type="text"
                    placeholder="请输入视频ID"
                  ></el-input>
                </div>
              </template>
              <template v-if="currentProp.pageType === 'live'">
                <div class="flex item-center mb10" 
                  v-if="currentProp.liveList.length>0">
                  <span class="mr10">直播间</span>
                </div>
                <el-tag
                  closable
                  @close="handleClose(currentProp, 0)"
                  type="success"
                  v-if="currentProp.liveList.length>0"
                  >{{ currentProp.liveList[0].roomName }}</el-tag
                >
              </template>
              <template v-if="currentProp.pageType === 'activityCenter'">
                <div class="flex item-center mb10" 
                  v-if="currentProp.activityInfo.gameId">
                  <span class="mr10">营销活动</span>
                </div>
                <el-tag
                  closable
                  @close="handleClose(currentProp, 0)"
                  type="success"
                  v-if="currentProp.activityInfo.gameId"
                  >{{ currentProp.activityInfo.gameName }}</el-tag
                >
              </template>
            </div>
          </div>
          <!-- 图片广告 -->
          <div
            class="image-ad-setting"
            v-if="currentProp && currentProp.name === 'image-ad-selection'"
          >
            <div class="p20">
              <div class="title">图片广告</div>
              <div class="tips">
                最多添加10个广告，鼠标拖拽调整广告顺序，建议尺寸1500*720像素
                <div class="warning">
                  页面链接也可输入小程序关联的公众号文章地址
                </div>
              </div>
              <div class="item-setting">
                <div>
                  选择模板
                  <span v-if="currentProp.type === '1'">轮播海报</span>
                  <span v-if="currentProp.type === '2'">一行一张</span>
                  <span v-if="currentProp.type === '3'">两列轮播</span>
                  <span v-if="currentProp.type === '4'">背景轮播</span>
                  <span v-if="currentProp.type === '5'">左一右二轮播</span>
                </div>
                <el-radio-group
                  v-model="currentProp.type"                  
                  @change="switchImageAdTemp(currentProp.type)"
                >
                  <div class="flex">
                  <el-radio label="1">
                    <div
                      class="shape no-swiper"
                      :class="{ active: currentProp.type === '1' }"
                    >
                      <div class="content"></div>
                    </div>
                  </el-radio>
                  <el-radio label="2">
                    <div
                      class="shape swiper"
                      :class="{ active: currentProp.type === '2' }"
                    >
                      <div class="content"></div>
                    </div>
                  </el-radio>
                  <el-radio label="3">
                    <div
                      class="shape double-swiper flex flex-between"
                      :class="{ active: currentProp.type === '3' }"
                    >
                      <div class="content flex"></div>
                      <div class="content flex"></div>
                    </div>
                  </el-radio>
                  </div>
                  <div class="flex">
                  <el-radio label="4">
                    <div
                      class="shape no-swiper"
                      :class="{ active: currentProp.type === '4' }"
                    >
                      <div class="content"></div>
                    </div>
                  </el-radio>
                  <el-radio label="5">
                    <div
                      class="shape double-swiper2 flex flex-between"
                      :class="{ active: currentProp.type === '5' }"
                    >
                      <div class="content"></div>
                      <div class="shape double-swiper3">
                        <div class="content"></div>
                        <div class="content"></div>
                      </div>
                    </div>
                  </el-radio>
                  </div>
                </el-radio-group>
              </div>
            </div>
            <div class="have-bg-wrapper">
              <div
                class="item-setting image-ad-selection-upload"
                v-if="currentProp.type === '3'"
              >
                <el-radio-group v-model="imgAdSelectionUpLoadType" class="flex">
                  <el-radio label="leftImgList" style="margin: 0">
                    <div
                      class="context flex item-center flex-center"
                      :class="{
                        active: imgAdSelectionUpLoadType === 'leftImgList',
                      }"
                    >
                      <div>宽度375像素</div>
                      <div
                        class="dot flex"
                        :class="{
                          active: imgAdSelectionUpLoadType === 'leftImgList',
                        }"
                      >
                        <div class="point first"></div>
                        <div class="point"></div>
                        <div class="point"></div>
                      </div>
                    </div>
                  </el-radio>
                  <el-radio label="rightImgList" style="margin: 0">
                    <div
                      class="context flex item-center flex-center"
                      :class="{
                        active: imgAdSelectionUpLoadType === 'rightImgList',
                      }"
                    >
                      <div>宽度375像素</div>
                      <div
                        class="dot flex"
                        :class="{
                          active: imgAdSelectionUpLoadType === 'rightImgList',
                        }"
                      >
                        <div class="point first"></div>
                        <div class="point"></div>
                        <div class="point"></div>
                      </div>
                    </div>
                  </el-radio>
                </el-radio-group>
              </div>
              <div
                class="item-setting image-ad-selection-upload"
                v-if="currentProp.type === '5'"
              >
                <el-radio-group v-model="imgAdSelectionUpLoadType">
                  <el-radio label="leftImgList" style="margin: 0; float:left;">
                    <div
                      class="context context2 flex item-center flex-center"
                      :class="{
                        active: imgAdSelectionUpLoadType === 'leftImgList',
                      }"
                    >
                      <div>宽度375像素</div>
                      <div
                        class="dot flex"
                        :class="{
                          active: imgAdSelectionUpLoadType === 'leftImgList',
                        }"
                      >
                        <div class="point first"></div>
                        <div class="point"></div>
                        <div class="point"></div>
                      </div>
                    </div>
                  </el-radio>
                  <el-radio label="rightImgList" style="margin: 0">
                    <div
                      class="context context3 flex item-center flex-center"
                      :class="{
                        active: imgAdSelectionUpLoadType === 'rightImgList',
                      }"
                    >
                      <div>宽度375像素</div>
                      <div
                        class="dot flex"
                        :class="{
                          active: imgAdSelectionUpLoadType === 'rightImgList',
                        }"
                      >
                        <div class="point first"></div>
                        <div class="point"></div>
                        <div class="point"></div>
                      </div>
                    </div>
                  </el-radio>
                  <el-radio label="rightImgList2" style="margin: 0">                    
                    <div
                      class="context context3 flex item-center flex-center"
                      :class="{
                        active: imgAdSelectionUpLoadType === 'rightImgList2',
                      }"
                    >
                      <div>宽度375像素</div>
                      <div
                        class="dot flex"
                        :class="{
                          active: imgAdSelectionUpLoadType === 'rightImgList2',
                        }"
                      >
                        <div class="point first"></div>
                        <div class="point"></div>
                        <div class="point"></div>
                      </div>
                    </div>
                  </el-radio>
                  
                </el-radio-group>
              </div>
              <draggable
                class="tabbar-setting"
                :list="currentProp.imgList"
                v-if="currentProp.type !== '3' && currentProp.type !== '5'"
              >
                <div
                  class="tabbar-setting-item flex"
                  v-for="(v, i) in currentProp.imgList"
                  :key="i"
                >
                  <div class="delete-tab" @click="deleteCurrentImageAd(i)">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div>
                    <div
                      class="icon-wrapper"
                      :class="{ 'no-bg': !v.src }"
                      @click="changeImageAd(i)"
                    >
                      <img :src="v.src" class="img" v-if="v.src" alt="图片广告" />
                      <div class="change-icon">
                        {{ v.src ? "更换图片" : "添加图片" }}
                      </div>
                    </div>
                    <div
                      class="icon-wrapper mt10"
                      :class="{ 'no-bg': !v.bgsrc }"
                      @click="changeImageAdBg(i)"
                      v-if="currentProp.type === '4'"
                    >
                      <img :src="v.bgsrc" class="img" v-if="v.bgsrc" alt="背景图片" />
                      <div class="change-icon">
                        {{ v.bgsrc ? "更换背景" : "添加背景" }}
                      </div>
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="flex item-center mb10">
                      <span class="mr10">标题</span>
                      <el-input
                        class="flex-1"
                        v-model="v.text"
                        size="small"
                        maxlength="10"
                        placeholder="建议10个字以内，可不填"
                      ></el-input>
                    </div>
                    <div class="flex item-center" style="padding: 10px 0">
                      <span class="mr10">类型</span>
                      <el-radio-group
                        v-model="v.pageType"
                        class="flex-1"
                        @change="openGoodsSelect(v, i, 'imgList')"
                      >
                        <el-radio label="page">页面</el-radio>
                        <el-radio label="goods">商品</el-radio>
                        <el-radio label="brand">品牌</el-radio>
                        <el-radio label="mp">小程序</el-radio>
                        <el-radio label="channels">视频号</el-radio>
                        <el-radio label="live">直播间</el-radio>
                        <el-radio label="activityCenter">营销活动</el-radio>
                      </el-radio-group>
                    </div>
                    <div class="flex item-center" v-if="v.pageType === 'page'">
                      <span class="mr10">链接</span>
                      <el-select
                        class="flex-1"
                        size="small"
                        clearable
                        placeholder="选择页面"
                        v-if="!v.groupGoods.groupId"
                        v-model="v.hrefAddress"
                        @change="selectGroup($event, i, 'imgList')"
                        allow-create
                        filterable
                      >
                        <el-option
                          v-for="(item, index) in microShopRouteList"
                          :key="index"
                          :label="item.hrefName"
                          :value="item.hrefAddress"
                        ></el-option>
                      </el-select>
                      <div class="flex item-center" v-if="v.groupGoods.groupId">
                        <span>分组：</span>
                        <el-tag
                          closable
                          @close="handleCloseGroup('imgList', i)"
                          type="success"
                          >{{ v.groupGoods.groupName }}</el-tag
                        >
                      </div>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="v.pageType === 'goods' && v.goodsInfo.wxshopSpuName"
                    >
                      <span class="mr10">商品</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.goodsInfo.wxshopSpuName }}</el-tag
                      >
                    </div>
                    <div
                      class="flex item-center"
                      v-if="
                        v.pageType === 'brand' &&
                        v.brandInfo &&
                        v.brandInfo.brandName
                      "
                    >
                      <span class="mr10">品牌</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.brandInfo.brandName }}</el-tag
                      >
                    </div>
                    <template v-if="v.pageType === 'mp'">
                      <div class="flex item-center mb20">
                        <span class="mr10">appid</span>
                        <el-input
                          class="flex-1"
                          size="small"
                          v-model="v.appid"
                          type="text"
                          placeholder="请输入appid"
                        ></el-input>
                      </div>
                      <div class="flex item-center">
                        <span style="width: 34px" class="mr10">链接</span>
                        <el-input
                          class="flex-1"
                          v-model="v.hrefAddress"
                          size="small"
                          type="text"
                          placeholder="请输入链接"
                        ></el-input>
                      </div>
                    </template>
                    <template v-if="v.pageType === 'channels'">
                      <div class="flex item-center mb10">
                        <span class="mr10">视频号主页ID</span>
                      </div>
                      <div class="flex item-center mb20">
                        <el-input
                          class="flex-1"
                          size="small"
                          v-model="v.profile"
                          type="text"
                          placeholder="请输入主页ID"
                        ></el-input>
                      </div>
                      <div class="flex item-center mb10">
                        <span class="mr10">视频号视频ID</span>
                      </div>
                      <div class="flex item-center mb20">
                        <el-input
                          class="flex-1"
                          v-model="v.activity"
                          size="small"
                          type="text"
                          placeholder="请输入视频ID"
                        ></el-input>
                      </div>
                    </template>
                    <template v-if="v.pageType === 'live'">
                      <div class="flex item-center mb10" 
                        v-if="v.liveList.length>0">
                        <span class="mr10">直播间</span>
                      </div>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        v-if="v.liveList.length>0"
                        >{{ v.liveList[0].roomName }}</el-tag
                      >
                    </template>
                    <template v-if="v.pageType === 'activityCenter'">
                      <div class="flex item-center mb10" 
                        v-if="v.activityInfo.gameId">
                        <span class="mr10">营销活动</span>
                      </div>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        v-if="v.activityInfo.gameId"
                        >{{ v.activityInfo.gameName }}</el-tag
                      >
                    </template>
                  </div>
                </div>
              </draggable>
              <draggable
                class="tabbar-setting"
                :list="currentProp.leftImgList"
                v-if="
                  (currentProp.type === '3' || currentProp.type === '5') &&
                  imgAdSelectionUpLoadType === 'leftImgList'
                "
              >
                <div
                  class="tabbar-setting-item flex"
                  v-for="(v, i) in currentProp.leftImgList"
                  :key="i"
                >
                  <div class="delete-tab" @click="deleteCurrentImageAd(i)">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div
                    class="icon-wrapper"
                    :class="{ 'no-bg': !v.src }"
                    @click="changeImageAd(i)"
                  >
                    <img :src="v.src" class="img" v-if="v.src" alt="图片广告" />
                    <div class="change-icon">
                      {{ v.src ? "更换图片" : "添加图片" }}
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="flex item-center mb10">
                      <span class="mr10">标题</span>
                      <el-input
                        class="flex-1"
                        v-model="v.text"
                        size="small"
                        maxlength="10"
                        placeholder="建议10个字以内，可不填"
                      ></el-input>
                    </div>
                    <div class="flex item-center" style="padding: 10px 0">
                      <span class="mr10">类型</span>
                      <el-radio-group
                        v-model="v.pageType"
                        class="flex-1"
                        @change="openGoodsSelect(v, i, 'leftImgList')"
                      >
                        <el-radio label="page">页面</el-radio>
                        <el-radio label="goods">商品</el-radio>
                        <el-radio label="brand">品牌</el-radio>
                        <el-radio label="mp">小程序</el-radio>
                        <el-radio label="channels">视频号</el-radio>
                        <el-radio label="live">直播间</el-radio>
                        <el-radio label="activityCenter">营销活动</el-radio>
                      </el-radio-group>
                    </div>
                    <div class="flex item-center" v-if="v.pageType === 'page'">
                      <span class="mr10">链接</span>
                      <el-select
                        class="flex-1"
                        size="small"
                        clearable
                        placeholder="选择页面"
                        v-if="!v.groupGoods.groupId"
                        v-model="v.hrefAddress"
                        @change="selectGroup($event, i, 'leftImgList')"
                        allow-create
                        filterable
                      >
                        <el-option
                          v-for="(item, index) in microShopRouteList"
                          :key="index"
                          :label="item.hrefName"
                          :value="item.hrefAddress"
                        ></el-option>
                      </el-select>
                      <div class="flex item-center" v-if="v.groupGoods.groupId">
                        <span>分组：</span>
                        <el-tag
                          closable
                          @close="handleCloseGroup('leftImgList', i)"
                          type="success"
                          >{{ v.groupGoods.groupName }}</el-tag
                        >
                      </div>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="v.pageType === 'goods' && v.goodsInfo.wxshopSpuName"
                    >
                      <span class="mr10">商品</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.goodsInfo.wxshopSpuName }}</el-tag
                      >
                    </div>
                    <div
                      class="flex item-center"
                      v-if="
                        v.pageType === 'brand' &&
                        v.brandInfo &&
                        v.brandInfo.brandName
                      "
                    >
                      <span class="mr10">品牌</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.brandInfo.brandName }}</el-tag
                      >
                    </div>
                    <template v-if="v.pageType === 'mp'">
                      <div class="flex item-center mb20">
                        <span class="mr10">appid</span>
                        <el-input
                          class="flex-1"
                          size="small"
                          v-model="v.appid"
                          type="text"
                          placeholder="请输入appid"
                        ></el-input>
                      </div>
                      <div class="flex item-center">
                        <span style="width: 34px" class="mr10">链接</span>
                        <el-input
                          class="flex-1"
                          v-model="v.hrefAddress"
                          size="small"
                          type="text"
                          placeholder="请输入链接"
                        ></el-input>
                      </div>
                    </template>
                    <template v-if="v.pageType === 'channels'">
                      <div class="flex item-center mb10">
                        <span class="mr10">视频号主页ID</span>
                      </div>
                      <div class="flex item-center mb20">
                        <el-input
                          class="flex-1"
                          size="small"
                          v-model="v.profile"
                          type="text"
                          placeholder="请输入主页ID"
                        ></el-input>
                      </div>
                      <div class="flex item-center mb10">
                        <span class="mr10">视频号视频ID</span>
                      </div>
                      <div class="flex item-center mb20">
                        <el-input
                          class="flex-1"
                          v-model="v.activity"
                          size="small"
                          type="text"
                          placeholder="请输入视频ID"
                        ></el-input>
                      </div>
                    </template>
                    <template v-if="v.pageType === 'live'">
                      <div class="flex item-center mb10">
                        <span class="mr10">直播间ID</span>
                      </div>
                      <div class="flex item-center mb20">
                        <el-input
                          class="flex-1"
                          size="small"
                          v-model="v.roomId"
                          type="text"
                          placeholder="请输入直播间ID"
                        ></el-input>
                      </div>
                    </template>
                  </div>
                </div>
              </draggable>
              <draggable
                class="tabbar-setting"
                :list="currentProp.rightImgList"
                v-if="
                  (currentProp.type === '3' || currentProp.type === '5') &&
                  imgAdSelectionUpLoadType === 'rightImgList'
                "
              >
                <div
                  class="tabbar-setting-item flex"
                  v-for="(v, i) in currentProp.rightImgList"
                  :key="i"
                >
                  <div class="delete-tab" @click="deleteCurrentImageAd(i)">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div
                    class="icon-wrapper"
                    :class="{ 'no-bg': !v.src }"
                    @click="changeImageAd(i)"
                  >
                    <img :src="v.src" class="img" v-if="v.src" alt="图片广告" />
                    <div class="change-icon">
                      {{ v.src ? "更换图片" : "添加图片" }}
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="flex item-center mb10">
                      <span class="mr10">标题</span>
                      <el-input
                        class="flex-1"
                        v-model="v.text"
                        size="small"
                        maxlength="10"
                        placeholder="建议10个字以内，可不填"
                      ></el-input>
                    </div>
                    <div class="flex item-center" style="padding: 10px 0">
                      <span class="mr10">类型</span>
                      <el-radio-group
                        v-model="v.pageType"
                        class="flex-1"
                        @change="openGoodsSelect(v, i, 'rightImgList')"
                      >
                        <el-radio label="page">页面</el-radio>
                        <el-radio label="goods">商品</el-radio>
                        <el-radio label="brand">品牌</el-radio>
                        <el-radio label="mp">小程序</el-radio>
                        <el-radio label="channels">视频号</el-radio>
                        <el-radio label="live">直播间</el-radio>
                        <el-radio label="activityCenter">营销活动</el-radio>
                      </el-radio-group>
                    </div>
                    <div class="flex item-center" v-if="v.pageType === 'page'">
                      <span class="mr10">链接</span>
                      <el-select
                        class="flex-1"
                        size="small"
                        clearable
                        placeholder="选择页面"
                        v-if="!v.groupGoods.groupId"
                        v-model="v.hrefAddress"
                        @change="selectGroup($event, i, 'rightImgList')"
                        allow-create
                        filterable
                      >
                        <el-option
                          v-for="(item, index) in microShopRouteList"
                          :key="index"
                          :label="item.hrefName"
                          :value="item.hrefAddress"
                        ></el-option>
                      </el-select>
                      <div class="flex item-center" v-if="v.groupGoods.groupId">
                        <span>分组：</span>
                        <el-tag
                          closable
                          @close="handleCloseGroup('rightImgList', i)"
                          type="success"
                          >{{ v.groupGoods.groupName }}</el-tag
                        >
                      </div>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="v.pageType === 'goods' && v.goodsInfo.wxshopSpuName"
                    >
                      <span class="mr10">商品</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.goodsInfo.wxshopSpuName }}</el-tag
                      >
                    </div>
                    <div
                      class="flex item-center"
                      v-if="
                        v.pageType === 'brand' &&
                        v.brandInfo &&
                        v.brandInfo.brandName
                      "
                    >
                      <span class="mr10">品牌</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.brandInfo.brandName }}</el-tag
                      >
                    </div>
                    <template v-if="v.pageType === 'mp'">
                      <div class="flex item-center mb20">
                        <span class="mr10">appid</span>
                        <el-input
                          class="flex-1"
                          size="small"
                          v-model="v.appid"
                          type="text"
                          placeholder="请输入appid"
                        ></el-input>
                      </div>
                      <div class="flex item-center">
                        <span style="width: 34px" class="mr10">链接</span>
                        <el-input
                          class="flex-1"
                          v-model="v.hrefAddress"
                          size="small"
                          type="text"
                          placeholder="请输入链接"
                        ></el-input>
                      </div>
                    </template>
                    <template v-if="v.pageType === 'channels'">
                      <div class="flex item-center mb10">
                        <span class="mr10">视频号主页ID</span>
                      </div>
                      <div class="flex item-center mb20">
                        <el-input
                          class="flex-1"
                          size="small"
                          v-model="v.profile"
                          type="text"
                          placeholder="请输入主页ID"
                        ></el-input>
                      </div>
                      <div class="flex item-center mb10">
                        <span class="mr10">视频号视频ID</span>
                      </div>
                      <div class="flex item-center mb20">
                        <el-input
                          class="flex-1"
                          v-model="v.activity"
                          size="small"
                          type="text"
                          placeholder="请输入视频ID"
                        ></el-input>
                      </div>
                    </template>
                    <template v-if="v.pageType === 'live'">
                      <div class="flex item-center mb10" 
                        v-if="v.liveList.length>0">
                        <span class="mr10">直播间</span>
                      </div>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        v-if="v.liveList.length>0"
                        >{{ v.liveList[0].roomName }}</el-tag
                      >
                    </template>
                    <template v-if="v.pageType === 'activityCenter'">
                      <div class="flex item-center mb10" 
                        v-if="v.activityInfo.gameId">
                        <span class="mr10">营销活动</span>
                      </div>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        v-if="v.activityInfo.gameId"
                        >{{ v.activityInfo.gameName }}</el-tag
                      >
                    </template>
                  </div>
                </div>
              </draggable>
              <draggable
                class="tabbar-setting"
                :list="currentProp.rightImgList2"
                v-if="
                  currentProp.type === '5' &&
                  imgAdSelectionUpLoadType === 'rightImgList2'
                "
              >
                <div
                  class="tabbar-setting-item flex"
                  v-for="(v, i) in currentProp.rightImgList2"
                  :key="i"
                >
                  <div class="delete-tab" @click="deleteCurrentImageAd(i)">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div
                    class="icon-wrapper"
                    :class="{ 'no-bg': !v.src }"
                    @click="changeImageAd(i)"
                  >
                    <img :src="v.src" class="img" v-if="v.src" alt="图片广告" />
                    <div class="change-icon">
                      {{ v.src ? "更换图片" : "添加图片" }}
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="flex item-center mb10">
                      <span class="mr10">标题</span>
                      <el-input
                        class="flex-1"
                        v-model="v.text"
                        size="small"
                        maxlength="10"
                        placeholder="建议10个字以内，可不填"
                      ></el-input>
                    </div>
                    <div class="flex item-center" style="padding: 10px 0">
                      <span class="mr10">类型</span>
                      <el-radio-group
                        v-model="v.pageType"
                        class="flex-1"
                        @change="openGoodsSelect(v, i, 'rightImgList2')"
                      >
                        <el-radio label="page">页面</el-radio>
                        <el-radio label="goods">商品</el-radio>
                        <el-radio label="brand">品牌</el-radio>
                        <el-radio label="mp">小程序</el-radio>
                        <el-radio label="channels">视频号</el-radio>
                        <el-radio label="live">直播间</el-radio>
                        <el-radio label="activityCenter">营销活动</el-radio>
                      </el-radio-group>
                    </div>
                    <div class="flex item-center" v-if="v.pageType === 'page'">
                      <span class="mr10">链接</span>
                      <el-select
                        class="flex-1"
                        size="small"
                        clearable
                        placeholder="选择页面"
                        v-if="!v.groupGoods.groupId"
                        v-model="v.hrefAddress"
                        @change="selectGroup($event, i, 'rightImgList2')"
                        allow-create
                        filterable
                      >
                        <el-option
                          v-for="(item, index) in microShopRouteList"
                          :key="index"
                          :label="item.hrefName"
                          :value="item.hrefAddress"
                        ></el-option>
                      </el-select>
                      <div class="flex item-center" v-if="v.groupGoods.groupId">
                        <span>分组：</span>
                        <el-tag
                          closable
                          @close="handleCloseGroup('rightImgList2', i)"
                          type="success"
                          >{{ v.groupGoods.groupName }}</el-tag
                        >
                      </div>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="v.pageType === 'goods' && v.goodsInfo.wxshopSpuName"
                    >
                      <span class="mr10">商品</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.goodsInfo.wxshopSpuName }}</el-tag
                      >
                    </div>
                    <div
                      class="flex item-center"
                      v-if="
                        v.pageType === 'brand' &&
                        v.brandInfo &&
                        v.brandInfo.brandName
                      "
                    >
                      <span class="mr10">品牌</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.brandInfo.brandName }}</el-tag
                      >
                    </div>
                    <template v-if="v.pageType === 'mp'">
                      <div class="flex item-center mb20">
                        <span class="mr10">appid</span>
                        <el-input
                          class="flex-1"
                          size="small"
                          v-model="v.appid"
                          type="text"
                          placeholder="请输入appid"
                        ></el-input>
                      </div>
                      <div class="flex item-center">
                        <span style="width: 34px" class="mr10">链接</span>
                        <el-input
                          class="flex-1"
                          v-model="v.hrefAddress"
                          size="small"
                          type="text"
                          placeholder="请输入链接"
                        ></el-input>
                      </div>
                    </template>
                    <template v-if="v.pageType === 'channels'">
                      <div class="flex item-center mb10">
                        <span class="mr10">视频号主页ID</span>
                      </div>
                      <div class="flex item-center mb20">
                        <el-input
                          class="flex-1"
                          size="small"
                          v-model="v.profile"
                          type="text"
                          placeholder="请输入主页ID"
                        ></el-input>
                      </div>
                      <div class="flex item-center mb10">
                        <span class="mr10">视频号视频ID</span>
                      </div>
                      <div class="flex item-center mb20">
                        <el-input
                          class="flex-1"
                          v-model="v.activity"
                          size="small"
                          type="text"
                          placeholder="请输入视频ID"
                        ></el-input>
                      </div>
                    </template>
                    <template v-if="v.pageType === 'live'">
                      <div class="flex item-center mb10" 
                        v-if="v.liveList.length>0">
                        <span class="mr10">直播间</span>
                      </div>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        v-if="v.liveList.length>0"
                        >{{ v.liveList[0].roomName }}</el-tag
                      >
                    </template>
                    <template v-if="v.pageType === 'activityCenter'">
                      <div class="flex item-center mb10" 
                        v-if="v.activityInfo.gameId">
                        <span class="mr10">营销活动</span>
                      </div>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        v-if="v.activityInfo.gameId"
                        >{{ v.activityInfo.gameName }}</el-tag
                      >
                    </template>
                  </div>
                </div>
              </draggable>
              <el-button
                :disabled="
                  ( currentProp.type !== '3' &&
                    currentProp.type !== '5' &&
                    currentProp.imgList &&
                    currentProp.imgList.length >= 10) ||
                  ((currentProp.type === '3' || currentProp.type === '5') &&
                    currentProp.leftImgList &&
                    currentProp.leftImgList.length >= 10 &&
                    imgAdSelectionUpLoadType === 'leftImgList') ||
                  ((currentProp.type === '3' || currentProp.type === '5') &&
                    currentProp.rightImgList &&
                    currentProp.rightImgList.length >= 10 &&
                    imgAdSelectionUpLoadType === 'rightImgList') ||
                  (currentProp.type === '5' &&
                    currentProp.rightImgList2 &&
                    currentProp.rightImgList2.length >= 10 &&
                    imgAdSelectionUpLoadType === 'rightImgList2')  
                "
                type="primary"
                plain
                size="small"
                class="w100"
                @click="addImageAd"
                >添加背景图</el-button
              >
            </div>
            <ul class="other-setting p20">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{
                    !currentProp.borderRadius ? "直角" : "圆角"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">页面边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.margin"
                  ></el-slider>
                </div>
              </li>
              <li
                class="flex flex-between item-center"
                v-if="!currentProp.isSwiper"
              >
                <span class="mr20">图片边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.marginBottom"
                  ></el-slider>
                </div>
              </li>
              <!-- <li 
                class="flex flex-between item-center"
                v-if="currentProp.type === '1' || currentProp.type === '4'"> -->
              <li 
                class="flex flex-between item-center"
                v-if="currentProp.type !== '2'">
                <div class="flex item-center">
                  <div class="label" style="margin-right:10px">轮播样式</div>
                  <div>
                    <el-radio-group
                      v-model="currentProp.dotType"
                      class="flex-1"
                      style="border:none"
                    >
                      <el-radio label="circle" style="margin-right:14px;"><span style="margin-left:4px;">圆点</span></el-radio>
                      <el-radio label="square" style="margin-right:14px;"><span style="margin-left:4px;">矩形</span></el-radio>
                      <el-radio label="pages" style="margin-right:14px;"><span style="margin-left:4px;">页码</span></el-radio>
                      <el-radio label="none" style="margin-right:14px;"><span style="margin-left:4px;">无</span></el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <!-- 图文导航 -->
          <div
            class="image-ad-setting"
            v-if="currentProp && currentProp.name === 'image-text-nav'"
          >
            <div class="p20">
              <div class="title">图文导航</div>
              <div class="tips">
                不能少于3个导航，拖动选中的导航可对其进行排序。注：上传图片时风格尺寸需要保持统一，建议尺寸90x90像素
                <div class="warning">
                  页面链接也可输入小程序关联的公众号文章地址
                </div>
              </div>
            </div>
            <div class="have-bg-wrapper">
              <draggable
                class="tabbar-setting"
                :list="currentProp.imageTextNavList"
              >
                <div
                  class="tabbar-setting-item"
                  v-for="(v, i) in currentProp.imageTextNavList"
                  :key="i"
                >
                  <div
                    class="delete-tab"
                    v-if="
                      currentProp.imageTextNavList &&
                      currentProp.imageTextNavList.length > 3
                    "
                    @click="deleteCurrentImageTextNav(i)"
                  >
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div class="flex">
                    <div class="navbar-icon flex">
                      <div class="un-selected flex">
                        <div
                          class="icon-wrapper"
                          :class="{ 'no-bg': !v.src }"
                          @click="changeImageTextNav(i)"
                        >
                          <img :src="v.src" v-if="v.src" alt="导航图" />
                          <div class="change-icon">
                            {{ v.src ? "更换图标" : "添加图标" }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex-1">
                      <div class="flex item-center mb10">
                        <div class="mr10">标题</div>
                        <el-input
                          class="flex-1"
                          v-model="v.title"
                          size="small"
                        ></el-input>
                      </div>
                      <div class="flex item-center" style="padding: 10px 0">
                        <span class="mr10">链接类型</span>
                        <el-radio-group
                          v-model="v.pageType"
                          class="flex-1"
                          @change="openGoodsSelect(v, i, 'imageTextNavList')"
                        >
                          <el-radio label="page" style="marginright: 10px"
                            >页面</el-radio
                          >
                          <el-radio label="goods" style="marginright: 10px"
                            >商品</el-radio
                          >
                          <el-radio label="brand" style="marginright: 10px"
                            >品牌</el-radio
                          >
                          <el-radio label="mp">小程序</el-radio>
                          <el-radio label="channels">视频号</el-radio>
                          <el-radio label="live">直播间</el-radio>
                          <el-radio label="activityCenter">营销活动</el-radio>
                        </el-radio-group>
                      </div>
                      <div
                        class="flex item-center"
                        v-if="v.pageType === 'page'"
                      >
                        <span class="mr10">链接</span>
                        <el-select
                          class="flex-1"
                          size="small"
                          clearable
                          placeholder="选择页面"
                          v-model="v.hrefAddress"
                          v-if="!v.groupGoods.groupId"
                          @change="selectGroup($event, i, 'imageTextNavList')"
                          allow-create
                          filterable
                        >
                          <el-option
                            v-for="(item, index) in microShopRouteList"
                            :key="index"
                            :label="item.hrefName"
                            :value="item.hrefAddress"
                          ></el-option>
                        </el-select>
                        <div
                          class="flex item-center"
                          v-if="v.groupGoods.groupId"
                        >
                          <span>分组：</span>
                          <el-tag
                            closable
                            @close="handleCloseGroup('imageTextNavList', i)"
                            type="success"
                            >{{ v.groupGoods.groupName }}</el-tag
                          >
                        </div>
                      </div>
                      <div
                        class="flex item-center"
                        v-if="
                          v.pageType === 'goods' && v.goodsInfo.wxshopSpuName
                        "
                      >
                        <span class="mr10">商品</span>
                        <el-tag
                          closable
                          @close="handleClose(v, i)"
                          type="success"
                          >{{ v.goodsInfo.wxshopSpuName }}</el-tag
                        >
                      </div>
                      <div
                        class="flex item-center"
                        v-if="
                          v.pageType === 'brand' &&
                          v.brandInfo &&
                          v.brandInfo.brandName
                        "
                      >
                        <span class="mr10">品牌</span>
                        <el-tag
                          closable
                          @close="handleClose(v, i)"
                          type="success"
                          >{{ v.brandInfo.brandName }}</el-tag
                        >
                      </div>
                      <template v-if="v.pageType === 'mp'">
                        <div class="flex item-center mb20">
                          <span class="mr10">appid</span>
                          <el-input
                            class="flex-1"
                            size="small"
                            v-model="v.appid"
                            type="text"
                            placeholder="请输入appid"
                          ></el-input>
                        </div>
                        <div class="flex item-center">
                          <span style="width: 34px" class="mr10">链接</span>
                          <el-input
                            class="flex-1"
                            v-model="v.hrefAddress"
                            size="small"
                            type="text"
                            placeholder="请输入链接"
                          ></el-input>
                        </div>
                      </template>
                      <template v-if="v.pageType === 'channels'">
                        <div class="flex item-center mb10">
                          <span class="mr10">视频号主页ID</span>
                        </div>
                        <div class="flex item-center mb20">
                          <el-input
                            class="flex-1"
                            size="small"
                            v-model="v.profile"
                            type="text"
                            placeholder="请输入主页ID"
                          ></el-input>
                        </div>
                        <div class="flex item-center mb10">
                          <span class="mr10">视频号视频ID</span>
                        </div>
                        <div class="flex item-center mb20">
                          <el-input
                            class="flex-1"
                            v-model="v.activity"
                            size="small"
                            type="text"
                            placeholder="请输入视频ID"
                          ></el-input>
                        </div>
                      </template>
                      <template v-if="v.pageType === 'live'">
                        <div class="flex item-center mb10" 
                          v-if="v.liveList.length>0">
                          <span class="mr10">直播间</span>
                        </div>
                        <el-tag
                          closable
                          @close="handleClose(v, i)"
                          type="success"
                          v-if="v.liveList.length>0"
                          >{{ v.liveList[0].roomName }}</el-tag
                        >
                      </template>
                      <template v-if="v.pageType === 'activityCenter'">
                        <div class="flex item-center mb10" 
                          v-if="v.activityInfo.gameId">
                          <span class="mr10">营销活动</span>
                        </div>
                        <el-tag
                          closable
                          @close="handleClose(v, i)"
                          type="success"
                          v-if="v.activityInfo.gameId"
                          >{{ v.activityInfo.gameName }}</el-tag
                        >
                      </template>
                    </div>
                  </div>
                </div>
              </draggable>
              <el-button
                type="primary"
                @click="addImageTextNav"
                plain
                size="small"
                class="w100"
                >添加导航</el-button
              >
            </div>
            <ul class="other-setting p20">
              <li class="flex flex-between">
                <span class="mr20">背景颜色</span>
                <el-color-picker
                  v-model="currentProp.backgroundColor"
                  size="mini"
                  :predefine="predefine"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">文字颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.color"
                  size="mini"
                ></el-color-picker>
              </li>
            </ul>
          </div>
          <!-- 魔方 -->
          <div
            class="cube-setting"
            v-if="currentProp && currentProp.name === 'cube'"
          >
            <div class="p20">
              <div class="title">魔方</div>
              <div class="tips">
                选定布局区域，在下方添加图片，建议添加比例一致的图片，建议尺寸360x360像素
                <div class="warning">
                  页面链接也可输入小程序关联的公众号文章地址
                </div>
              </div>
              <div class="other-setting">
                <div class="mb20">
                  <span class="mr20">选择模板</span>
                  <span class="sub-title temp">
                    {{
                      currentProp.permutation === 2
                        ? "一行两列"
                        : currentProp.permutation === 3
                        ? "一行三列"
                        : "一行四列"
                    }}
                  </span>
                </div>
                <div class="item-setting flex">
                  <el-radio-group v-model="currentProp.permutation">
                    <el-radio :label="2" style="marginright: 40px">
                      <div
                        class="shape two-column flex"
                        :class="{ active: currentProp.permutation === 2 }"
                      >
                        <div class="column flex-1"></div>
                        <div class="column flex-1"></div>
                      </div>
                    </el-radio>
                    <el-radio :label="3" style="marginright: 40px">
                      <div
                        class="shape three-column flex"
                        :class="{ active: currentProp.permutation === 3 }"
                      >
                        <div class="column flex-1"></div>
                        <div class="column flex-1"></div>
                        <div class="column flex-1"></div>
                      </div>
                    </el-radio>
                    <el-radio :label="4" style="marginright: 40px">
                      <div
                        class="shape four-column flex"
                        :class="{ active: currentProp.permutation === 4 }"
                      >
                        <div class="column flex-1"></div>
                        <div class="column flex-1"></div>
                        <div class="column flex-1"></div>
                        <div class="column flex-1"></div>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div class="have-bg-wrapper" style="padding: 0">
              <draggable class="tabbar-setting o" :list="currentProp.cubeList">
                <div
                  class="tabbar-setting-item flex move"
                  v-for="(v, i) in currentProp.cubeList"
                  :key="i"
                >
                  <div
                    class="icon-wrapper"
                    :class="{ 'no-bg': !v.src }"
                    @click="changeCube(i)"
                  >
                    <img
                      class="w100"
                      :src="v.src"
                      v-if="v.src"
                      alt="图片广告"
                    />
                    <div class="change-icon">
                      {{ v.src ? "更换图片" : "添加图片" }}
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="flex item-center" style="padding: 10px 0">
                      <span class="mr10">链接类型</span>
                      <el-radio-group
                        class="flex-1"
                        v-model="v.pageType"
                        @change="openGoodsSelect(v, i, 'cubeList')"
                      >
                        <el-radio label="page" style="marginright: 10px"
                          >页面</el-radio
                        >
                        <el-radio label="goods" style="marginright: 10px"
                          >商品</el-radio
                        >
                        <el-radio label="brand" style="marginright: 10px"
                          >品牌</el-radio
                        >
                        <el-radio label="mp" style="marginright: 10px"
                          >小程序</el-radio
                        >
                        <el-radio label="channels" style="marginright: 10px"
                          >视频号</el-radio>
                        <el-radio label="live" style="marginright: 10px"
                          >直播间</el-radio>
                        <el-radio label="activityCenter" style="marginright: 10px"
                        >营销活动</el-radio>                        
                      </el-radio-group>
                    </div>
                    <div class="flex item-center" v-if="v.pageType === 'page'">
                      <span class="mr10">链接</span>
                      <el-select
                        class="flex-1"
                        size="small"
                        clearable
                        placeholder="选择页面"
                        v-model="v.hrefAddress"
                        @change="selectGroup($event, i, 'cubeList')"
                        v-if="!v.groupGoods.groupId"
                        allow-create
                        filterable
                      >
                        <el-option
                          v-for="(item, i) in microShopRouteList"
                          :key="i"
                          :label="item.hrefName"
                          :value="item.hrefAddress"
                        ></el-option>
                      </el-select>
                      <div class="flex item-center" v-if="v.groupGoods.groupId">
                        <span>分组：</span>
                        <el-tag
                          closable
                          @close="handleCloseGroup('cubeList', i)"
                          type="success"
                          >{{ v.groupGoods.groupName }}</el-tag
                        >
                      </div>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="v.pageType === 'goods' && v.goodsInfo.wxshopSpuName"
                    >
                      <span class="mr10">商品</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.goodsInfo.wxshopSpuName }}</el-tag
                      >
                    </div>
                    <div
                      class="flex item-center"
                      v-if="
                        v.pageType === 'brand' &&
                        v.brandInfo &&
                        v.brandInfo.brandName
                      "
                    >
                      <span class="mr10">品牌</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.brandInfo.brandName }}</el-tag
                      >
                    </div>
                    <template v-if="v.pageType === 'mp'">
                      <div class="flex item-center mb20">
                        <span class="mr10">appid</span>
                        <el-input
                          class="flex-1"
                          size="small"
                          v-model="v.appid"
                          type="text"
                          placeholder="请输入appid"
                        ></el-input>
                      </div>
                      <div class="flex item-center">
                        <span style="width: 34px" class="mr10">链接</span>
                        <el-input
                          class="flex-1"
                          v-model="v.hrefAddress"
                          size="small"
                          type="text"
                          placeholder="请输入链接"
                        ></el-input>
                      </div>
                    </template>
                    <template v-if="v.pageType === 'channels'">
                      <div class="flex item-center mb10">
                        <span class="mr10">视频号主页ID</span>
                      </div>
                      <div class="flex item-center mb20">
                        <el-input
                          class="flex-1"
                          size="small"
                          v-model="v.profile"
                          type="text"
                          placeholder="请输入主页ID"
                        ></el-input>
                      </div>
                      <div class="flex item-center mb10">
                        <span class="mr10">视频号视频ID</span>
                      </div>
                      <div class="flex item-center mb20">
                        <el-input
                          class="flex-1"
                          v-model="v.activity"
                          size="small"
                          type="text"
                          placeholder="请输入视频ID"
                        ></el-input>
                      </div>
                    </template>
                    <template v-if="v.pageType === 'live'">
                      <div class="flex item-center mb10" 
                        v-if="v.liveList.length>0">
                        <span class="mr10">直播间</span>
                      </div>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        v-if="v.liveList.length>0"
                        >{{ v.liveList[0].roomName }}</el-tag
                      >
                    </template>
                    <template v-if="v.pageType === 'activityCenter'">
                      <div class="flex item-center mb10" 
                        v-if="v.activityInfo.gameId">
                        <span class="mr10">营销活动</span>
                      </div>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        v-if="v.activityInfo.gameId"
                        >{{ v.activityInfo.gameName }}</el-tag
                      >
                    </template>
                  </div>
                </div>
              </draggable>
            </div>
            <ul class="other-setting p20">
              <li class="flex flex-between item-center">
                <span class="mr20">图片空隙</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.itemMargin"
                  ></el-slider>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">页面间距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.margin"
                  ></el-slider>
                </div>
              </li>
            </ul>
          </div>
          <!-- 商品排列 -->
          <div
            class="goods-setting"
            v-if="currentProp && currentProp.name === 'goodsList'"
          >
            <div class="p20">
              <div class="title">商品排列</div>
              <div class="tips">
                直接上传已上架商品（商品分组则上传已分类商品）商品分组最多添加7组分类
              </div>
              <div>
                <span class="mr20">选择模板</span>
                <span class="sub-title temp">{{ goodsType }}</span>
              </div>
              <div class="item-setting template-setting flex">
                <el-radio-group
                  class="flex flex-wrap"
                  v-model="currentProp.goodShowType"
                >
                  <el-radio label="big">
                    <div
                      style="height: 60px"
                      class="shape two-column flex"
                      :class="{ active: currentProp.goodShowType === 'big' }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/9d8ee587-635e-4dc4-8aa6-c678a07f25bf.png"
                        alt
                      />
                    </div>
                  </el-radio>
                  <el-radio label="twoColumn">
                    <div
                      style="height: 60px"
                      class="shape three-column flex"
                      :class="{
                        active: currentProp.goodShowType === 'twoColumn',
                      }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/481b7566-8606-4147-817f-d3e27c56c493.png"
                        alt
                      />
                    </div>
                  </el-radio>
                  <el-radio label="threeColumn">
                    <div
                      style="height: 60px"
                      class="shape three-column flex"
                      :class="{
                        active: currentProp.goodShowType === 'threeColumn',
                      }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/69a14a701832cdb47f321eb847d04ef.png"
                        alt="一行3列"
                      />
                    </div>
                  </el-radio>
                  <el-radio label="scroll">
                    <div
                      style="height: 60px"
                      class="shape four-column flex"
                      :class="{ active: currentProp.goodShowType === 'scroll' }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/415fc147-4b32-4c39-b022-ac4e61ba41e4.png"
                        alt
                      />
                    </div>
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
            <draggable class="tabbar-setting" :list="currentProp.goodsList">
              <div
                class="tabbar-setting-item"
                v-show="!v.isMock"
                v-for="(v, i) in currentProp.goodsList"
                :key="i"
              >
                <div class="delete-tab" @click="deleteCurrentGoods(i)">
                  <span class="hmicon icon-guanbi1"></span>
                </div>
                <div class="flex">
                  <div class="img-wrapper mr10">
                    <img :src="v.spuMainPic" alt="logo" style="width: 50px" />
                  </div>
                  <div class="goods-name">{{ v.wxshopSpuName }}</div>
                </div>
              </div>
            </draggable>
            <div class="have-bg-wrapper">
              <el-button
                type="primary"
                @click="addGoods"
                plain
                size="small"
                class="w100"
                >添加商品</el-button
              >
            </div>
            <ul class="other-setting p20 border-bottom">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{
                    !currentProp.borderRadius ? "直角" : "圆角"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">{{
                    currentProp.titleBold ? "加粗体" : "常规体"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">页面边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </li>
              <li
                class="flex flex-between item-center"
                v-if="!currentProp.isSwiper"
              >
                <span class="mr20">图片边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.marginBottom"
                  ></el-slider>
                </div>
              </li>
            </ul>
            <ul class="other-setting p20">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品描述</span>
                  <span class="sub-title temp">{{
                    currentProp.showSubTitle ? "显示" : "隐藏"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showSubTitle"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品价格</span>
                  <span class="sub-title temp">{{
                    currentProp.showPrice ? "显示" : "隐藏"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showPrice"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
              <!-- <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">购买按钮</span>
                  <span class="sub-title temp">
                    {{ currentProp.showCart ? "显示" : "隐藏" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showCart"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>-->
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品销量</span>
                  <span class="sub-title temp">{{
                    currentProp.showSaleNum ? "显示" : "隐藏"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showSaleNum"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品角标</span>
                  <span class="sub-title temp">{{
                    currentProp.showLogo ? "显示" : "隐藏"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showLogo"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">购买按钮</span>
                  <span class="sub-title temp">{{
                    currentProp.showCart ? "显示" : "隐藏"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showCart"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
            </ul>
            <div class="p20">
              <el-radio-group
                v-model="currentProp.logoType"
                v-if="currentProp.showLogo"
              >
                <el-radio label="HOT"></el-radio>
                <el-radio label="NEW"></el-radio>
                <el-radio label="秒杀"></el-radio>
                <el-radio label="自定义"></el-radio>
              </el-radio-group>
              <div v-if="currentProp.logoType === '自定义'">
                <span class="tips">上传图片建议尺寸120x120像素</span>
              </div>
              <div
                class="icon-wrapper"
                v-if="currentProp.logoType === '自定义'"
                :class="{ 'no-bg': !currentProp.logoUrl }"
                @click="changeLogoUrl()"
              >
                <img
                  :src="currentProp.logoUrl"
                  v-if="currentProp.logoUrl"
                  alt="图片广告"
                />
                <div class="change-icon">
                  {{ currentProp.logoUrl ? "更换图片" : "添加图片" }}
                </div>
              </div>
            </div>
          </div>
          <!-- 每日特惠 -->
          <div
            class="goods-setting dailydeals-setting"
            v-if="currentProp && currentProp.name === 'dailydeals'"
          >
            <div class="p20">
              <div class="title">每日特惠</div>
              <div class="tips">选择模板 一行一商品</div>
              <div>
                <span class="mr20">选择模板</span>
                <span class="sub-title temp">{{ goodsType }}</span>
              </div>
              <div
                class="item-setting template-setting flex border-bottom"
                style="padding-bottom: 20px"
              >
                <el-radio-group
                  class="flex flex-wrap"
                  v-model="currentProp.goodShowType"
                >
                  <el-radio label="big">
                    <div
                      style="height: 60px"
                      class="shape two-column flex"
                      :class="{ active: currentProp.goodShowType === 'big' }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/lunbo_01.png"
                        alt
                      />
                    </div>
                  </el-radio>
                  <el-radio label="twoColumn">
                    <div
                      style="height: 60px"
                      class="shape three-column flex"
                      :class="{
                        active: currentProp.goodShowType === 'twoColumn',
                      }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/lunbo_02.png"
                        alt
                      />
                    </div>
                  </el-radio>
                  <el-radio label="threeColumn">
                    <div
                      style="height: 60px"
                      class="shape three-column flex"
                      :class="{
                        active: currentProp.goodShowType === 'threeColumn',
                      }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/lunbo_03.png"
                        alt="一行3列"
                      />
                    </div>
                  </el-radio>
                  <el-radio label="fourColumn">
                    <div
                      style="height: 60px"
                      class="shape four-column flex"
                      :class="{
                        active: currentProp.goodShowType === 'fourColumn',
                      }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/lunbo_04.png"
                        alt
                      />
                    </div>
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="flex flex-center padding20 mb20">
              <el-radio-group
                class="flex-1"
                v-model="currentProp.goodShowType2"
                @change="dailyDealsRadioGroup"
              >
                <el-radio label="auto" style="marginright: 10px"
                  >自动读取特价商品</el-radio
                >
                <el-radio label="add" style="marginright: 10px"
                  >手动添加特价商品</el-radio
                >
              </el-radio-group>
            </div>
            <draggable class="tabbar-setting" :list="currentProp.goodsList">
              <div
                class="tabbar-setting-item"
                v-show="!v.isMock"
                v-for="(v, i) in currentProp.goodsList"
                :key="i"
              >
                <div class="delete-tab" @click="deleteCurrentGoods(i)">
                  <span class="hmicon icon-guanbi1"></span>
                </div>
                <div class="flex">
                  <div class="img-wrapper mr10">
                    <img :src="v.spuMainPic" alt="logo" style="width: 50px" />
                  </div>
                  <div class="goods-name">{{ v.wxshopSpuName }}</div>
                </div>
              </div>
            </draggable>
            <!-- <div class="have-bg-wrapper" v-if="currentProp.goodShowType2==='auto'">
              <el-button
                type="primary"
                @click="autoAddGoods"
                plain
                size="small"
                class="w100"
                >自动添加特价商品</el-button
              >
            </div> -->
            <div
              class="have-bg-wrapper"
              v-if="currentProp.goodShowType2 === 'add'"
            >
              <el-button
                type="primary"
                @click="addDailyDeals"
                plain
                size="small"
                class="w100"
                >手动添加特价商品</el-button
              >
            </div>
            <div class="flex item-center padding20 mt20">
              <span class="mr10">模块名称</span>
              <el-input
                class="flex-1"
                type="text"
                size="small"
                placeholder="请输入标题"
                v-model="currentProp.title"
                style="width: 100px"
              ></el-input>
              <span class="showhide">{{
                currentProp.showTitle ? "显示" : "隐藏"
              }}</span>
              <div class="flex flex-end">
                <el-switch
                  :width="30"
                  v-model="currentProp.showTitle"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                  @change="dailydealsShowTitle2"
                ></el-switch>
              </div>
            </div>
            <div class="flex flex-between item-center padding20 mt20">
              <div class="flex">
                <span class="mr10">标题图片<br>(600*100)</span>
                <div
                  class="icon-wrapper"
                  :class="{ 'no-bg': !currentProp.titlePic }"
                >
                  <img
                    :src="currentProp.titlePic"
                    v-if="currentProp.titlePic"
                    alt="图标"
                  />
                  <div class="change-icon" @click="changetitlePic()">
                    {{ currentProp.titlePic ? "更换图标" : "添加图标" }}
                  </div>
                  <div class="card-item-delete-img" @click="deleteTitlePic()">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                </div>

              </div>
              <div class="flex">
                <span class="showhide">{{
                  currentProp.showTitlePic ? "显示" : "隐藏"
                }}</span>
                <div class="flex flex-end">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showTitlePic"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                    @change="dailydealsShowTitle"
                  ></el-switch>
                </div>
              </div>
            </div>
            <div class="flex item-center padding20 mt20">
              <span class="mr10">副标题</span>
              <el-input
                class="flex-1"
                type="textarea"
                maxlength="100"
                size="small"
                placeholder="请输入描述,最多100字"
                v-model="currentProp.subTitle"
              ></el-input>
              <span class="showhide">{{
                currentProp.showSubTitleTop ? "显示" : "隐藏"
              }}</span>
              <div class="flex flex-end">
                <el-switch
                  :width="30"
                  v-model="currentProp.showSubTitleTop"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
            </div>
            <div class="flex flex-between item-center padding20 mt20">
              <span class="mr10">{{
                  currentProp.showGroupGoods ? "隐藏身份不一致商品" : "显示所有商品"
                }}</span>
              <div class="flex">
                <span class="showhide">{{
                  currentProp.showGroupGoods ? "开启" : "关闭"
                }}</span>
                <div class="flex flex-end">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showGroupGoods"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
            </div>
            <ul class="other-setting padding20 mt20">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">模块粗细</span>
                  <span class="sub-title temp">{{
                    currentProp.titleBold ? "加粗体" : "常规体"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">副标题粗细</span>
                  <span class="sub-title temp">{{
                    currentProp.subTitleBoldTop ? "加粗体" : "常规体"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.subTitleBoldTop">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.subTitleBoldTop }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.subTitleBoldTop }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between">
                <span class="mr20">标题颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.titleColor"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">副标题颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.subTitleColor"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">背景颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.backgroundColor"
                  size="mini"
                ></el-color-picker>
              </li>
            </ul>
            <ul class="other-setting p20 border-bottom">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{
                    !currentProp.borderRadius ? "直角" : "圆角"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">商品切换速度</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="1"
                    :max="5"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.interval"
                  ></el-slider>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">页面边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">查看更多跳转</span>
                <div class="flex-1 text-right">
                  <el-select
                    class="mr10"
                    size="small"
                    clearable
                    placeholder="查看更多跳转"
                    v-model="currentProp.hrefAddress"
                  >
                    <el-option
                      v-for="(item, i) in specialMoreList"
                      :key="i"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>                  
                </div>
              </li>
            </ul>
          </div>
          <!-- 新品专区 -->
          <div
            class="goods-setting dailydeals-setting"
            v-if="currentProp && currentProp.name === 'dailynews'"
          >
            <div class="p20">
              <div class="title">新品专区</div>
              <div class="tips">选择模板 一行一商品</div>
              <div>
                <span class="mr20">选择模板</span>
                <span class="sub-title temp">{{ goodsType }}</span>
              </div>
              <div
                class="item-setting template-setting flex border-bottom"
                style="padding-bottom: 20px"
              >
                <el-radio-group
                  class="flex flex-wrap"
                  v-model="currentProp.goodShowType"
                >
                  <el-radio label="big">
                    <div
                      style="height: 60px"
                      class="shape two-column flex"
                      :class="{ active: currentProp.goodShowType === 'big' }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/lunbo_01.png"
                        alt
                      />
                    </div>
                  </el-radio>
                  <el-radio label="twoColumn">
                    <div
                      style="height: 60px"
                      class="shape three-column flex"
                      :class="{
                        active: currentProp.goodShowType === 'twoColumn',
                      }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/lunbo_02.png"
                        alt
                      />
                    </div>
                  </el-radio>
                  <el-radio label="threeColumn">
                    <div
                      style="height: 60px"
                      class="shape three-column flex"
                      :class="{
                        active: currentProp.goodShowType === 'threeColumn',
                      }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/lunbo_03.png"
                        alt="一行3列"
                      />
                    </div>
                  </el-radio>
                  <el-radio label="fourColumn">
                    <div
                      style="height: 60px"
                      class="shape four-column flex"
                      :class="{
                        active: currentProp.goodShowType === 'fourColumn',
                      }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/lunbo_04.png"
                        alt
                      />
                    </div>
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="flex flex-center padding20 mb20">
              <el-radio-group
                class="flex-1"
                v-model="currentProp.goodShowType2"
                @change="dailyNewsRadioGroup"
              >
                <el-radio label="auto" style="marginright: 10px"
                  >自动读取新品商品</el-radio
                >
                <el-radio label="add" style="marginright: 10px"
                  >手动添加新品商品</el-radio
                >
              </el-radio-group>
            </div>
            <draggable class="tabbar-setting" :list="currentProp.goodsList">
              <div
                class="tabbar-setting-item"
                v-show="!v.isMock"
                v-for="(v, i) in currentProp.goodsList"
                :key="i"
              >
                <div class="delete-tab" @click="deleteCurrentGoods(i)">
                  <span class="hmicon icon-guanbi1"></span>
                </div>
                <div class="flex">
                  <div class="img-wrapper mr10">
                    <img :src="v.spuMainPic" alt="logo" style="width: 50px" />
                  </div>
                  <div class="goods-name">{{ v.wxshopSpuName }}</div>
                </div>
              </div>
            </draggable>
            <div
              class="have-bg-wrapper"
              v-if="currentProp.goodShowType2 === 'add'"
            >
              <el-button
                type="primary"
                @click="addDailyNews('dailyNews')"
                plain
                size="small"
                class="w100"
                >手动添加新品商品</el-button
              >
            </div>
            <div class="flex item-center padding20 mt20">
              <span class="mr10">模块名称</span>
              <el-input
                class="flex-1"
                type="text"
                size="small"
                placeholder="请输入标题"
                v-model="currentProp.title"
                style="width: 100px"
              ></el-input>
              <span class="showhide">{{
                currentProp.showTitle ? "显示" : "隐藏"
              }}</span>
              <div class="flex flex-end">
                <el-switch
                  :width="30"
                  v-model="currentProp.showTitle"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                  @change="dailydealsShowTitle2"
                ></el-switch>
              </div>
            </div>
            <div class="flex flex-between item-center padding20 mt20">
              <div class="flex">
                <span class="mr10">标题图片<br>(600*100)</span>
                <div
                  class="icon-wrapper"
                  :class="{ 'no-bg': !currentProp.titlePic }"
                >
                  <img
                    :src="currentProp.titlePic"
                    v-if="currentProp.titlePic"
                    alt="图标"
                  />
                  <div class="change-icon" @click="changetitlePic()">
                    {{ currentProp.titlePic ? "更换图标" : "添加图标" }}
                  </div>
                  <div class="card-item-delete-img" @click="deleteTitlePic()">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                </div>

              </div>
              <div class="flex">
                <span class="showhide">{{
                  currentProp.showTitlePic ? "显示" : "隐藏"
                }}</span>
                <div class="flex flex-end">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showTitlePic"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                    @change="dailydealsShowTitle"
                  ></el-switch>
                </div>
              </div>
            </div>
            <div class="flex item-center padding20 mt20">
              <span class="mr10">副标题</span>
              <el-input
                class="flex-1"
                type="textarea"
                maxlength="100"
                size="small"
                placeholder="请输入描述,最多100字"
                v-model="currentProp.subTitle"
              ></el-input>
              <span class="showhide">{{
                currentProp.showSubTitleTop ? "显示" : "隐藏"
              }}</span>
              <div class="flex flex-end">
                <el-switch
                  :width="30"
                  v-model="currentProp.showSubTitleTop"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
            </div>
            <ul class="other-setting padding20 mt20">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">模块粗细</span>
                  <span class="sub-title temp">{{
                    currentProp.titleBold ? "加粗体" : "常规体"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">副标题粗细</span>
                  <span class="sub-title temp">{{
                    currentProp.subTitleBoldTop ? "加粗体" : "常规体"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.subTitleBoldTop">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.subTitleBoldTop }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.subTitleBoldTop }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between">
                <span class="mr20">标题颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.titleColor"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">副标题颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.subTitleColor"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">背景颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.backgroundColor"
                  size="mini"
                ></el-color-picker>
              </li>
            </ul>
            <ul class="other-setting p20 border-bottom">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{
                    !currentProp.borderRadius ? "直角" : "圆角"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">商品切换速度</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="1"
                    :max="5"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.interval"
                  ></el-slider>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">页面边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </li>
            </ul>
          </div>
          <!-- 组合活动 -->
          <div
            class="goods-setting dailydeals-setting"
            v-if="currentProp && currentProp.name === 'composite'"
          >
            <div class="p20">
              <div class="title">组合活动</div>
              <div class="tips">选择模板 一行一商品</div>
              <div>
                <span class="mr20">选择模板</span>
                <span class="sub-title temp">{{ goodsType }}</span>
              </div>
              <div
                class="item-setting template-setting flex border-bottom"
                style="padding-bottom: 20px"
              >
                <el-radio-group
                  class="flex flex-wrap"
                  v-model="currentProp.goodShowType"
                >
                  <el-radio label="left">
                    <div
                      style="height: 60px"
                      class="shape three-column flex"
                      :class="{
                        active: currentProp.goodShowType === 'left',
                      }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/lunbo_02.png"
                        alt
                      />
                    </div>
                  </el-radio>
                  <el-radio label="right">
                    <div
                      style="height: 60px"
                      class="shape three-column flex"
                      :class="{
                        active: currentProp.goodShowType === 'right',
                      }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/lunbo_02.png"
                        alt=""
                      />
                    </div>
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="flex item-center padding20 mt20">
              <span class="mr10">每日特惠标题</span>
              <el-input
                class="flex-1"
                type="text"
                size="small"
                placeholder="请输入标题"
                v-model="currentProp.titleDailyDeals"
                style="width: 100px"
              ></el-input>
              <span class="showhide">{{
                currentProp.showTitleDailyDeals ? "显示" : "隐藏"
              }}</span>
              <div class="flex flex-end">
                <el-switch
                  :width="30"
                  v-model="currentProp.showTitleDailyDeals"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                  @change="changeDailydealsShowTitle2"
                ></el-switch>
              </div>
            </div>
            <div class="flex flex-between item-center padding20 mt20">
              <div class="flex">
                <span class="mr10">标题图片<br>(600*100)</span>
                <div
                  class="icon-wrapper"
                  :class="{ 'no-bg': !currentProp.titlePicDailyDeals }"
                >
                  <img
                    :src="currentProp.titlePicDailyDeals"
                    v-if="currentProp.titlePicDailyDeals"
                    alt="图标"
                  />
                  <div class="change-icon" @click="changetitlePicDailyDeals()">
                    {{ currentProp.titlePicDailyDeals ? "更换图标" : "添加图标" }}
                  </div>
                  <div class="card-item-delete-img" @click="deleteTitlePicDailyDeals()">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                </div>

              </div>
              <div class="flex">
                <span class="showhide">{{
                  currentProp.showTitlePicDailyDeals ? "显示" : "隐藏"
                }}</span>
                <div class="flex flex-end">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showTitlePicDailyDeals"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                    @change="changeDailydealsShowTitle"
                  ></el-switch>
                </div>
              </div>
            </div>
            <div class="flex item-center padding20 mt20 bt20">
              <span class="mr10">副标题</span>
              <el-input
                class="flex-1"
                type="textarea"
                maxlength="100"
                size="small"
                placeholder="请输入描述,最多100字"
                v-model="currentProp.subTitleDailyDeals"
              ></el-input>
              <span class="showhide">{{
                currentProp.showSubTitleTopDailyDeals ? "显示" : "隐藏"
              }}</span>
              <div class="flex flex-end">
                <el-switch
                  :width="30"
                  v-model="currentProp.showSubTitleTopDailyDeals"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
            </div>
            <div class="flex flex-between item-center padding20 mt20">
              <span class="mr10">{{
                  currentProp.showGroupGoods ? "隐藏身份不一致商品" : "显示所有商品"
                }}</span>
              <div class="flex">
                <span class="showhide">{{
                  currentProp.showGroupGoods ? "开启" : "关闭"
                }}</span>
                <div class="flex flex-end">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showGroupGoods"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
            </div>
            <div class="flex flex-center padding20 mt20 mb20">
              <el-radio-group
                class="flex-1"
                v-model="currentProp.goodShowType2"
                @change="dailyDealsRadioGroup"
              >
                <el-radio label="auto" style="marginright: 10px"
                  >自动读取特价商品</el-radio
                >
                <el-radio label="add" style="marginright: 10px"
                  >手动添加特价商品</el-radio
                >
              </el-radio-group>
            </div>
            <draggable class="tabbar-setting" :list="currentProp.goodsList">
              <div
                class="tabbar-setting-item"
                v-show="!v.isMock"
                v-for="(v, i) in currentProp.goodsList"
                :key="i"
              >
                <div class="delete-tab" @click="deleteCurrentGoods(i)">
                  <span class="hmicon icon-guanbi1"></span>
                </div>
                <div class="flex">
                  <div class="img-wrapper mr10">
                    <img :src="v.spuMainPic" alt="logo" style="width: 50px" />
                  </div>
                  <div class="goods-name">{{ v.wxshopSpuName }}</div>
                </div>
              </div>
            </draggable>            
            <div
              class="have-bg-wrapper"
              v-if="currentProp.goodShowType2 === 'add'"
            >
              <el-button
                type="primary"
                @click="addDailyDeals"
                plain
                size="small"
                class="w100"
                >手动添加特价商品</el-button
              >
            </div>

            <div class="flex item-center padding20 mt20 border-top">
              <span class="mr10">新品专区标题</span>
              <el-input
                class="flex-1"
                type="text"
                size="small"
                placeholder="请输入标题"
                v-model="currentProp.titleDailyNews"
                style="width: 100px"
              ></el-input>
              <span class="showhide">{{
                currentProp.showTitleDailyNews ? "显示" : "隐藏"
              }}</span>
              <div class="flex flex-end">
                <el-switch
                  :width="30"
                  v-model="currentProp.showTitleDailyNews"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                  @change="changeDailyNewsShowTitle2"
                ></el-switch>
              </div>
            </div>
            <div class="flex flex-between item-center padding20 mt20">
              <div class="flex">
                <span class="mr10">标题图片<br>(600*100)</span>
                <div
                  class="icon-wrapper"
                  :class="{ 'no-bg': !currentProp.titlePicDailyNews }"
                >
                  <img
                    :src="currentProp.titlePicDailyNews"
                    v-if="currentProp.titlePicDailyNews"
                    alt="图标"
                  />
                  <div class="change-icon" @click="changetitlePicDailyNews()">
                    {{ currentProp.titlePicDailyNews ? "更换图标" : "添加图标" }}
                  </div>
                  <div class="card-item-delete-img" @click="deleteTitlePicDailyNews()">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                </div>

              </div>
              <div class="flex">
                <span class="showhide">{{
                  currentProp.showTitlePicDailyNews ? "显示" : "隐藏"
                }}</span>
                <div class="flex flex-end">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showTitlePicDailyNews"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                    @change="changeDailyNewsShowTitle"
                  ></el-switch>
                </div>
              </div>
            </div>
            <div class="flex item-center padding20 mt20">
              <span class="mr10">副标题</span>
              <el-input
                class="flex-1"
                type="textarea"
                maxlength="100"
                size="small"
                placeholder="请输入描述,最多100字"
                v-model="currentProp.subTitleDailyNews"
              ></el-input>
              <span class="showhide">{{
                currentProp.showSubTitleTopDailyNews ? "显示" : "隐藏"
              }}</span>
              <div class="flex flex-end">
                <el-switch
                  :width="30"
                  v-model="currentProp.showSubTitleTopDailyNews"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
            </div>
            <div class="flex flex-center padding20 mb20 mt20">
              <el-radio-group
                class="flex-1"
                v-model="currentProp.goodShowType3"
                @change="dailyNewsRadioGroup('composite')"
              >
                <el-radio label="auto" style="marginright: 10px"
                  >自动读取新品商品</el-radio
                >
                <el-radio label="add" style="marginright: 10px"
                  >手动添加新品商品</el-radio
                >
              </el-radio-group>
            </div>
            <draggable class="tabbar-setting" :list="currentProp.goodsList3">
              <div
                class="tabbar-setting-item"
                v-show="!v.isMock"
                v-for="(v, i) in currentProp.goodsList3"
                :key="i"
              >
                <div class="delete-tab" @click="deleteCurrentGoods(i,'composite')">
                  <span class="hmicon icon-guanbi1"></span>
                </div>
                <div class="flex">
                  <div class="img-wrapper mr10">
                    <img :src="v.spuMainPic" alt="logo" style="width: 50px" />
                  </div>
                  <div class="goods-name">{{ v.wxshopSpuName }}</div>
                </div>
              </div>
            </draggable>            
            <div
              class="have-bg-wrapper"
              v-if="currentProp.goodShowType2 === 'add'"
            >
              <el-button
                type="primary"
                @click="addDailyNews('composite')"
                plain
                size="small"
                class="w100"
                >手动添加新品商品</el-button
              >
            </div>
            <ul class="other-setting padding20 mt20">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">模块粗细</span>
                  <span class="sub-title temp">{{
                    currentProp.titleBold ? "加粗体" : "常规体"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">副标题粗细</span>
                  <span class="sub-title temp">{{
                    currentProp.subTitleBoldTop ? "加粗体" : "常规体"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.subTitleBoldTop">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.subTitleBoldTop }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.subTitleBoldTop }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">副标题对齐</span>
                  <span class="sub-title temp">{{
                    currentProp.subTitleTextAlign ? "右对齐" : "左对齐"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.subTitleTextAlign">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.subTitleTextAlign }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.subTitleTextAlign }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between">
                <span class="mr20">标题颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.titleColor"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">副标题颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.subTitleColor"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">背景颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.backgroundColor"
                  size="mini"
                ></el-color-picker>
              </li>
            </ul>
            <ul class="other-setting p20 border-bottom">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{
                    !currentProp.borderRadius ? "直角" : "圆角"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">商品切换速度</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="1"
                    :max="5"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.interval"
                  ></el-slider>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">页面边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">查看更多跳转</span>
                <div class="flex-1 text-right">
                  <el-select
                    class="mr10"
                    size="small"
                    clearable
                    placeholder="查看更多跳转"
                    v-model="currentProp.hrefAddress"
                  >
                    <el-option
                      v-for="(item, i) in specialMoreList"
                      :key="i"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>                  
                </div>
              </li>
            </ul>
          </div>
          <!-- 接龙活动 -->
          <div
            class="notice-setting"
            v-if="currentProp && currentProp.name === 'jielong'"
          >
            <div class="page-header">
              <div class="mb20">
                <div class="title">接龙活动</div>
                <span class="tips"
                  >按照活动最新从近到远排序</span
                >
              </div>
              <div class="flex item-center">
                <span class="mr10">显示条数</span>
                <el-input
                  class="flex-1"
                  size="small"                  
                  v-model.trim="currentProp.listLimit"
                  @mousewheel.prevent.native
                  @input="filterGt0OrFixed"
                ></el-input>
                <span>条</span>
              </div>
            </div>
          </div>
          <!-- 猜你喜欢 -->
          <div
            class="goods-setting"
            v-if="currentProp && currentProp.name === 'guess-you-like'"
          >
            <div class="p20">
              <div class="title">猜你喜欢</div>
              <div class="tips">根据客户购买商品动态推荐客户商品</div>
              <div>
                <span class="mr20">选择模板</span>
                <span class="sub-title temp">{{ goodsType }}</span>
              </div>
              <div class="item-setting template-setting flex">
                <el-radio-group v-model="currentProp.goodShowType">
                  <el-radio label="big">
                    <div
                      style="height: 60px"
                      class="shape two-column flex"
                      :class="{ active: currentProp.goodShowType === 'big' }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/9d8ee587-635e-4dc4-8aa6-c678a07f25bf.png"
                        alt
                      />
                    </div>
                  </el-radio>
                  <el-radio label="twoColumn">
                    <div
                      style="height: 60px"
                      class="shape three-column flex"
                      :class="{
                        active: currentProp.goodShowType === 'twoColumn',
                      }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/481b7566-8606-4147-817f-d3e27c56c493.png"
                        alt
                      />
                    </div>
                  </el-radio>
                  <el-radio label="threeColumn">
                    <div
                      style="height: 60px"
                      class="shape three-column flex"
                      :class="{
                        active: currentProp.goodShowType === 'threeColumn',
                      }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/69a14a701832cdb47f321eb847d04ef.png"
                        alt="一行3列"
                      />
                    </div>
                  </el-radio>
                  <!-- <el-radio label="scroll">
                    <div
                      style="height: 60px"
                      class="shape four-column flex"
                      :class="{ active: currentProp.goodShowType === 'scroll' }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/415fc147-4b32-4c39-b022-ac4e61ba41e4.png"
                        alt
                      />
                    </div>
                  </el-radio> -->
                </el-radio-group>
              </div>
            </div>
            <draggable class="tabbar-setting" :list="currentProp.goodsList">
              <div
                class="tabbar-setting-item"
                v-show="!v.isMock"
                v-for="(v, i) in currentProp.goodsList"
                :key="i"
              >
                <div class="delete-tab" @click="deleteCurrentGoods(i)">
                  <span class="hmicon icon-guanbi1"></span>
                </div>
                <div class="flex">
                  <div class="img-wrapper mr10">
                    <img :src="v.spuMainPic" alt="logo" style="width: 50px" />
                  </div>
                  <div class="goods-name">{{ v.wxshopSpuName }}</div>
                </div>
              </div>
            </draggable>
            <ul class="other-setting p20 border-bottom">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{
                    !currentProp.borderRadius ? "直角" : "圆角"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">{{
                    currentProp.titleBold ? "加粗体" : "常规体"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">页面边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </li>
              <li
                class="flex flex-between item-center"
                v-if="!currentProp.isSwiper"
              >
                <span class="mr20">图片边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.marginBottom"
                  ></el-slider>
                </div>
              </li>
            </ul>
            <ul class="other-setting p20">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品描述</span>
                  <span class="sub-title temp">{{
                    currentProp.showSubTitle ? "显示" : "隐藏"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showSubTitle"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品价格</span>
                  <span class="sub-title temp">{{
                    currentProp.showPrice ? "显示" : "隐藏"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showPrice"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
              <!-- <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">购买按钮</span>
                  <span class="sub-title temp">
                    {{ currentProp.showCart ? "显示" : "隐藏" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showCart"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>-->
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品销量</span>
                  <span class="sub-title temp">{{
                    currentProp.showSaleNum ? "显示" : "隐藏"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showSaleNum"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品角标</span>
                  <span class="sub-title temp">{{
                    currentProp.showLogo ? "显示" : "隐藏"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showLogo"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
            </ul>
            <div class="p20">
              <el-radio-group
                v-model="currentProp.logoType"
                v-if="currentProp.showLogo"
              >
                <el-radio label="HOT"></el-radio>
                <el-radio label="NEW"></el-radio>
                <el-radio label="秒杀"></el-radio>
                <el-radio label="自定义"></el-radio>
              </el-radio-group>
              <div v-if="currentProp.logoType === '自定义'">
                <span class="tips">上传图片建议尺寸120x120像素</span>
              </div>
              <div
                class="icon-wrapper"
                v-if="currentProp.logoType === '自定义'"
                :class="{ 'no-bg': !currentProp.logoUrl }"
                @click="changeLogoUrl()"
              >
                <img
                  :src="currentProp.logoUrl"
                  v-if="currentProp.logoUrl"
                  alt="图片广告"
                />
                <div class="change-icon">
                  {{ currentProp.logoUrl ? "更换图片" : "添加图片" }}
                </div>
              </div>
            </div>
          </div>
          <!-- 优惠券 -->
          <div
            class="coupon-setting"
            v-if="currentProp && currentProp.name === 'coupon'"
          >
            <div class="p20">
              <div class="title">优惠券</div>
              <div class="tips">最多添加10张优惠券</div>
            </div>
            <div class="item-setting">
              <div>
                选择模板
                <span>
                  {{ currentProp.type === "1" ? "样式一" : "样式二" }}
                </span>
              </div>
              <el-radio-group v-model="currentProp.type">
                <el-radio label="1">
                  <div
                    class="shape style1"
                    :class="{ active: currentProp.type === '1' }"
                  >
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="2">
                  <div
                    class="shape style2"
                    :class="{ active: currentProp.type === '2' }"
                  >
                    <div class="content"></div>
                  </div>
                </el-radio>
              </el-radio-group>
            </div>
            <div class="have-bg-wrapper">
              <el-button
                type="primary"
                @click="addCoupon('coupon')"
                plain
                size="small"
                class="w100"
                >添加优惠券</el-button
              >
            </div>
            <div class="settings">
              <div class="flex item-center settings-item">
                <div class="label">模块名称</div>
                <div class="flex-1">
                  <el-input
                    size="small"
                    v-model="currentProp.title"
                    placeholder="请输入模块名称"
                  ></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.titleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="flex item-center settings-item">
                <div class="label">副标题</div>
                <div class="flex-1">
                  <el-input
                    size="small"
                    v-model="currentProp.secTitle"
                    placeholder="请输入模块名称"
                  ></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.secTitleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="settings-item fill-bg">
                <div class="flex item-center">
                  <div class="label">填充背景</div>
                  <div>
                    <el-radio-group
                      v-model="currentProp.fillBgType"
                      @change="changeCouponFillType"
                    >
                      <el-radio label="custom">自定义颜色</el-radio>
                      <el-radio label="bgImage">上传背景图</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div style="margin-left: 64px; margin-top: 10px">
                  <el-color-picker
                    v-if="currentProp.fillBgType === 'custom'"
                    :predefine="predefine"
                    v-model="currentProp.bg"
                    size="mini"
                  ></el-color-picker>
                  <div
                    class="icon-wrapper"
                    v-if="currentProp.fillBgType === 'bgImage'"
                    :class="{ 'no-bg': !currentProp.bg }"
                    @click="changeCouponBg"
                  >
                    <img
                      :src="currentProp.bg"
                      class="img"
                      v-if="currentProp.bg"
                      alt="填充背景"
                    />
                    <div class="change-icon">
                      {{ currentProp.bg ? "更换背景" : "添加背景" }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="settings-item flex flex-between item-center">
                <span class="mr20">文字颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.color"
                  size="mini"
                ></el-color-picker>
              </div>
              <div class="settings-item">
                <div class="flex item-center">
                  <div class="label">券颜色</div>
                  <div>
                    <el-radio-group
                      v-model="currentProp.couponColorType"
                      @change="changeCouponColorType"
                    >
                      <el-radio label="default">默认全店风格</el-radio>
                      <el-radio label="custom">自定义</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div style="margin-left: 64px; margin-top: 10px">
                  <el-color-picker
                    v-if="currentProp.couponColorType === 'custom'"
                    :predefine="predefine"
                    v-model="currentProp.couponColor"
                    size="mini"
                  ></el-color-picker>
                </div>
              </div>
            </div>
          </div>
          <!-- 拼团 -->
          <div
            class="groupon-setting"
            v-if="currentProp && currentProp.name === 'groupon'"
          >
            <div class="p20">
              <div class="title">拼团</div>
            </div>
            <div class="item-setting top">
              <div>
                选择模板
                <span v-if="currentProp.type === '1'">横条样式</span>
                <span v-if="currentProp.type === '2'">块状样式</span>
                <span v-if="currentProp.type === '3'">横向滑动</span>
              </div>
              <el-radio-group v-model="currentProp.type">
                <el-radio label="1">
                  <div
                    class="shape style1"
                    :class="{ active: currentProp.type === '1' }"
                  >
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="2">
                  <div
                    class="shape style2"
                    :class="{ active: currentProp.type === '2' }"
                  >
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="3">
                  <div
                    class="shape style3"
                    :class="{ active: currentProp.type === '3' }"
                  >
                    <div class="content"></div>
                  </div>
                </el-radio>
              </el-radio-group>
            </div>
            <div class="have-bg-wrapper">
              <el-button
                type="primary"
                @click="addGroupon"
                plain
                size="small"
                class="w100"
                >添加拼团商品</el-button
              >
            </div>
            <div class="settings other-setting">
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">模块名称</div>
                <div class="flex-1">
                  <el-input
                    size="small"
                    v-model="currentProp.title"
                    placeholder="请输入模块名称"
                  ></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.titleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">副标题</div>
                <div class="flex-1">
                  <el-input
                    size="small"
                    v-model="currentProp.secTitle"
                    placeholder="请输入模块名称"
                  ></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.secTitleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="settings-item fill-bg">
                <div class="flex item-center">
                  <div class="label">填充背景</div>
                  <div>
                    <el-radio-group
                      v-model="currentProp.fillBgType"
                      @change="changeCouponFillType"
                    >
                      <el-radio label="custom">自定义颜色</el-radio>
                      <el-radio label="bgImage">上传背景图</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div style="margin-left: 64px; margin-top: 10px">
                  <el-color-picker
                    v-if="currentProp.fillBgType === 'custom'"
                    :predefine="predefine"
                    v-model="currentProp.bg"
                    size="mini"
                  ></el-color-picker>
                  <div
                    class="icon-wrapper"
                    v-if="currentProp.fillBgType === 'bgImage'"
                    :class="{ 'no-bg': !currentProp.bg }"
                    @click="changeCouponBg"
                  >
                    <img
                      :src="currentProp.bg"
                      class="img"
                      v-if="currentProp.bg"
                      alt="填充背景"
                    />
                    <div class="change-icon">
                      {{ currentProp.bg ? "更换背景" : "添加背景" }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="settings-item flex flex-between item-center">
                <span class="mr20">文字颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.color"
                  size="mini"
                ></el-color-picker>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{
                    !currentProp.borderRadius ? "直角" : "圆角"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">{{
                    currentProp.titleBold ? "加粗体" : "常规体"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <span class="mr20">页面间距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </div>
            </div>
          </div>
          <!-- 单人单次专享 -->
          <div
            class="groupon-setting"
            v-if="currentProp && currentProp.name === 'single-exclusive'"
          >
            <div class="p20">
              <div class="title">单人单次专享活动</div>
            </div>
            <div class="item-setting top">
              <div>
                选择模板
                <span v-if="currentProp.type === '1'">横条样式</span>
                <span v-if="currentProp.type === '2'">块状样式</span>
                <span v-if="currentProp.type === '3'">横向滑动</span>
              </div>
              <el-radio-group v-model="currentProp.type">
                <el-radio label="1">
                  <div
                    class="shape style1"
                    :class="{ active: currentProp.type === '1' }"
                  >
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="2">
                  <div
                    class="shape style2"
                    :class="{ active: currentProp.type === '2' }"
                  >
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="3">
                  <div
                    class="shape style3"
                    :class="{ active: currentProp.type === '3' }"
                  >
                    <div class="content"></div>
                  </div>
                </el-radio>
              </el-radio-group>
            </div>
            <div class="have-bg-wrapper">
              <el-button
                type="primary"
                @click="addSingleExclusive"
                plain
                size="small"
                class="w100"
                >添加专享商品</el-button
              >
            </div>
            <div class="settings other-setting">
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">模块名称</div>
                <div class="flex-1">
                  <el-input
                    size="small"
                    v-model="currentProp.title"
                    placeholder="请输入模块名称"
                  ></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.titleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">副标题</div>
                <div class="flex-1">
                  <el-input
                    size="small"
                    v-model="currentProp.secTitle"
                    placeholder="请输入模块名称"
                  ></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.secTitleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="settings-item fill-bg">
                <div class="flex item-center">
                  <div class="label">填充背景</div>
                  <div>
                    <el-radio-group
                      v-model="currentProp.fillBgType"
                      @change="changeCouponFillType"
                    >
                      <el-radio label="custom">自定义颜色</el-radio>
                      <el-radio label="bgImage">上传背景图</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div style="margin-left: 64px; margin-top: 10px">
                  <el-color-picker
                    v-if="currentProp.fillBgType === 'custom'"
                    :predefine="predefine"
                    v-model="currentProp.bg"
                    size="mini"
                  ></el-color-picker>
                  <div
                    class="icon-wrapper"
                    v-if="currentProp.fillBgType === 'bgImage'"
                    :class="{ 'no-bg': !currentProp.bg }"
                    @click="changeCouponBg"
                  >
                    <img
                      :src="currentProp.bg"
                      class="img"
                      v-if="currentProp.bg"
                      alt="填充背景"
                    />
                    <div class="change-icon">
                      {{ currentProp.bg ? "更换背景" : "添加背景" }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="settings-item flex flex-between item-center">
                <span class="mr20">文字颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.color"
                  size="mini"
                ></el-color-picker>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{
                    !currentProp.borderRadius ? "直角" : "圆角"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">{{
                    currentProp.titleBold ? "加粗体" : "常规体"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <span class="mr20">页面间距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </div>
            </div>
          </div>
          <!-- 秒杀 -->
          <div
            class="groupon-setting"
            v-if="currentProp && currentProp.name === 'seckill'"
          >
            <div class="p20">
              <div class="title">秒杀</div>
            </div>
            <div class="item-setting top">
              <div>
                选择模板
                <span v-if="currentProp.type === '1'">横条样式</span>
                <span v-if="currentProp.type === '2'">块状样式</span>
                <span v-if="currentProp.type === '3'">横向滑动</span>
              </div>
              <el-radio-group v-model="currentProp.type">
                <el-radio label="1">
                  <div
                    class="shape style1"
                    :class="{ active: currentProp.type === '1' }"
                  >
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="2">
                  <div
                    class="shape style2"
                    :class="{ active: currentProp.type === '2' }"
                  >
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="3">
                  <div
                    class="shape style3"
                    :class="{ active: currentProp.type === '3' }"
                  >
                    <div class="content"></div>
                  </div>
                </el-radio>
              </el-radio-group>
            </div>
            <div class="have-bg-wrapper">
              <el-button
                type="primary"
                @click="addSeckill"
                plain
                size="small"
                class="w100"
                >添加秒杀商品</el-button
              >
            </div>
            <div class="settings other-setting">
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">模块名称</div>
                <div class="flex-1">
                  <el-input
                    size="small"
                    v-model="currentProp.title"
                    placeholder="请输入模块名称"
                  ></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.titleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">副标题</div>
                <div class="flex-1">
                  <el-input
                    size="small"
                    v-model="currentProp.secTitle"
                    placeholder="请输入模块名称"
                  ></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.secTitleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="settings-item fill-bg">
                <div class="flex item-center">
                  <div class="label">填充背景</div>
                  <div>
                    <el-radio-group
                      v-model="currentProp.fillBgType"
                      @change="changeCouponFillType"
                    >
                      <el-radio label="custom">自定义颜色</el-radio>
                      <el-radio label="bgImage">上传背景图</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div style="margin-left: 64px; margin-top: 10px">
                  <el-color-picker
                    v-if="currentProp.fillBgType === 'custom'"
                    :predefine="predefine"
                    v-model="currentProp.bg"
                    size="mini"
                  ></el-color-picker>
                  <div
                    class="icon-wrapper"
                    v-if="currentProp.fillBgType === 'bgImage'"
                    :class="{ 'no-bg': !currentProp.bg }"
                    @click="changeCouponBg"
                  >
                    <img
                      :src="currentProp.bg"
                      class="img"
                      v-if="currentProp.bg"
                      alt="填充背景"
                    />
                    <div class="change-icon">
                      {{ currentProp.bg ? "更换背景" : "添加背景" }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="settings-item flex flex-between item-center">
                <span class="mr20">文字颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.color"
                  size="mini"
                ></el-color-picker>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{
                    !currentProp.borderRadius ? "直角" : "圆角"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">{{
                    currentProp.titleBold ? "加粗体" : "常规体"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <span class="mr20">页面间距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </div>
            </div>
          </div>
          <!-- 砍价 -->
          <div
            class="groupon-setting"
            v-if="currentProp && currentProp.name === 'bargain'"
          >
            <div class="p20">
              <div class="title">砍价</div>
            </div>
            <div class="item-setting top">
              <div>
                选择模板
                <span v-if="currentProp.type === '1'">横条样式</span>
                <span v-if="currentProp.type === '2'">块状样式</span>
                <span v-if="currentProp.type === '3'">横向滑动</span>
              </div>
              <el-radio-group v-model="currentProp.type">
                <el-radio label="1">
                  <div
                    class="shape style1"
                    :class="{ active: currentProp.type === '1' }"
                  >
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="2">
                  <div
                    class="shape style2"
                    :class="{ active: currentProp.type === '2' }"
                  >
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="3">
                  <div
                    class="shape style3"
                    :class="{ active: currentProp.type === '3' }"
                  >
                    <div class="content"></div>
                  </div>
                </el-radio>
              </el-radio-group>
            </div>
            <div class="have-bg-wrapper">
              <el-button
                type="primary"
                @click="addBargain"
                plain
                size="small"
                class="w100"
                >添加砍价商品</el-button
              >
            </div>
            <div class="settings other-setting">
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">模块名称</div>
                <div class="flex-1">
                  <el-input
                    size="small"
                    v-model="currentProp.title"
                    placeholder="请输入模块名称"
                  ></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.titleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">副标题</div>
                <div class="flex-1">
                  <el-input
                    size="small"
                    v-model="currentProp.secTitle"
                    placeholder="请输入模块名称"
                  ></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.secTitleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="settings-item fill-bg">
                <div class="flex item-center">
                  <div class="label">填充背景</div>
                  <div>
                    <el-radio-group
                      v-model="currentProp.fillBgType"
                      @change="changeCouponFillType"
                    >
                      <el-radio label="custom">自定义颜色</el-radio>
                      <el-radio label="bgImage">上传背景图</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div style="margin-left: 64px; margin-top: 10px">
                  <el-color-picker
                    v-if="currentProp.fillBgType === 'custom'"
                    :predefine="predefine"
                    v-model="currentProp.bg"
                    size="mini"
                  ></el-color-picker>
                  <div
                    class="icon-wrapper"
                    v-if="currentProp.fillBgType === 'bgImage'"
                    :class="{ 'no-bg': !currentProp.bg }"
                    @click="changeCouponBg"
                  >
                    <img
                      :src="currentProp.bg"
                      class="img"
                      v-if="currentProp.bg"
                      alt="填充背景"
                    />
                    <div class="change-icon">
                      {{ currentProp.bg ? "更换背景" : "添加背景" }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="settings-item flex flex-between item-center">
                <span class="mr20">文字颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.color"
                  size="mini"
                ></el-color-picker>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{
                    !currentProp.borderRadius ? "直角" : "圆角"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">{{
                    currentProp.titleBold ? "加粗体" : "常规体"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <span class="mr20">页面间距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </div>
            </div>
          </div>
          <!-- 直播 -->
          <div
            class="groupon-setting live-setting"
            v-if="currentProp && currentProp.name === 'live'"
          >
            <div class="p20">
              <div class="title">直播</div>
            </div>
            <div class="item-setting top">
              <div>
                选择模板
                <span v-if="currentProp.type === '1'">大图</span>
                <span v-if="currentProp.type === '2'">二宫格</span>
                <span v-if="currentProp.type === '3'">单宫格</span>
              </div>
              <el-radio-group v-model="currentProp.type">
                <el-radio label="1">
                  <div
                    class="shape style1"
                    :class="{ active: currentProp.type === '1' }"
                  >
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="2">
                  <div
                    class="shape style2"
                    :class="{ active: currentProp.type === '2' }"
                  >
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="3">
                  <div
                    class="shape style3"
                    :class="{ active: currentProp.type === '3' }"
                  >
                    <div class="content"></div>
                  </div>
                </el-radio>
              </el-radio-group>
            </div>
            <div class="have-bg-wrapper">
              <el-button
                type="primary"
                @click="addLiveRoom"
                plain
                size="small"
                class="w100"
                >添加直播间</el-button
              >
            </div>
            <div class="settings other-setting">
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">模块名称</div>
                <div class="flex-1">
                  <el-input
                    size="small"
                    v-model="currentProp.title"
                    placeholder="请输入模块名称"
                  ></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.titleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">副标题</div>
                <div class="flex-1">
                  <el-input
                    size="small"
                    v-model="currentProp.secTitle"
                    placeholder="请输入模块名称"
                  ></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.secTitleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{
                    !currentProp.borderRadius ? "直角" : "圆角"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">{{
                    currentProp.titleBold ? "加粗体" : "常规体"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <span class="mr20">页面间距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </div>
            </div>
          </div>
          <!-- 图片热区 -->
          <div
            class="groupon-setting"
            v-if="currentProp && currentProp.name === 'hotZone'"
          >
            <div class="p20">
              <div class="title">图片热区</div>
              <div class="tips">
                <span style="color: #e50065">点击预览区图片</span
                >，待鼠标变成十字后，在图片上拖拽划分区域以添加链接地址
              </div>
            </div>

            <div class="have-bg-wrapper tabbar-setting">
              <div
                class="hotzone-img-wrapper pointer"
                @click="uploadHotZoneImage"
              >
                <img :src="currentProp.image" alt="plus会员背景" />
                <div class="tip">更换热区图</div>
              </div>
              <div
                class="tabbar-setting-item"
                v-for="(v, i) in currentProp.zones"
                :key="i"
              >
                <!-- <div class="delete-tab" @click="handleRemoveZone(i)">
                  <span class="hmicon icon-guanbi1"></span>
                </div> -->
                <div class="flex-1">
                  <div class="flex item-center">
                    <div class="mr10 bold title">热区{{ i + 1 }}</div>
                  </div>
                  <div class="flex item-center" style="padding: 10px 0">
                    <span class="mr10">类型</span>
                    <el-radio-group
                      v-model="v.pageType"
                      class="flex-1"
                      style="line-height: 18px"
                      @change="openGoodsSelect(v, i, 'zones')"
                    >
                      <el-radio label="page">页面</el-radio>
                      <el-radio label="goods">商品</el-radio>
                      <el-radio label="brand">品牌</el-radio>
                      <el-radio label="mp">小程序</el-radio>
                      <el-radio label="channels">视频号</el-radio>
                      <el-radio label="live">直播间</el-radio>
                      <el-radio label="activityCenter">营销活动</el-radio>
                      <el-radio label="coupon">优惠券</el-radio>
                      <el-radio label="qyWeChat">企微客服</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="flex item-center" v-if="v.pageType === 'page'">
                    <span class="mr10">链接</span>
                    <el-select
                      class="flex-1"
                      size="small"
                      clearable
                      placeholder="选择页面"
                      v-if="!v.groupGoods.groupId"
                      v-model="v.hrefAddress"
                      @change="selectGroup($event, i, 'zones')"
                      allow-create
                      filterable
                    >
                      <el-option
                        v-for="(item, index) in microShopRouteList"
                        :key="index"
                        :label="item.hrefName"
                        :value="item.hrefAddress"
                      ></el-option>
                    </el-select>
                    <div class="flex item-center" v-if="v.groupGoods.groupId">
                      <span>分组：</span>
                      <el-tag
                        closable
                        @close="handleCloseGroup('zones', i)"
                        type="success"
                        >{{ v.groupGoods.groupName }}</el-tag
                      >
                    </div>
                  </div>
                  <div
                    class="flex item-center"
                    v-if="v.pageType === 'goods' && v.goodsInfo.wxshopSpuName"
                  >
                    <span class="mr10">商品</span>
                    <el-tag
                      closable
                      @close="handleClose(v, i)"
                      type="success"
                      >{{ v.goodsInfo.wxshopSpuName }}</el-tag
                    >
                  </div>
                  <div
                    class="flex item-center"
                    v-if="
                      v.pageType === 'brand' &&
                      v.brandInfo &&
                      v.brandInfo.brandName
                    "
                  >
                    <span class="mr10">品牌</span>
                    <el-tag
                      closable
                      @close="handleClose(v, i)"
                      type="success"
                      >{{ v.brandInfo.brandName }}</el-tag
                    >
                  </div>
                  <template v-if="v.pageType === 'mp'">
                    <div class="flex item-center mb20">
                      <span class="mr10">appid</span>
                      <el-input
                        class="flex-1"
                        size="small"
                        v-model="v.appid"
                        type="text"
                        placeholder="请输入appid"
                      ></el-input>
                    </div>
                    <div class="flex item-center">
                      <span style="width: 34px" class="mr10">链接</span>
                      <el-input
                        class="flex-1"
                        v-model="v.hrefAddress"
                        size="small"
                        type="text"
                        placeholder="请输入链接"
                      ></el-input>
                    </div>
                  </template>
                  <template v-if="v.pageType === 'channels'">
                    <div class="flex item-center mb10">
                      <span class="mr10">视频号主页ID</span>
                    </div>
                    <div class="flex item-center mb20">
                      <el-input
                        class="flex-1"
                        size="small"
                        v-model="v.profile"
                        type="text"
                        placeholder="请输入主页ID"
                      ></el-input>
                    </div>
                    <div class="flex item-center mb10">
                      <span class="mr10">视频号视频ID</span>
                    </div>
                    <div class="flex item-center mb20">
                      <el-input
                        class="flex-1"
                        v-model="v.activity"
                        size="small"
                        type="text"
                        placeholder="请输入视频ID"
                      ></el-input>
                    </div>
                  </template>
                  <template v-if="v.pageType === 'live'">
                    <div class="flex item-center mb10" 
                      v-if="v.liveList.length>0">
                      <span class="mr10">直播间</span>
                    </div>
                    <el-tag
                      closable
                      @close="handleClose(v, i)"
                      type="success"
                      v-if="v.liveList.length>0"
                      >{{ v.liveList[0].roomName }}</el-tag
                    >
                  </template>
                  <template v-if="v.pageType === 'activityCenter'">
                    <div class="flex item-center mb10" 
                      v-if="v.activityInfo.gameId">
                      <span class="mr10">营销活动</span>
                    </div>
                    <el-tag
                      closable
                      @close="handleClose(v, i)"
                      type="success"
                      v-if="v.activityInfo.gameId"
                      >{{ v.activityInfo.gameName }}</el-tag
                    >
                  </template>
                  <template v-if="v.pageType === 'qyWeChat'">
                    <div class="flex item-center">
                      <span style="width: 34px" class="mr10">链接</span>
                      <el-input
                        class="flex-1"
                        v-model="v.src"
                        size="small"
                        type="text"
                        placeholder="请输入链接"
                      ></el-input>
                    </div>
                  </template>
                  <template v-if="v.pageType === 'coupon'">
                    <div class="have-bg-wrapper">
                      <el-button
                        type="primary"
                        @click="addCoupon('HotZone')"
                        plain
                        size="small"
                        class="w100"
                        >添加优惠券</el-button
                      >
                    </div>
                    <div class="coupon-list">
                      <div
                        class="coupon-item flex"
                        v-for="(item, index) in v.couponList"
                        :key="index"
                      >
                        <div
                          class="delete-tab"
                          @click="deleteCurrentCoupon(i, index)"
                        >
                          <span class="hmicon icon-guanbi1"></span>
                        </div>
                        <div
                          class="
                            price-wrapper
                            flex flex-column flex-center
                            item-center
                          "
                          :style="{
                            background: storeStyle.baseColor,
                          }"
                        >
                          <div class="price" v-if="!item.discount">
                            {{ item.account }}
                          </div>
                          <div class="discount" v-if="item.discount">
                            {{ item.discount }}
                          </div>
                          <div>
                            <div class="limit">满{{ item.levelMin }}使用</div>
                          </div>
                        </div>
                        <div class="flex-1 info flex flex-column flex-center">
                          <div class="name">{{ item.name }}</div>
                          <div class="valid-time">
                            有效期：{{ item.dateTime }}
                          </div>
                          <div>
                            <button
                              :style="{ background: storeStyle.baseColor }"
                              class="btn round"
                            >
                              立即领取
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 开启全局设置按钮 -->
      <div
        class="page-setting-btn"
        @click="openPageSetting"
        :class="{ active: showPageSetting }"
      >
        <span class="hmicon icon-yemianshezhi"></span>
        <span>页面设置</span>
      </div>
    </div>
    <my-upload
      field="file"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="show"
      v-if="show"
      noCircle
      noSquare
      :width="uploadWidth"
      :height="uploadHeight"
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'mallDecoration' }"
      :url="$uploadUrl"
      img-format="png"
    ></my-upload>
    <hm-filter-micro-shop-goods
      type="microShop"
      :visible="dialogVisible"
      :radio="isRadio"
      :isdailydeals="true"
      @saveGoods="saveGoods"
      @setLink="setLink"
      @close="dialogVisible = false"
    ></hm-filter-micro-shop-goods>
    <hm-filter-micro-shop-goods-daily-deals
      :visible="dailyDealsVisible"
      :radio="isRadioDailyDeals"
      @dailyDealsList2="dailyDealsList2"
      @saveGoods="saveDailyDeals"
      @close="dailyDealsVisible = false"
    ></hm-filter-micro-shop-goods-daily-deals>
    <hm-filter-micro-shop-goods-daily-news
      :visible="dailyNewsVisible"
      :radio="isRadioDailyNews"
      @dailyNewsList2="dailyNewsList2"
      @saveGoods="saveDailyNews"
      @close="dailyNewsVisible = false"
    ></hm-filter-micro-shop-goods-daily-news>
    <hm-filter-group-goods
      @saveGroupGoods="saveGroupGoods"
      @close="groupGoodsVisible = false"
      :visible="groupGoodsVisible"
    ></hm-filter-group-goods>
    <hm-filter-hot
      @saveHotGoods="saveHotGoods"
      @saveGroupGoods="saveGroupGoods"
      @close="hotVisible = false"
      :visible="hotVisible"
    ></hm-filter-hot>
    <hm-filter-coupon
      :visible="selectCouponVisible"
      @saveCoupon="saveCoupon"
      @close="selectCouponVisible = false"
    ></hm-filter-coupon>
    <hm-filter-live
      :visible="selectLiveVisible"
      @saveLive="saveLive"
      @close="selectLiveVisible = false"
    ></hm-filter-live>
    <hm-filter-live-radio
      :visible="selectLiveVisibleRadio"
      @saveLive="saveLiveRadio"
      @close="selectLiveVisibleRadio = false"
    ></hm-filter-live-radio>
    <hm-filter-activity-center
      :visible="selectActivityVisible"
      @saveActivityCenter="saveActivityCenter"
      @close="selectActivityVisible = false"
    ></hm-filter-activity-center>
    <hm-filter-bargain
      :visible="selectBargainVisible"
      @saveBargain="saveBargain"
      @close="selectBargainVisible = false"
    ></hm-filter-bargain>
    <hm-filter-seckill
      :visible="selectSeckillVisible"
      @saveSeckill="saveSeckill"
      @close="selectSeckillVisible = false"
    ></hm-filter-seckill>
    <hm-filter-single-exclusive
      :visible="selectSingleExclusiveVisible"
      @saveSingleExclusive="saveSingleExclusive"
      @close="selectSingleExclusiveVisible = false"
    ></hm-filter-single-exclusive>
    <hm-filter-groupon
      :visible="selectGrouponVisible"
      @saveGroupon="saveGroupon"
      @close="selectGrouponVisible = false"
    ></hm-filter-groupon>
    <hm-filter-brand
      @saveBrand="saveBrand"
      @close="brandVisible = false"
      :visible="brandVisible"
    ></hm-filter-brand>
    <hm-upload
      :hmUploadVisible="hmUploadVisible"
      @cancleUpload="cancleUpload"
      @hmUploadSuccess="hmUploadSuccess"
      :isUploadVideo="isUploadVideo"
    ></hm-upload>
  </div>
</template>

<script>
/* eslint vue/no-unused-components: [0] */
import { getLoginUser } from "@/utils/auth";
import { hmComponents, tabBarList, predefine } from "@/utils/tempData";
import html2canvas from "html2canvas";
import draggable from "vuedraggable";
import myUpload from "vue-image-crop-upload";
import HmUpload from "@/components/HmUpload";
import HmRichEditor from "@/components/HmRichEditor";
import tabBar from "@/components/HmMallComponent/tabBar";
import search from "@/components/HmMallComponent/search";
import notice from "@/components/HmMallComponent/notice";
import contactUs from "@/components/HmMallComponent/contactUs";
import dividingLine from "@/components/HmMallComponent/dividingLine";
import richText from "@/components/HmMallComponent/richText";
import titleText from "@/components/HmMallComponent/titleText";
import imageAdSelection from "@/components/HmMallComponent/imageAdSelection";
import imageTextNav from "@/components/HmMallComponent/imageTextNav";
import goodsList from "@/components/HmMallComponent/goodsList";
import dailydeals from "@/components/HmMallComponent/dailydeals";
import dailynews from "@/components/HmMallComponent/dailynews";
import composite from "@/components/HmMallComponent/composite";
import jielong from "@/components/HmMallComponent/jielong";
import coupon from "@/components/HmMallComponent/coupon";
import groupon from "@/components/HmMallComponent/groupon";
import seckill from "@/components/HmMallComponent/seckill";
import bargain from "@/components/HmMallComponent/bargain";
import singleExclusive from "@/components/HmMallComponent/singleExclusive";
import live from "@/components/HmMallComponent/live";
import guessYouLike from "@/components/HmMallComponent/guessYouLike";
import tabs from "@/components/HmMallComponent/tabs";
import hot from "@/components/HmMallComponent/hot";
import cube from "@/components/HmMallComponent/cube";
import HotZone from "@/components/hotZone/Hotzone";
import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
import HmFilterMicroShopGoodsDailyDeals from "@/components/HmFilterMicroShopGoodsDailyDeals";
import HmFilterMicroShopGoodsDailyNews from "@/components/HmFilterMicroShopGoodsDailyNews";
import HmFilterGroupGoods from "@/components/HmFilterGroupGoods";
import HmFilterBrand from "@/components/HmFilterBrand";
import HmFilterCoupon from "@/components/HmFilterCoupon";
import HmFilterBargain from "@/components/HmFilterBargain";
import HmFilterGroupon from "@/components/HmFilterGroupon";
import HmFilterSeckill from "@/components/HmFilterSeckill";
import HmFilterLive from "@/components/HmFilterLive";
import HmFilterLiveRadio from "@/components/HmFilterLiveRadio";
import HmFilterSingleExclusive from "@/components/HmFilterSingleExclusive";
import HmFilterHot from "@/components/HmFilterHot";
import HmFilterActivityCenter from "@/components/HmFilterActivityCenter";
import { mapGetters } from "vuex";
export default {
  name: "custom-clone",
  display: "Clone",
  order: 2,
  components: {
    tabBar,
    draggable,
    tabs,
    hot,
    search,
    contactUs,
    groupon,
    dividingLine,
    myUpload,
    HmUpload,
    notice,
    richText,
    HmRichEditor,
    titleText,
    imageAdSelection,
    imageTextNav,
    goodsList,
    dailydeals,
    dailynews,
    composite,
    cube,
    seckill,
    bargain,
    live,
    guessYouLike,
    singleExclusive,
    HmFilterMicroShopGoods,
    HmFilterMicroShopGoodsDailyDeals,
    HmFilterMicroShopGoodsDailyNews,
    HmFilterGroupGoods,
    HmFilterBrand,
    HmFilterCoupon,
    HmFilterLive,
    HmFilterLiveRadio,
    HmFilterBargain,
    HmFilterGroupon,
    HmFilterSeckill,
    HmFilterSingleExclusive,
    HmFilterHot,
    HotZone,
    coupon,
    HmFilterActivityCenter,
    jielong
  },
  data() {
    return {
      showUploadLocalVideo: false,
      maxUploadSize: "",
      pageConfig: {
        fillBgType: "custom",
        titleColor: "#2b2b2b",
        titleBold: false,
        topBgImg:
          "https://imgcdn.hemiao100.com/hemiaoBase/a490012bc5491ffa93dc5a82fb3417e.png",
        isShowSearchBox: true,
        tabBarSet: "customize",
        // fixedType: "custom",
      },
      isUploadVideo: false,
      imgAdSelectionUpLoadType: "leftImgList",
      selectLiveVisible: false,
      selectLiveVisibleRadio: false,
      selectActivityVisible: false,
      selectCouponVisible: false,
      selectBargainVisible: false,
      selectGrouponVisible: false,
      selectSeckillVisible: false,
      selectSingleExclusiveVisible: false,
      brandVisible: false,
      tabList: [],
      hotList: [],
      groupGoodsVisible: false,
      hmUploadVisible: false,
      isRadio: false,
      isRadioDailyDeals: false,
      isRadioDailyNews: false,
      addDailyNewsType: "",
      scrollGt100: false,
      goodsType: "",
      pageType: "",
      pageModel: "",
      layoutId: "",
      currentImageAd: "",
      currentIndex: "",
      currentParams: "",
      uploadType: "",
      uploadWidth: 20,
      uploadHeight: 20,
      predefine,
      showPageSetting: true,
      dialogVisible: false,
      dailyDealsVisible: false,
      dailyNewsVisible: false,
      show: false,
      title: "微页面标题",
      hotWord: "",
      activePreviewIndex: "",
      currentProp: {},
      currentTab: "",
      currentTabIconType: "",
      tabBarList,
      hmComponents,
      allComponents: [],
      previewComponents: [],
      currentLinkIndex: "",
      currentLinkPropName: "",
      selectGroupGoodsType: "",
      hotVisible: false,
      isdailydeals: false,
      goodsSnList: "",
      dailyDealsList: [],
      selectLiveRadio: false,
      specialMoreList:[
        {
          label: "特价商品列表",
          value: "/pages/product/list?from=dailydeals",
        },
        {
          label: "特价专题页",
          value: "/activity/special/specialList",
        }
      ],
      
    };
  },
  computed: mapGetters(["tempDetails", "microShopRouteList", "storeStyle"]),
  watch: {
    tempDetails(val) {
      this.title = val.pageTitle || "微页面标题";
      if (val.pageConfig) {
        this.pageConfig = JSON.parse(val.pageConfig) || this.pageConfig;
        if (!this.pageConfig.fillBgType) {
          this.pageConfig.fillBgType = "custom";
          this.pageConfig.bg = "#f5f5f5";
        }
        if(!this.pageConfig.tabBarSet){
          this.pageConfig.tabBarSet = 'customize';
        }
        this.pageConfig = JSON.parse(JSON.stringify(this.pageConfig));
      }
      this.previewComponents = val.previewComponents
        ? JSON.parse(val.previewComponents)
        : [];
      console.log("this.previewComponents: ", this.previewComponents);
      this.previewComponents.forEach((v) => {
        if (v.component === "hotZone") {
          v.prop.zonesInit = v.prop.zones;
        }
      });
      if (val.tabBarList) {
        this.tabBarList = JSON.parse(val.tabBarList);
      }
    },
    "currentProp.goodShowType": {
      handler(val) {
        if (val) {
          switch (val) {
            case "big":
              this.type = "大图";
              break;
            case "twoColumn":
              this.type = "一行两个";
              break;
            case "scroll":
              this.type = "横向滑动";
              break;
            default:
              break;
          }
        }
      },
      deep: true,
    },
    "currentProp.permutation": {
      handler(val) {
        if (val) {
          this.calcCubeList(val);
        }
      },
      deep: true,
    },
    "currentProp.type": {
      handler(val) {
        console.log("val: ", val);
        if (val) {
          this.currentProp.url = "";
        }
      },
      deep: true,
    },
    "currentProp.isSwiper": {
      handler(val) {
        if (val) {
          this.currentProp.marginBottom = 0;
        }
      },
      deep: true,
    },
  },
  created() {
    this.pageType = this.$route.query.pageType;
    this.pageModel = this.$route.query.pageModel;
    this.layoutId = this.$route.query.layoutId;
    this.mode = this.$route.query.mode;
    if (
      (this.pageModel === "customize" && this.layoutId) ||
      this.pageModel === "default"
    ) {
      this.$store.dispatch("queryTempDetails", {
        pageType: this.pageType,
        pageModel: this.pageModel,
        layoutId: this.layoutId,
      });
    }
    this.queryCanUploadLocalVideo();
    this.$store.dispatch("queryMicroShopList", {
      pageType: "page",
    });
    this.$store.dispatch("queryStoreStyle");
  },
  mounted() {
    this.handelScroll();
  },
  methods: {
    changePageBg() {
      this.pageConfig.bg = "";
      this.$forceUpdate();
    },
    changePageBgImage() {
      this.hmUploadVisible = true;
      this.uploadType = "pageConfigBg";
    },
    changeBgColor() {
      this.$forceUpdate();
    },
    handelScroll() {
      let scrollbarEl = this.$refs.scrollbar.wrap;
      scrollbarEl.onscroll = () => {
        if (scrollbarEl.scrollTop > 100) {
          this.scrollGt100 = true;
        } else {
          this.scrollGt100 = false;
        }
      };
    },
    async queryCanUploadLocalVideo() {
      const { storeCode } = getLoginUser();
      const { result } = await this.$store.dispatch(
        "queryStoreInterFaceTextInfo",
        {
          code: "uploadVideo",
          storeCode,
        }
      );
      if (result) {
        this.showUploadLocalVideo = true;
        this.maxUploadSize = result.value;
      }
    },
    changeVideoType() {
      this.currentProp.src = "";
    },
    upLoadVideo() {
      this.isUploadVideo = true;
      this.uploadType = "video";
      this.hmUploadVisible = true;
    },
    handleAddZone(zone) {
      if (this.currentProp.zones) {
        this.$set(zone, "goodsInfo", {});
        this.$set(zone, "hrefAddress", "");
        this.$set(zone, "groupGoods", {});
        this.$set(zone, "appid", "");
        this.$set(zone, "profile", "");
        this.$set(zone, "activity", "");
        this.$set(zone, "roomId", "");
        this.$set(zone, "activityInfo", {});
        this.$set(zone, "liveList", []);
        this.$set(zone, "couponList", []);
        this.currentProp.zones.push(zone);
        this.currentProp.zonesInit = this.currentProp.zones;
      }
    },
    handleRemoveZone(index) {
      if (this.currentProp.zones) {
        this.currentProp.zones.splice(index, 1);
        this.currentProp.zonesInit = this.currentProp.zones;
      }
    },
    handleChangeZone() {},
    uploadHotZoneImage() {
      this.uploadType = "hotZoneImage";
      this.hmUploadVisible = true;
    },
    switchImageAdTemp(type) {
      if (type === "5") {
        this.imgAdSelectionUpLoadType = "leftImgList";
        if(!this.currentProp.leftImgList){
          this.currentProp.leftImgList = [];
        }
        if (!this.currentProp.rightImgList) {
          this.currentProp.rightImgList = [];
        }
        if (!this.currentProp.rightImgList2) {
          this.currentProp.rightImgList2 = [];
        }
      }else if (type === "3") {
        this.imgAdSelectionUpLoadType = "leftImgList";
        if (this.currentProp.imgList.length) {
          this.currentProp.leftImgList = this.currentProp.imgList;
        } else {
          this.currentProp.leftImgList = [];
        }

        if (!this.currentProp.rightImgList) {
          this.currentProp.rightImgList = [];
        }
      } else {
        if (this.currentProp.leftImgList.length) {
          this.currentProp.imgList = this.currentProp.leftImgList;
        }
      }
      this.$forceUpdate();
    },
    changeCouponBg() {
      this.hmUploadVisible = true;
      this.uploadType = "coupon";
    },
    saveLive(data) {
      console.log(data);
      if (this.currentLinkIndex !== -1) {
        if(this.selectLiveRadio){
          this.currentProp[this.currentLinkPropName][
            this.currentLinkIndex
          ].liveList = data;
          this.currentProp[this.currentLinkPropName][
            this.currentLinkIndex
          ].roomId = data[0].roomId;
        }else{
          this.currentProp.liveList = data;
        }
      } else {
        this.currentProp.liveList = data;
      }
      this.selectLiveVisible = false;
    },
    saveLiveRadio(data) {
      console.log(data);
      if (this.currentLinkIndex !== -1) {
        this.currentProp[this.currentLinkPropName][
          this.currentLinkIndex
        ].liveList = data;
        this.currentProp[this.currentLinkPropName][
          this.currentLinkIndex
        ].roomId = data[0].roomId;
      } else {
        this.currentProp.liveList = data;
      }
      this.selectLiveVisibleRadio = false;
    },   
    addLiveRoom() {
      this.selectLiveRadio = false;
      this.selectLiveVisible = true;
    },
    saveCoupon(data) {
      if (this.selsectCouponType === "coupon") {
        this.currentProp.couponList = data;
      } else if (this.selsectCouponType === "HotZone") {
        this.currentProp[this.currentLinkPropName][
          this.currentLinkIndex
        ].couponList = data;
        console.log("data: ", data);
        console.log("this.currentLinkIndex: ", this.currentLinkIndex);
        console.log("this.currentLinkPropName: ", this.currentLinkPropName);
      }
      this.selectCouponVisible = false;
    },
    saveSeckill(data) {
      this.selectSeckillVisible = false;
      this.currentProp.seckillList = data;
    },
    saveBargain(data) {
      this.selectBargainVisible = false;
      this.currentProp.bargainList = data;
    },
    saveSingleExclusive(data) {
      this.selectSingleExclusiveVisible = false;
      this.currentProp.singleExclusiveList = data;
    },
    saveGroupon(data) {
      this.selectGrouponVisible = false;
      this.currentProp.grouponList = data;
    },
    addCoupon(type) {
      this.selsectCouponType = type;
      this.selectCouponVisible = true;
    },
    addGroupon() {
      this.selectGrouponVisible = true;
    },
    addSingleExclusive() {
      this.selectSingleExclusiveVisible = true;
    },
    addBargain() {
      this.selectBargainVisible = true;
    },
    addSeckill() {
      this.selectSeckillVisible = true;
    },
    changeCouponColorType() {
      this.currentProp.couponColor = "";
    },
    changeCouponFillType() {
      this.currentProp.bg = "";
    },
    addTabsGroupGoods(i) {
      this.groupGoodsVisible = true;
      this.selectGroupGoodsType = "tabs";
      this.currentIndex = i;
    },
    addHotGroupGoods(i) {
      this.hotVisible = true;
      this.selectGroupGoodsType = "hot";
      this.currentIndex = i;
    },
    addTabNav() {
      this.currentProp.tabList.push({
        tabTitle: "",
        appid: "",
        profile: "",
        activity: "",
        roomId: "",
        liveList: [],
        activityInfo: {},
        hrefAddress: "",
        groupGoods: {},
      });
    },
    addHotNav() {
      this.currentProp.hotList.push({
        hotTitle: "",
        appid: "",
        profile: "",
        activity: "",
        roomId: "",
        liveList: [],
        activityInfo: {},
        hrefAddress: "",
        groupGoods: {},
        watermark: "",
      });
    },
    deleteCurrentTabs(i) {
      this.currentProp.tabList.splice(i, 1);
      this.$refs.singleComponent[this.activePreviewIndex].goodsList = [];
    },
    deleteCurrentHot(i) {
      this.currentProp.hotList.splice(i, 1);
      this.$refs.singleComponent[this.activePreviewIndex].goodsList = [];
    },
    handleCloseGroup(prop, index) {
      if (!index && index !== 0) {
        this.currentProp.groupGoods = {};
        this.currentProp.hrefAddress = "";
      } else {
        this.currentProp[prop][index].groupGoods = {};
        this.currentProp[prop][index].hrefAddress = "";
      }
    },
    saveGroupGoods(row) {
      console.log("row");
      console.log(row);
      console.log("this.selectGroupGoodsType");
      console.log(this.selectGroupGoodsType);
      this.groupGoodsVisible = false;
      if (!this.selectGroupGoodsType) {
        if (!this.currentIndex && this.currentIndex !== 0) {
          this.currentProp.groupGoods = row;
        } else {
          this.currentProp[this.currentParams][this.currentIndex].groupGoods =
            row;
          this.currentIndex = "";
          this.currentParams = "";
        }
      } else if (this.selectGroupGoodsType === "tabBarList") {
        this.tabBarList[this.currentIndex].groupGoods = row;
        this.currentIndex = "";
        this.selectGroupGoodsType = "";
      } else if (this.selectGroupGoodsType === "tabs") {
        console.log("this.tabs");
        console.log(this.$refs.singleComponent);
        console.log(this.activePreviewIndex);
        this.currentProp.tabList[this.currentIndex].groupGoods = row;
        this.$refs.singleComponent[this.activePreviewIndex].changeTabTabs(
          this.currentIndex
        );
        this.currentIndex = "";
        this.selectGroupGoodsType = "";
      } else if(this.selectGroupGoodsType === "hot")
      {
        this.hotVisible = false;
        console.log("hot123");
        this.currentProp.hotList[this.currentIndex].groupGoods = row;
        this.$refs.singleComponent[this.activePreviewIndex].changeTabHot(
          this.currentIndex
        );
        this.currentIndex = "";
        this.selectGroupGoodsType = "";
        console.log("this.currentProp.hotList",this.currentProp.hotList[0].groupGoods);
      }
    },
    saveHotGoods(row) {
      // console.log("row")
      // console.log(row)
      // console.log('this.selectGroupGoodsType')
      // console.log(this.selectGroupGoodsType)
      // console.log("this.currentPro")
      // console.log(this.currentProp)
      this.hotVisible = false;
      if (!this.selectGroupGoodsType) {
        if (!this.currentIndex && this.currentIndex !== 0) {
          this.currentProp.groupGoods = row;
        } else {
          this.currentProp[this.currentParams][this.currentIndex].groupGoods =
            row;
          this.currentIndex = "";
          this.currentParams = "";
        }
      } else if (this.selectGroupGoodsType === "hot") {
        console.log("rowrowrowrow");
        console.log(row);
        this.currentProp.hotList[this.currentIndex].groupGoods = row;
        this.$refs.singleComponent[this.activePreviewIndex].changeTabHot(
          this.currentIndex
        );
        this.currentIndex = "";
        this.selectGroupGoodsType = "";
      }
    },
    saveBrand(row) {
      this.brandVisible = false;
      if (this.currentLinkIndex !== -1) {
        this.currentProp[this.currentLinkPropName][
          this.currentLinkIndex
        ].brandInfo = row;
      } else {
        this.currentProp.brandInfo = row;
      }
      this.brandVisible = false;
    },
    saveActivityCenter(row) {
      this.selectActivityVisible = false;
      if (this.currentLinkIndex !== -1) {
        this.currentProp[this.currentLinkPropName][
          this.currentLinkIndex
        ].activityInfo = row;
      } else {
        this.currentProp.activityInfo = row;
      }
    },
    // async queryGroupGoods(groupId) {
    //   const { storeCode } = getLoginUser();
    //   const { result } =  await this.$store.dispatch('queryGroupGoods', {
    // 			pageSize: 99999,
    // 			pageNo: 1,
    //       storeCode,
    // 			groupId,
    //   })
    //   const { records } = result
    //   this.$refs.singleComponent[this.activePreviewIndex].goodsList = records
    // },
    selectGroup(e, i, param) {
      if (e === "groupGoods") {
        this.groupGoodsVisible = true;
        if (i || i === 0) {
          this.currentIndex = i;
          this.currentParams = param;
        }
      }
    },
    handleCloseTabsGroup(i) {
      this.currentProp.tabList[i].groupGoods = {};
      this.$refs.singleComponent[this.activePreviewIndex].goodsList = [];
    },
    handleCloseTabsGroup2(i){
      this.currentProp.hotList[i].groupGoods = {};
    },
    handleCloseHotGroup(i, goodsIndex) {
      this.currentProp.hotList[i].groupGoods.splice(goodsIndex, 1);
      // this.$refs.singleComponent[this.activePreviewIndex].goodsList = [];
    },
    handleCloseTabBarGroup(i) {
      this.tabBarList[i].groupGoods = {};
    },
    handleCloseHotBarGroup(i) {
      this.hotBarList[i].groupGoods = {};
    },
    selectTabBarGroup(e, i) {
      console.log("tabBarList");
      if (e === "groupGoods") {
        this.groupGoodsVisible = true;
        this.selectGroupGoodsType = "tabBarList";
        this.currentIndex = i;
      }
    },
    cancleUpload() {
      this.hmUploadVisible = false;
      this.isUploadVideo = false;
    },
    hmUploadSuccess(url) {
      this.isUploadVideo = false;
      switch (this.uploadType) {
        case "imageAd":
          if (this.currentProp.type !== "3" && this.currentProp.type !== "5") {
            this.currentProp.imgList[this.currentImageAd].src = url;
          } else {
            this.currentProp[this.imgAdSelectionUpLoadType][
              this.currentImageAd
            ].src = url;
          }
          break;
        case "imageAdBg":
          this.currentProp.imgList[this.currentImageAd].bgsrc = url;
          break;    
        case "cube":
          this.currentProp.cubeList[this.currentImageAd].src = url;
          break;
        case "coupon":
          this.currentProp.bg = url;
          break;
        case "hotZoneImage":
          this.currentProp.image = url;
          break;
        case "video":
          this.currentProp.src = url;
          break;
        case "topBgImg":
          this.pageConfig.topBgImg = url;
          break;
        case "pageConfigBg":
          this.pageConfig.bg = url;
          break;
        case "hotImg":
          // this.currentProp.hotImg = url;
          this.currentProp.hotImg[this.currentImageAd].src = url;
          break;
        default:
          break;
      }
      this.hmUploadVisible = false;
      this.$forceUpdate();
    },
    setLink(row) {
      if (this.currentLinkIndex !== -1) {
        this.currentProp[this.currentLinkPropName][
          this.currentLinkIndex
        ].goodsInfo = row;
        this.currentProp[this.currentLinkPropName][
          this.currentLinkIndex
        ].hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      } else {
        this.currentProp.goodsInfo = row;
        this.currentProp.hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      }
      this.dialogVisible = false;
      this.isRadio = false;
    },
    handleClose(v) {
      v.goodsInfo = {};
      v.couponList = [];
      v.appid = "";
      v.profile = "";
      v.activity = "";
      v.roomId= "",
      v.liveList= [],
      v.brandInfo = {};
      v.activityInfo = {};
      v.hrefAddress = "";
      v.pageType = "";
    },
    openGoodsSelect(v, i, propName) {
      if (v.pageType === "goods") {
        this.dialogVisible = true;
        this.isRadio = true;
        this.currentLinkIndex = i;
        this.currentLinkPropName = propName;
      }
      if (v.pageType === "brand") {
        this.brandVisible = true;
        this.currentLinkIndex = i;
        this.currentLinkPropName = propName;
      }
      if (v.pageType === "coupon") {
        this.currentLinkIndex = i;
        this.currentLinkPropName = propName;
      }
      if (v.pageType === "live") {
        this.selectLiveVisibleRadio = true;
        this.currentLinkIndex = i;
        this.currentLinkPropName = propName;
      }
      if (v.pageType === "activityCenter") {
        this.selectActivityVisible = true;
        this.currentLinkIndex = i;
        this.currentLinkPropName = propName;
      }
      v.groupGoods = {};
      v.goodsInfo = {};
      v.couponList = [];
      v.hrefAddress = "";
      v.appid = "";
      v.brandInfo = {};
      v.profile = "";
      v.activity = "";
      v.roomId = "";
      v.liveList = [];
      v.activityInfo = {};
    },
    openGoodsSelectSingle() {
      if (this.currentProp.pageType === "goods") {
        this.dialogVisible = true;
        this.isRadio = true;
        // 为-1表示设置单个
        this.currentLinkIndex = -1;
      }
      if (this.currentProp.pageType === "brand") {
        this.brandVisible = true;
        // 为-1表示设置单个
        this.currentLinkIndex = -1;
      }
      if (this.currentProp.pageType === "live") {
        this.selectLiveVisibleRadio = true;
        this.currentLinkIndex = -1;
      }
      if (this.currentProp.pageType === "activityCenter") {
        this.selectActivityVisible = true;
        this.currentLinkIndex = -1;
      }
      this.currentProp.goodsInfo = {};
      this.currentProp.brandInfo = {};
      this.currentProp.groupGoods = {};
      this.currentProp.hrefAddress = "";
      this.currentProp.appid = "";
      this.currentProp.profile = "";
      this.currentProp.activity = "";
      this.currentProp.roomId = "";
      this.currentProp.liveList = [];
      this.currentProp.activityInfo = {};
    },
    handleCloseSingle() {
      this.currentProp.brandInfo = {};
      this.currentProp.goodsInfo = {};
      this.currentProp.hrefAddress = "";
      this.currentProp.pageType = "";
      this.currentProp.appid = "";
      this.currentProp.profile = "";
      this.currentProp.activity = "";
      this.currentProp.roomId = "";
      this.currentProp.liveList = [];
      this.currentProp.activityInfo = {};
    },
    addGoods() {
      this.dialogVisible = true;
      this.isRadio = false;
    },
    addDailyDeals() {
      this.dailyDealsVisible = true;
      this.isRadioDailyDeals = false;
    },
    addDailyNews(type) {
      this.dailyNewsVisible = true;
      this.isRadioDailyNews = false;
      this.addDailyNewsType = type;
    },
    saveGoods(data) {
      this.dialogVisible = false;
      this.currentProp.goodsList = this.currentProp.goodsList.filter(
        (v) => !v.isMock
      );
      this.currentProp.goodsList.push(...data);
    },
    saveDailyDeals(data) {
      this.dailyDealsVisible = false;
      this.currentProp.goodsList = this.currentProp.goodsList.filter(
        (v) => !v.isMock
      );
      this.currentProp.goodsList.push(...data);
    },
    saveDailyNews(data) {
      this.dailyNewsVisible = false;
      if(this.addDailyNewsType==='dailyNews'){
        this.currentProp.goodsList = this.currentProp.goodsList.filter(
          (v) => !v.isMock
        );
        this.currentProp.goodsList.push(...data);
      }else if(this.addDailyNewsType==='composite'){
        this.currentProp.goodsList3 = this.currentProp.goodsList3.filter(
          (v) => !v.isMock
        );
        this.currentProp.goodsList3.push(...data);
      }
      
    },
    setHotword() {
      this.previewComponents[this.activePreviewIndex].prop.hotWordList = [
        this.hotWord,
      ];
    },
    deleteCurrentComponent(i) {
      console.log(99998);
      this.previewComponents.splice(i, 1);
      this.openPageSetting();
    },
    copyCurrentComponent(i) {
      const row = JSON.parse(JSON.stringify(this.previewComponents[i]));
      this.previewComponents.splice(i, 0, row);
    },
    deleteCurrentGoods(i,type) {
      if(type==='composite'){
        this.currentProp.goodsList3.splice(i, 1);
        if (this.currentProp.goodsList3 && !this.currentProp.goodsList3.length) {
          this.currentProp.goodsList3.push({
            spuMainPic:
              "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
            wxshopSpuName: "这里显示商品标题",
            subTitle: "这里显示商品描述，最多显示一行",
            id: 1,
            temp: true,
            isMock: true,
            wxshopPrice: 0,
            markingPrice: 0,
            saleNum: 999,
          });
        }
      }else{
        this.currentProp.goodsList.splice(i, 1);
        if (this.currentProp.goodsList && !this.currentProp.goodsList.length) {
          this.currentProp.goodsList.push({
            spuMainPic:
              "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
            wxshopSpuName: "这里显示商品标题",
            subTitle: "这里显示商品描述，最多显示一行",
            id: 1,
            temp: true,
            isMock: true,
            wxshopPrice: 0,
            markingPrice: 0,
            saleNum: 999,
          });
        }
      }
    },
    addHotWord() {
      let display = "";
      if (this.currentProp.version === "Horizontal") {
        display = "inline-block";
      } else {
        display = "block";
      }
      this.currentProp.hotWordList.push({
        word: "",
        background: "#F0F0F0",
        color: "#2B2B2B",
        display: display,
        src: "",
      });
      console.log("this.currentProp.hotWordList", this.currentProp.hotWordList);
    },
    changeVersion(e) {
      let display = "";
      if (e === "Horizontal") {
        display = "inline-block";
        this.currentProp.versionSrc = "";
      } else {
        display = "block";
      }
      this.currentProp.hotWordList.forEach((v) => {
        v.display = display;
      });
    },
    setPlaceholder() {
      if (this.currentProp.hotWordList && this.currentProp.hotWordList.length) {
        this.currentProp.placeholder = this.currentProp.hotWordList[0].word;
      }
    },
    save() {
      this.previewComponents.forEach((v) => {
        if (v.component === "search") {
          if (v.prop.hotWordList.length) {
            v.prop.placeholder = v.prop.hotWordList[0].word;
          } else {
            v.prop.placeholder = "";
          }
        }
      });
      console.log("this.previewComponents: ", this.previewComponents);
      html2canvas(document.querySelector(".preview-wrapper"), {
        useCORS: true,
        backgroundColor: null,
      }).then((canvas) => {
        const previewImg = canvas.toDataURL("image/png");
        const params = {
          pageType: this.pageType,
          pageTitle: this.title,
          tabBarList: JSON.stringify(this.tabBarList),
          previewComponents: JSON.stringify(this.previewComponents),
          previewImg,
          pageConfig: JSON.stringify(this.pageConfig),
        };
        let actionName = "";
        if (this.pageModel === "default") {
          actionName = "addTemp";
        } else {
          if (this.mode === "edit") {
            Object.assign(params, {
              micropageId: this.layoutId,
            });
            actionName = "editTemp";
          } else {
            actionName = "addCustomTemp";
          }
        }
        this.$store.dispatch(actionName, params).then((res) => {
          if (res.code === "0") {
            this.$message({
              type: "success",
              message: "操作成功！",
            });
            this.$router.back(-1);
          }
        });
      });
    },
    back() {
      this.$confirm("退出将不会保存当前装修，确认退出?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        this.$router.back();
      });
    },
    deleteCardList(i, prop) {
      this.currentProp[prop].splice(i, 1);
      if (prop === "hotWordList") {
        if (
          this.currentProp.hotWordList &&
          this.currentProp.hotWordList.length
        ) {
          this.currentProp.placeholder = this.currentProp.hotWordList[0].word;
        } else {
          this.currentProp.placeholder = "";
        }
      }
    },
    deleteCardListImg(v) {
      v.src = "";
    },
    deleteVersionSrc() {
      this.currentProp.versionSrc = "";
    },
    deleteWatermark(v) {
      v.watermark = "";
    },
    changeIcon(i, type) {
      this.uploadType = "navbar";
      this.uploadWidth = 40;
      this.uploadHeight = 40;
      this.show = true;
      this.currentTab = i;
      this.currentTabIconType = type;
    },
    setConcatImg() {
      this.uploadType = "contact";
      this.uploadWidth = 600;
      this.uploadHeight = 600;
      this.show = true;
    },
    changeImageTextNav(i) {
      this.uploadType = "imageTextNav";
      this.show = true;
      this.uploadWidth = 90;
      this.uploadHeight = 90;
      this.currentImageAd = i;
    },
    changeImageAd(i) {
      // if (this.currentProp.isSwiper) {
      //   this.uploadWidth = 1500;
      //   this.uploadHeight = 720;
      //   this.show = true;
      // } else {
      //   this.hmUploadVisible = true;
      // }
      this.hmUploadVisible = true;
      this.uploadType = "imageAd";
      this.currentImageAd = i;
    },
    changeImageAdBg(i){
      this.hmUploadVisible = true;
      this.uploadType = "imageAdBg";
      this.currentImageAd = i;
    },
    changeHotImageAd() {
      this.hmUploadVisible = true;
      this.uploadType = "hotImg";
      this.currentImageAd = i;
    },
    setTopBgImg() {
      this.hmUploadVisible = true;
      this.uploadType = "topBgImg";
    },
    resetTopBgImg() {
      this.pageConfig.topBgImg =
        "https://imgcdn.hemiao100.com/hemiaoBase/a490012bc5491ffa93dc5a82fb3417e.png";
    },
    changeCube(i) {
      this.uploadType = "cube";
      // this.show = true;
      // this.uploadWidth = 360;
      // this.uploadHeight = 360;
      this.hmUploadVisible = true;
      this.currentImageAd = i;
    },
    changeLogoUrl() {
      this.uploadType = "logoUrl";
      this.show = true;
      this.uploadWidth = 120;
      this.uploadHeight = 120;
    },
    changeLogoUrlSearch(i) {
      this.uploadType = "logoUrlSearch";
      this.show = true;
      this.uploadWidth = 50;
      this.uploadHeight = 50;
      this.currentImageAd = i;
    },
    changeVersionSrc() {
      this.uploadType = "versionSrc";
      this.show = true;
      this.uploadWidth = 690;
      this.uploadHeight = 380;
    },
    changeWatermark(i){
      this.uploadType = "watermark";
      this.show = true;
      this.uploadWidth = 750;
      this.uploadHeight = 750;
      this.currentImageAd = i;
    },
    changetitlePic(){
      this.uploadType = "titlePic";
      this.show = true;
      this.uploadWidth = 600;
      this.uploadHeight = 100;
    },
    changetitlePicDailyDeals(){
      this.uploadType = "titlePicDailyDeals";
      console.log("changetitlePicDailyDeals---this.uploadType:",this.uploadType);
      this.show = true;
      this.uploadWidth = 600;
      this.uploadHeight = 100;
    },
    changetitlePicDailyNews(){
      this.uploadType = "titlePicDailyNews";
      console.log("changetitlePicDailyNews---this.uploadType:",this.uploadType);
      this.show = true;
      this.uploadWidth = 600;
      this.uploadHeight = 100;
    },
    cloneEnd(prop) {
      return JSON.parse(JSON.stringify(prop));
    },
    log(e) {
      if (e.added) {
        this.activePreviewIndex = e.added.newIndex;

        this.currentProp = {};
        this.currentProp = e.added.element.prop;
        this.recoveryData();
      } else if (e.moved) {
        this.activePreviewIndex = e.moved.newIndex;
        this.recoveryData();
      }
      this.showPageSetting = false;
      // if (this.currentProp.zones && !this.currentProp.zones.length) {
      //   this.$refs.singleComponent[this.activePreviewIndex].zones = [];
      // }
    },
    recoveryData() {},
    openPageSetting() {
      this.currentProp = {};
      this.activePreviewIndex = "";
      this.showPageSetting = true;
    },
    selectPreviewItem(i, prop) {
      console.log(i);
      console.log(prop);
      this.activePreviewIndex = i;
      this.currentProp = {};
      this.currentProp = prop;
      console.log("this.currentProp: ", this.currentProp);
      this.showPageSetting = false;
    },
    cropSuccess() {},
    toggleShow() {
      this.show = !this.show;
    },
    // 添加视频
    addVideoLink() {},
    // 添加底部导航栏
    addTabBarList() {
      this.tabBarList.push({
        hrefName: "自定义",
        open: true,
        hrefAddress: "",
        appid: "",
        profile: "",
        activity: "",
        roomId: "",
        liveList: [],
        activityInfo: {},
        custom: true,
        iconPath: "",
        selectedIconpath: "",
        groupGoods: {},
      });
    },
    // 添加图文导航
    addImageTextNav() {
      this.currentProp.imageTextNavList.push({
        src: "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
        hrefAddress: "",
        title: "导航",
        appid: "",
        profile: "",
        activity: "",
        roomId: "",
        liveList: [],
        activityInfo: {},
        goodsInfo: {},
        groupGoods: {},
      });
    },
    // 添加图片广告
    addImageAd() {
      if (this.currentProp.type === "5") {
        let tempsrc;
        if(this.imgAdSelectionUpLoadType === 'leftImgList'){
          tempsrc = "https://imgcdn.hemiao100.com/hemiaoBase/hmService/banner-left.jpg"
        }else{
          tempsrc = "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png"
        }
        this.currentProp[this.imgAdSelectionUpLoadType].push({
          src: tempsrc,
          hrefAddress: "",
          text: "",
          appid: "",
          profile: "",
          activity: "",
          roomId: "",
          liveList: [],
          activityInfo: {},
          goodsInfo: {},
          groupGoods: {},
        });
      }else if (this.currentProp.type === "3") {
        this.currentProp[this.imgAdSelectionUpLoadType].push({
          src: "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          hrefAddress: "",
          text: "",
          appid: "",
          profile: "",
          activity: "",
          roomId: "",
          liveList: [],
          activityInfo: {},
          goodsInfo: {},
          groupGoods: {},
        });
      } else if(this.currentProp.type === "4") {
        this.currentProp.imgList.push({
          src: "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          bgsrc: "",
          hrefAddress: "",
          text: "",
          appid: "",
          profile: "",
          activity: "",
          roomId: "",
          liveList: [],
          activityInfo: {},
          goodsInfo: {},
          groupGoods: {},
        });
      } else {
        this.currentProp.imgList.push({
          src: "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          hrefAddress: "",
          text: "",
          appid: "",
          profile: "",
          activity: "",
          roomId: "",
          liveList: [],
          activityInfo: {},
          goodsInfo: {},
          groupGoods: {},
        });
      }
      this.$forceUpdate();
    },
    //热销活动添加图片
    addImageAd2() {
      this.currentProp.imgList.push({
        src: "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
        hrefAddress: "",
        text: "",
        appid: "",
        profile: "",
        activity: "",
        roomId: "",
        liveList: [],
        activityInfo: {},
        goodsInfo: {},
        groupGoods: {},
      });
      this.$forceUpdate();
    },
    //热销活动删除图片
    deleteCurrentImageAd2(i) {
      this.currentProp.imgList.splice(i, 1);
    },
    deleteCurrentImageAd(i) {
      this.currentProp.imgList.splice(i, 1);
      this.currentProp[this.imgAdSelectionUpLoadType].splice(i, 1);
    },
    calcCubeList(val) {
      let length = this.currentProp.cubeList
        ? this.currentProp.cubeList.length
        : 0;
      let list = JSON.parse(JSON.stringify(this.currentProp.cubeList));
      if (val < length) {
        list = list.slice(0, val);
      } else if (val > length) {
        for (let i = 0; i < val - length; i++) {
          list.push({
            src: "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
            url: "",
            appid: "",
            profile: "",
            activity: "",
            roomId: "",
            liveList: [],
            activityInfo: {},
            hrefAddress: "",
            goodsInfo: {},
            groupGoods: {},
          });
        }
      }
      this.currentProp.cubeList = list;
    },
    deleteCurrentCoupon(i, index) {
      this.currentProp.zones[i].couponList.splice(index, 1);
      this.$forceUpdate();
    },
    deleteCurrentImageTextNav(i) {
      this.currentProp.imageTextNavList.splice(i, 1);
    },
    cropUploadSuccess(jsonData) {
      const url = jsonData.result;
      switch (this.uploadType) {
        case "navbar":
          this.tabBarList[this.currentTab][this.currentTabIconType] = url;
          break;
        case "contact":
          this.currentProp.url = url;
          break;
        case "imageAd":
          this.currentProp.imgList[this.currentImageAd].src = url;
          break;
        case "imageTextNav":
          this.currentProp.imageTextNavList[this.currentImageAd].src = url;
          break;
        case "cube":
          this.currentProp.cubeList[this.currentImageAd].src = url;
          break;
        case "logoUrl":
          this.currentProp.logoUrl = url;
          break;
        case "logoUrlSearch":
          this.currentProp.hotWordList[this.currentImageAd].src = url;
          break;
        case "versionSrc":
          this.currentProp.versionSrc = url;
          break;
        case "titlePic":
          this.currentProp.titlePic = url;
          break;
        case "titlePicDailyDeals":
          this.currentProp.titlePicDailyDeals = url;
          break;
        case "titlePicDailyNews":
          this.currentProp.titlePicDailyNews = url; 
          break;
        case "watermark":
          this.currentProp.hotList[this.currentImageAd].watermark = url;
          break;
        default:
          break;
      }
    },
    deleteCurrentTabbar(i) {
      this.tabBarList.splice(i, i);
    },
    dailyDealsList2(data) {
      console.log("dailyDealsList父方法:", data);
      this.dailyDealsList = data;
    },
    dailyNewsList2(data) {
      console.log("dailyDealsList父方法:", data);
      this.dailyNewsList = data;
    },
    autoAddGoods() {
      console.log("autoAddGoods");
      console.log("this.dailyDealsList", this.dailyDealsList);
      this.currentProp.goodsList = [];
      this.currentProp.goodsList.push(...this.dailyDealsList);
    },
    autoAddGoodsNews(type) {
      console.log("type:",type);
      console.log("autoAddGoodsNews");
      console.log("this.dailyNewsList", this.dailyNewsList);
      if(type==='composite'){
        this.currentProp.goodsList3 = [];
        this.currentProp.goodsList3.push(...this.dailyNewsList);
      }else{
        this.currentProp.goodsList = [];
        this.currentProp.goodsList.push(...this.dailyNewsList);
      }
    },
    dailyDealsRadioGroup() {
      console.log("this.value");
      console.log(this.currentProp.goodShowType2);
      if (this.currentProp.goodShowType2 === "auto") {
        this.autoAddGoods();
      }
    },
    dailyNewsRadioGroup(type) {
      console.log("this.value",this.currentProp.goodShowType2);
      console.log("type:",type);
      if(type==='composite'){
        if (this.currentProp.goodShowType3 === "auto") {
          this.autoAddGoodsNews(type);
        }
      }else{
        if (this.currentProp.goodShowType2 === "auto") {
          this.autoAddGoodsNews();
        }
      }
    },
    dailydealsShowTitle(){
      this.currentProp.showTitle = !this.currentProp.showTitle;
    },
    dailydealsShowTitle2(){
      this.currentProp.showTitlePic = !this.currentProp.showTitlePic;
    },
    changeDailydealsShowTitle(){
      this.currentProp.showTitleDailyDeals = !this.currentProp.showTitleDailyDeals;
    },
    changeDailydealsShowTitle2(){
      this.currentProp.showTitlePicDailyDeals = !this.currentProp.showTitlePicDailyDeals;
    },
    changeDailyNewsShowTitle(){
      this.currentProp.showTitleDailyNews = !this.currentProp.showTitleDailyNews;
    },
    changeDailyNewsShowTitle2(){
      this.currentProp.showTitlePicDailyNews = !this.currentProp.showTitlePicDailyNews;
    },
    deleteTitlePic(){
      console.log("this.currentProp.titlePic1:",this.currentProp.titlePic);
      this.currentProp.titlePic = "";
      this.currentProp = JSON.parse(JSON.stringify(this.currentProp));
      console.log("this.currentProp.titlePic2:",this.currentProp.titlePic);
    },
    deleteTitlePicDailyDeals(){
      this.currentProp.titlePicDailyDeals = "https://imgcdn.hemiao100.com/hemiaoBase/composite_pic05.png";
    },
    deleteTitlePicDailyNews(){
      this.currentProp.titlePicDailyNews = "https://imgcdn.hemiao100.com/hemiaoBase/composite_pic06.png";
    },
    
    cropUploadFail() {},
    filterGt0OrFixed(prop, i) {
      this.currentProp.listLimit = this.currentProp.listLimit.replace(/^(0+)/, ""); //过滤0开头
      this.currentProp.listLimit = this.currentProp.listLimit.replace(/[^\d]/g, ""); //仅保留数字
      this.currentProp.listLimit = this.currentProp.listLimit.replace("$#*.", "");
    },
  },
};
</script>
<style lang="scss">
.temp-container {
  .ql-editor {
    padding: 0;
  }
}
.image-ad-selection-upload {
  margin-bottom: 20px;
  .context {
    position: relative;
    height: 155px;
    width: 155px;
    border: 1px solid #ddd;
    text-align: center;
    background: #fafafa;
    &.context2{
      height: 248px;
    }
    &.context3{
      height: 116px;      
    }
    &.active {
      border: 1px solid #e50065;
      background: #fdf1f6;
    }
    .el-radio {
      margin: 0;
    }
    .dot {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      &.active {
        .point {
          background: #ffd4e7;
          &.first {
            background: #e50065;
          }
        }
      }
      .point {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #ddd;
        margin-right: 5px;
      }
    }
  }  
}
</style>
<style scoped lang="scss">
.icon-wrapper {
  overflow: hidden;
}
.temp-container {
  .component-list {
    background: #fff;
    padding: 20px;
    width: 219px;
    box-sizing: border-box;
    .title {
      color: #ccc;
      font-size: 16px;
      margin-bottom: 31px;
    }
    .list-group {
      box-sizing: border-box;
    }
    .list-group-item {
      cursor: move;
      margin-bottom: 28px;
      width: 50%;
      text-align: center;
      padding: 10px;
      box-sizing: border-box;
      &:hover {
        transition: all 0.2s linear;
        background-color: #fddfeb !important;
        border-radius: 2px;
        color: rgb(226, 0, 93);
        .label {
          color: rgb(226, 0, 93);
        }
      }
      .hmicon {
        font-size: 24px;
      }
      .label {
        margin-top: 16px;
        font-size: 14px;
        color: #666;
      }
    }
  }
  .preview-container {
    position: absolute;
    top: 220px;
    left: 219px;
    right: 360px;
    bottom: 0;
    user-select: none;
  }
  .preview-wrapper {
    position: relative;
    box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);
    width: 375px;
    height: 667px;
    margin: 0 auto;
    .preview-head {
      height: 64px;
      width: 375px;
      margin: 0 auto;
      position: relative;
      background-size: contain;
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url("https://imgcdn.hemiao100.com/hemiaoBase/9673fc3dbf6810f0bb4d9e15ea5af07.png")
          0/ 100% 100%;
        z-index: 100;
      }
      .preview-title {
        width: 180px;
        margin: 0 auto;
        height: 34px;
        line-height: 26px;
        text-align: center;
        padding-top: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .preview-body {
      position: relative;
      width: 375px;
      background-size: 100% 100%;
      .preview-list-group {
        height: 603px;
        .preview-list-group-item {
          position: relative;
          box-sizing: border-box;
          cursor: move;
          border: 2px solid transparent;
          min-height: 20px;
          .widget {
            position: absolute;
            top: 0;
            right: -85px;
            width: auto;
            cursor: pointer;
            z-index: 9;
            .widget-label {
              display: inline-block;
              background-color: #fff;
              width: 80px;
              height: 24px;
              text-align: center;
              line-height: 24px;
              font-size: 12px;
              pointer-events: none;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            }
            .widget-icon {
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
              width: 40px;
              height: 28px;
              text-align: center;
              font-size: 16px;
              line-height: 28px;
              background: #fff;
              color: #e71370;
              display: none;
            }
            &::before {
              content: "";
              width: 0;
              height: 0;
              border-width: 5px;
              border-style: solid;
              border-color: transparent #fff transparent transparent;
              position: absolute;
              bottom: 7px;
              left: -10px;
            }
          }
          &:hover {
            .widget-icon {
              display: block;
              cursor: pointer;
            }
            .widget-label {
              display: none;
              cursor: pointer;
            }
          }
          *:not(.widget-icon) {
            cursor: move !important;
          }
          video {
            min-height: 140px;
            width: 100%;
            display: block;
          }
          &:last-child {
            margin-bottom: 50px;
          }
          &.active,
          &.active:hover {
            box-sizing: border-box;
            border: 2px solid #ea5798;
            cursor: move;
          }
          &:hover {
            box-sizing: border-box;
            border: 2px dashed #ea5798;
            cursor: move;
          }
        }

        .contact-us-item {
          position: absolute;
          bottom: 23px;
          width: 100%;
          z-index: 11;
          left: 0;
        }
        .list-group-item {
          transition: all 0.2s linear;
          background-color: #fddfeb !important;
          border-radius: 2px;
          color: #e2005d;
          text-align: center;
          .label {
            margin-top: 10px;
          }
        }
      }
      .preview-height-tag {
        position: absolute;
        left: -130px;
        bottom: 0;
        width: 130px;
        display: -ms-flexbox;
        display: flex;
        color: #a2a2a2;
        border-bottom: 1px solid #dedede;
        .preview-height-tag-text {
          padding-top: 4px;
          font-size: 12px;
        }
      }
    }
  }

  .options-container {
    width: 360px;
    position: absolute;
    top: 56px;
    box-sizing: border-box;
    padding-bottom: 100px;
    right: 0;
    overflow-x: hidden;
    overflow-y: auto;
    bottom: 0;
    z-index: 999;
    background: #fff;
    .p20 {
      padding: 20px;
    }
    .have-bg-wrapper {
      padding: 0 20px 20px;
      background: #fafafa;
    }
    .title {
      color: #2b2b2b;
      font-weight: 500;
      font-size: 18px;
      margin-bottom: 18px;
    }
    .tips {
      margin: 18px 0 20px;
      font-size: 12px;
      color: #777;
    }
    .sub-title {
      color: #2b2b2b;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .page-header {
      padding: 20px;
      font-size: 14px;
      border-bottom: 1px solid #eee;
    }
    .page-footer {
      font-size: 14px;
      .sub-title {
        background: #fff;
        padding: 20px;
      }
    }
  }

  .border-bottom {
    border-bottom: 1px solid #eee;
  }

  .page-setting {
    .tabbar-setting .tabbar-setting-item .icon-wrapper {
      img {
        width: 21px;
      }
    }

    .icon-wrapper {
      position: relative;
      width: 66px;
      height: 66px;
      line-height: 66px;
      text-align: center;
      border: 1px solid #ddd;
      margin-right: 10px;
      cursor: pointer;
      img {
        width: auto;
      }
      &.no-bg {
        background: #f0f0f0;
      }
      .change-icon {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        color: #fff;
        text-align: center;
        height: 24px;
        line-height: 24px;
        background: rgba(0, 0, 0, 0.8);
      }
    }
  }

  .page-setting-btn {
    position: absolute;
    right: 385px;
    top: 100px;
    width: 98px;
    height: 36px;
    text-align: center;
    font-size: 14px;
    background: #fff;
    border-radius: 2px;
    line-height: 36px;
    cursor: pointer;
    user-select: none;
    &.active {
      background: #e2005d;
      color: #fff;
      .hmicon {
        color: #fff;
      }
    }
    .hmicon {
      margin-right: 5px;
    }
  }
  .temp-header {
    height: 56px;
    line-height: 56px;
    background: #e50065;
    color: #fff;
    padding: 0 22px;
    font-size: 16px;
    user-select: none;
    .hmicon {
      color: #fff;
      font-size: 18px;
      margin-right: 10px;
    }
    .btn {
      cursor: pointer;
    }
    .title {
      font-size: 18px;
    }
    .sub-title {
      font-size: 14px;
    }
    .header-list {
      li {
        border-right: 1px solid #fff;
        padding: 0 22px;
      }
      li:last-child {
        padding-right: 0;
        border-right: 0;
      }
    }
  }
  .tabbar-setting {
    background: #fafafa;
    padding: 20px;
    .tabbar-setting-item {
      position: relative;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
      padding: 10px;
      margin-bottom: 10px;
      .delete-tab {
        position: absolute;
        cursor: pointer;
        font-size: 20px;
        right: -12px;
        top: -10px;
        color: #fff;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: #bbb;
        border-radius: 50%;
        z-index: 2;
        opacity: 0;
        transition: all 0.2s linear;
      }
      &:hover {
        .delete-tab {
          opacity: 1;
        }
      }
      .icon-wrapper {
        position: relative;
        width: 66px;
        height: 66px;
        line-height: 66px;
        text-align: center;
        border: 1px solid #ddd;
        margin-right: 10px;
        cursor: pointer;
        img {
          width: auto;
        }
        &.no-bg {
          background: #f0f0f0;
        }
        .change-icon {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          color: #fff;
          text-align: center;
          height: 24px;
          line-height: 24px;
          background: rgba(0, 0, 0, 0.8);
        }
      }
    }
  }
  .card-list {
    .card-list-item {
      position: relative;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
      padding: 10px;
      margin-bottom: 10px;
      &:hover {
        .card-item-delete {
          opacity: 1;
        }
      }
      .card-item-delete {
        position: absolute;
        cursor: pointer;
        font-size: 20px;
        right: -12px;
        top: -10px;
        color: #fff;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: #bbb;
        border-radius: 50%;
        z-index: 2;
        opacity: 0;
        transition: all 0.2s linear;
      }
    }
  }

  .card-item-delete-img {
    position: absolute;
    cursor: pointer;
    font-size: 20px;
    right: 0px;
    top: 0px;
    color: #fff;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background: #bbb;
    border-radius: 50%;
    z-index: 2;
    opacity: 1;
    transition: all 0.2s linear;
  }

  .component-setting {
    font-size: 14px;
    .have-bg-wrapper {
      padding: 20px;
      background: #fafafa;
    }

    .title-text-setting {
      .other-setting {
        padding: 20px;
        border-bottom: 1px solid #eee;
        li:last-child {
          margin-bottom: 0;
        }
      }
    }

    .shape {
      background: #fff;
      padding: 3px;
      width: 66px;
      height: 18px;
      box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
      .content {
        background: #ffeaf3;
        height: 100%;
        width: 100%;
      }
      &.radius {
        .content {
          border-radius: 30px;
        }
      }
      &.active {
        border: 1px solid #e50065;
      }
      &.blank.active {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      }
      &.line.active {
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
      }

      &.blank,
      &.line {
        width: 48px;
        height: 22px;
        font-size: 14px;
        text-align: center;
        box-shadow: none;
        &.active {
          background: #ffeaf3;
        }
        .el-radio {
          margin-right: 0;
        }
      }
    }

    .cube-setting {
      .shape {
        height: 50px;
        .column {
          background: #ffd4e7;
          border: 1px dotted #ffdfed;
          margin: 0 2px;
          height: 100%;
        }
      }
    }

    .goods-setting,
    .search-setting {
      .icon-wrapper {
        position: relative;
        width: 66px;
        height: 66px;
        line-height: 66px;
        text-align: center;
        border: 1px solid #ddd;
        margin-right: 10px;
        cursor: pointer;
        .change-icon {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          color: #fff;
          text-align: center;
          height: 24px;
          line-height: 24px;
          background: rgba(0, 0, 0, 0.8);
        }
      }
    }

    .search-setting {
      .version {
        width: 82px;
        height: 63px;
        .content {
          width: 100%;
          height: 100%;
        }
      }
      .style1 {
        .content {
          background-image: url("https://imgcdn.hemiao100.com/decoration/version_style1.png");
          background-size: 100% 100%;
        }
      }
      .style2 {
        .content {
          background-image: url("https://imgcdn.hemiao100.com/decoration/version_style2.png");
          background-size: 100% 100%;
        }
      }
    }

    .image-ad-setting {
      .tabbar-setting {
        .tabbar-setting-item {
          cursor: move;
        }
      }
      .tabbar-setting {
        padding: 0;
      }
      .icon-wrapper {
        img {
          width: 100%;
        }
      }
      .shape.no-swiper,
      .shape.double-swiper,
      .shape.swiper {
        height: 44px;
      }
      .double-swiper2{
        height: 44px;
      }
      .double-swiper3{
        height: 22px;
        padding: 0;
      }
      .shape {
        &.swiper {
          position: relative;
          &::before {
            content: "\B7\B7\B7";
            position: absolute;
            left: 50%;
            top: 25%;
            -webkit-transform: translate(-50%);
            transform: translate(-50%);
            color: red;
            font-size: 26px;
          }
        }
        &.double-swiper {
          .content {
            position: relative;
            width: 48%;
            &::before {
              content: "\B7\B7\B7";
              position: absolute;
              left: 50%;
              top: 25%;
              -webkit-transform: translate(-50%);
              transform: translate(-50%);
              color: red;
              font-size: 26px;
            }
          }
        }
        &.double-swiper2,&.double-swiper3 {
          .content {
            position: relative;
            width: 100%;
            &::before {
              content: "\B7\B7\B7";
              position: absolute;
              left: 50%;
              top: 25%;
              -webkit-transform: translate(-50%);
              transform: translate(-50%);
              color: red;
              font-size: 26px;
            }
          }
        }
        &.double-swiper3{
          .content {
            &::before {
              top: 0;
            }
          }
        }
      }
    }
    .other-setting {
      li {
        margin-bottom: 20px;
      }
    }

    .coupon-setting {
      .item-setting {
        padding: 0 20px 20px;
        .shape {
          height: 28px;
          .content {
            background-color: transparent;
          }
        }
        .style1 {
          .content {
            background-image: url("https://imgcdn.hemiao100.com/decoration/ps51c6e0a88dcb8ee9-c4c9-44bc-9343-b8754a1b26ad.png");
            background-size: 100% 100%;
          }
        }
        .style2 {
          .content {
            background-image: url("https://imgcdn.hemiao100.com/decoration/ps9addd5b82b7a6c1d-c4f4-419f-be3c-2dc65a83e0f6.png");
            background-size: 100% 100%;
          }
        }
        .style3 {
          .content {
            background-image: url("https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-18/1616036787315-d5de7760-567e-4d23.png");
            background-size: 100% 100%;
          }
        }
      }

      .settings {
        padding: 20px;

        .label {
          width: 80px;
        }

        .settings-item {
          margin-bottom: 20px;
        }
      }

      .icon-wrapper {
        position: relative;
        width: 66px;
        height: 66px;
        line-height: 66px;
        text-align: center;
        border: 1px solid #ddd;
        margin-right: 10px;
        cursor: pointer;
        img {
          width: auto;
        }
        &.no-bg {
          background: #f0f0f0;
        }
        .change-icon {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          color: #fff;
          text-align: center;
          height: 24px;
          line-height: 24px;
          background: rgba(0, 0, 0, 0.8);
        }
      }
    }

    .groupon-setting {
      &.live-setting {
        .item-setting {
          &.top {
            .shape {
              height: 63px;
              width: 78px;
              .content {
                background-color: transparent;
              }
            }
            .style1 {
              .content {
                background-image: url("https://imgcdn.hemiao100.com/decoration/ps28a3f76a87c4ea71-aa49-49c8-91fe-271b6aa55fe8.png");
                background-size: 100% 100%;
              }
            }
            .style2 {
              .content {
                background-image: url("https://imgcdn.hemiao100.com/decoration/ps1c2f72bb04859ac6-523f-4cc2-8868-7f509b9f551f.png");
                background-size: 100% 100%;
              }
            }
          }
        }
      }
      .item-setting {
        padding: 0 20px 20px;
        &.top {
          .shape {
            height: 63px;
            width: 78px;
            .content {
              background-color: transparent;
            }
          }
          .style1 {
            .content {
              background-image: url("https://imgcdn.hemiao100.com/decoration/ps4602ec0679358453-15b6-43eb-b277-28db9ef60203.png");
              background-size: 100% 100%;
            }
          }
          .style2 {
            .content {
              background-image: url("https://imgcdn.hemiao100.com/decoration/ps51c9331763e24077-91a4-4d34-ae73-93c4088413a4.png");
              background-size: 100% 100%;
            }
          }
          .style3 {
            .content {
              background-image: url("https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-18/1616037303596-4ebf225b-f53a-4986.png");
              background-size: 100% 100%;
            }
          }
        }
      }

      .settings {
        padding: 20px;

        .label {
          width: 80px;
        }

        .settings-item {
          margin-bottom: 20px;
        }
      }

      .icon-wrapper {
        position: relative;
        width: 66px;
        height: 66px;
        line-height: 66px;
        text-align: center;
        border: 1px solid #ddd;
        margin-right: 10px;
        cursor: pointer;
        img {
          width: auto;
        }
        &.no-bg {
          background: #f0f0f0;
        }
        .change-icon {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          color: #fff;
          text-align: center;
          height: 24px;
          line-height: 24px;
          background: rgba(0, 0, 0, 0.8);
        }
      }
    }
    .coupon-list {
      background: #fafafa;
      .coupon-item {
        // overflow: hidden;
        margin-bottom: 10px;
        position: relative;
        .delete-tab {
          position: absolute;
          cursor: pointer;
          font-size: 20px;
          right: -12px;
          top: -10px;
          color: #fff;
          width: 20px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          background: #bbb;
          border-radius: 50%;
          z-index: 2;
          opacity: 0;
          transition: all 0.2s linear;
        }
        &:hover {
          .delete-tab {
            opacity: 1;
          }
        }
      }

      $baseWidth: 10px;

      .price-wrapper {
        position: relative;
        color: #fff;
        width: 95px;
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
        &::before {
          position: absolute;
          top: -($baseWidth / 2);
          right: -($baseWidth / 2);
          content: "";
          width: $baseWidth;
          height: $baseWidth;
          border-radius: 50%;
          background: #f4f4f4;
        }
        &::after {
          position: absolute;
          bottom: -($baseWidth / 2);
          right: -($baseWidth / 2);
          content: "";
          width: $baseWidth;
          height: $baseWidth;
          border-radius: 50%;
          background: #f4f4f4;
        }
      }
      .price {
        font-size: 24px;
        color: #fff;
        &::before {
          content: "￥";
          font-size: 10px;
        }
      }
      .discount {
        font-size: 24px;
        color: #fff;
        &::before {
          content: "折";
          font-size: 10px;
        }
      }
      .info {
        background: #fff;
        padding: 15px;
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
      }
      .valid-time {
        font-size: 11px;
        color: #606060;
      }
      .btn {
        width: 80px;
        height: 24px;
        margin-top: 8px;
        line-height: 24px;
        background: rgba(247, 43, 43, 1);
        border-radius: 12px;
        color: #fff;
        font-size: 13px;
        border: none;
      }
    }
  }
}

.setting-list {
  .title {
    margin-right: 20px;
  }
}

.link-wrapper {
  padding: 0 20px 20px;
}

.warning {
  color: #e50163;
}

.hotzone-img-wrapper {
  position: relative;
  width: 100px;
  margin-bottom: 20px;
  padding-top: 20px;
  &.join-bg {
    img {
      min-height: auto;
    }
  }
  img {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    width: 100%;
  }
  .tip {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    padding: 10px 0;
    text-align: center;
  }
}

.top-bg-wrapper {
  position: relative;
  margin: 0 auto;
  width: 234px;
  padding-top: 20px;
  border: 1px dotted #ddd;

  &:hover {
    .contorl-wrapper {
      display: block;
    }
  }

  .contorl-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    padding: 10px 0;
    text-align: center;
  }

  &.join-bg {
    img {
      min-height: auto;
    }
  }
  img {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    width: 100%;
    min-height: 150px;
  }
}

.head-ipt-wrapper {
  border-radius: 30px;
  padding-top: 28px;
  padding-left: 20px;
  input {
    border-radius: 30px;
    border: 1px solid #efefef;
    padding-left: 20px;
    height: 28px;
  }
  ::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #999;
    font-size: 12px;
  }
}
.dailydeals-setting {
  .padding20 {
    padding: 0 20px;
  }
  .showhide {
    margin: 0 10px;
  }
}
.ClickSearch {
  border: solid 1px #000000;
  padding: 5px;
  border-radius: 10px;
  color: auto;
  cursor: pointer;
}
.isClickSearch {
  border: solid 1px #e2005d;
  padding: 5px;
  border-radius: 10px;
  color: #e2005d;
  cursor: pointer;
}
.colorRed {
  color: #e2005d;
  height: 28px;
  line-height: 28px;
}
.change-icon{
  .red{
    color: #e2005d;
  }
  .white{ 
    color:#ffffff;
  }
}
</style>
